import { a as p } from "./applier-hnplq_H0.js";
import { d as Di, j as Ai, c as ki, h as Ii, y as Pi, q as Mi, m as Oi, w as Ri, x as Hi, n as Gi, o as Vi, v as Li, l as Wi, k as qi, f as Ki, g as Yi, i as Ni, p as Ui, r as Ji, e as $i, b as ji, s as Qi, t as Zi, u as _i } from "./applier-hnplq_H0.js";
const b = {
  id: "semantic-tokens",
  name: "Semantic Token Usage",
  description: "Ensures CSS uses semantic tokens (--ds-*) instead of raw color values",
  severity: "warning",
  validate: (e) => {
    const i = [];
    e.computedStyle || getComputedStyle(e.element);
    const t = [
      "color",
      "backgroundColor",
      "borderColor",
      "borderTopColor",
      "borderRightColor",
      "borderBottomColor",
      "borderLeftColor",
      "outlineColor"
    ], s = e.element.getAttribute("style") || "";
    return t.forEach((a) => {
      const r = new RegExp(`${a.replace(/([A-Z])/g, "-$1").toLowerCase()}:\\s*(#[0-9a-fA-F]{3,8})`, "i"), o = new RegExp(`${a.replace(/([A-Z])/g, "-$1").toLowerCase()}:\\s*(rgba?\\([^)]+\\))`, "i"), n = s.match(r), l = s.match(o);
      n && i.push({
        ruleId: "semantic-tokens",
        severity: "warning",
        message: `Raw hex color "${n[1]}" found for ${a}`,
        element: e.element,
        suggestion: `Use semantic token: var(--ds-${a.includes("background") ? "surface" : "foreground"})`
      }), l && i.push({
        ruleId: "semantic-tokens",
        severity: "warning",
        message: `Raw RGB color "${l[1]}" found for ${a}`,
        element: e.element,
        suggestion: `Use semantic token: var(--ds-${a.includes("background") ? "surface" : "foreground"})`
      });
    }), i;
  }
}, S = {
  id: "typography-hierarchy",
  name: "Typography Variant Hierarchy",
  description: "Ensures typography variants follow proper hierarchy and nesting",
  severity: "error",
  validate: (e) => {
    var l;
    const i = [];
    if (e.componentName !== "Typography") return i;
    const t = (l = e.props) == null ? void 0 : l.variant;
    if (!t) return i;
    const a = {
      display: 0,
      h1: 1,
      h2: 2,
      h3: 3,
      h4: 4,
      h5: 5,
      body: 6,
      "body-lg": 6,
      small: 7,
      caption: 7,
      overline: 7,
      label: 7
    }[t];
    if (a === void 0 || a > 5) return i;
    let r = e.element.parentElement;
    for (; r; ) {
      const d = r.getAttribute("data-typography-level");
      if (d) {
        const c = parseInt(d, 10);
        a <= c && a < 6 && i.push({
          ruleId: "typography-hierarchy",
          severity: "error",
          message: `Heading "${t}" (level ${a}) should not be nested inside parent level ${c}`,
          element: e.element,
          suggestion: `Use a lower-level heading like "h${c + 1}" or "body"`
        });
        break;
      }
      r = r.parentElement;
    }
    const o = document.querySelectorAll("h1, h2, h3, h4, h5, h6, [data-typography-level]");
    let n = 0;
    for (const d of o) {
      if (d === e.element) {
        a > n + 1 && n > 0 && i.push({
          ruleId: "typography-hierarchy",
          severity: "warning",
          message: `Heading level jumped from ${n} to ${a}. Consider using intermediate headings.`,
          element: e.element,
          suggestion: `Add heading level ${n + 1} before this element`
        });
        break;
      }
      const c = d.getAttribute("data-typography-level");
      if (c)
        n = parseInt(c, 10);
      else {
        const m = parseInt(d.tagName.charAt(1), 10);
        isNaN(m) || (n = m);
      }
    }
    return i;
  }
}, v = {
  id: "card-elevation",
  name: "Card Elevation Consistency",
  description: "Ensures card variants use the preset-recommended elevation and styling",
  severity: "warning",
  validate: (e) => {
    var o;
    const i = [];
    if (e.componentName !== "Card") return i;
    const t = (o = e.props) == null ? void 0 : o.variant, s = e.preset;
    t && t !== s.cards.defaultVariant && i.push({
      ruleId: "card-elevation",
      severity: "info",
      message: `Card uses variant "${t}" but preset recommends "${s.cards.defaultVariant}"`,
      element: e.element,
      suggestion: `Consider using variant="${s.cards.defaultVariant}" for visual consistency`,
      metadata: {
        usedVariant: t,
        recommendedVariant: s.cards.defaultVariant
      }
    });
    const r = (e.computedStyle || getComputedStyle(e.element)).borderRadius;
    return s.cards.radius === "none" && r !== "0px" && i.push({
      ruleId: "card-elevation",
      severity: "warning",
      message: 'Card has border-radius but preset specifies "none"',
      element: e.element,
      suggestion: "Remove border-radius to match preset configuration"
    }), i;
  }
}, w = {
  id: "spacing-consistency",
  name: "Spacing Value Consistency",
  description: "Ensures spacing uses density tokens, not arbitrary pixel values",
  severity: "warning",
  validate: (e) => {
    const i = [], t = e.element.getAttribute("style") || "";
    return [
      /padding:\s*\d+px/i,
      /margin:\s*\d+px/i,
      /gap:\s*\d+px/i,
      /padding-(?:top|right|bottom|left):\s*\d+px/i,
      /margin-(?:top|right|bottom|left):\s*\d+px/i
    ].forEach((a) => {
      a.test(t) && i.push({
        ruleId: "spacing-consistency",
        severity: "warning",
        message: "Arbitrary pixel spacing found in inline styles",
        element: e.element,
        suggestion: "Use density tokens: var(--ds-density-padding) or Tailwind spacing classes"
      });
    }), i;
  }
}, B = {
  id: "button-variant",
  name: "Button Variant Consistency",
  description: "Ensures button variants align with preset accent configuration",
  severity: "info",
  validate: (e) => {
    var r, o;
    const i = [];
    if (e.componentName !== "Button") return i;
    const t = (r = e.props) == null ? void 0 : r.variant, a = (o = e.preset.componentDefaults.Button) == null ? void 0 : o.variant;
    return t && a && t !== a && e.element.closest('form, [role="dialog"]') && t !== "primary" && i.push({
      ruleId: "button-variant",
      severity: "info",
      message: `Primary action button uses "${t}" variant`,
      element: e.element,
      suggestion: 'Consider using variant="primary" for primary actions'
    }), i;
  }
}, F = {
  id: "motion-consistency",
  name: "Motion Profile Consistency",
  description: "Ensures animations align with the preset motion profile",
  severity: "info",
  validate: (e) => {
    const i = [], t = e.computedStyle || getComputedStyle(e.element);
    if (e.preset.motion.style === "minimal") {
      const s = t.transitionDuration, a = t.animationDuration, r = (n) => {
        if (n === "0s" || n === "0ms") return 0;
        const l = n.match(/^([\d.]+)(s|ms)$/);
        return l ? l[2] === "s" ? parseFloat(l[1]) * 1e3 : parseFloat(l[1]) : 0;
      }, o = Math.max(
        r(s),
        r(a)
      );
      o > 200 && i.push({
        ruleId: "motion-consistency",
        severity: "info",
        message: `Long animation duration (${o}ms) found but preset uses minimal motion`,
        element: e.element,
        suggestion: "Consider reducing animation duration to ≤100ms for minimal motion profile"
      });
    }
    return i;
  }
}, f = [
  "playfair display",
  "cormorant garamond",
  "cormorant",
  "libre baskerville",
  "merriweather",
  "fraunces",
  "lora",
  "crimson pro",
  "crimson text",
  "bodoni moda",
  "editorial new",
  "georgia",
  "times new roman",
  "serif"
], z = [
  "jetbrains mono",
  "fira code",
  "ibm plex mono",
  "sf mono",
  "menlo",
  "monaco",
  "consolas",
  "monospace"
];
function y(e) {
  const i = e.toLowerCase();
  return f.some((t) => i.includes(t));
}
function h(e) {
  const i = e.toLowerCase();
  return z.some((t) => i.includes(t));
}
const C = {
  id: "editorial-display-typography",
  name: "Editorial Display Typography",
  description: "Ensures display and headline typography uses serif fonts for editorial style",
  severity: "error",
  validate: (e) => {
    var t, s, a, r;
    const i = [];
    if (((t = e.preset.dataAttributes) == null ? void 0 : t.style) !== "editorial") return i;
    if (e.componentName === "KpiCard" || e.element.hasAttribute("data-kpi-metric")) {
      const n = (e.computedStyle || getComputedStyle(e.element)).fontFamily;
      y(n) || i.push({
        ruleId: "editorial-display-typography",
        severity: "error",
        message: "KPI metric should use serif display font for editorial style",
        element: e.element,
        suggestion: `Use the preset's display font: ${((a = (s = e.preset.typography) == null ? void 0 : s.fonts) == null ? void 0 : a.display) || "Playfair Display, serif"}`,
        metadata: {
          currentFont: n,
          expectedType: "serif display"
        }
      });
    }
    if (e.componentName === "Typography") {
      const o = (r = e.props) == null ? void 0 : r.variant;
      if (o === "display" || o === "h1") {
        const l = (e.computedStyle || getComputedStyle(e.element)).fontFamily;
        y(l) || i.push({
          ruleId: "editorial-display-typography",
          severity: "error",
          message: `Typography variant="${o}" MUST use serif font for editorial style`,
          element: e.element,
          suggestion: "Use the preset's display font for high-impact headlines",
          metadata: {
            variant: o,
            currentFont: l
          }
        });
      }
    }
    return i;
  }
}, E = {
  id: "editorial-micro-labels",
  name: "Editorial Micro-Labels",
  description: "Ensures micro-labels use monospace font with uppercase casing",
  severity: "error",
  validate: (e) => {
    var l, d, c;
    const i = [];
    if (((l = e.preset.dataAttributes) == null ? void 0 : l.style) !== "editorial" || !(e.element.hasAttribute("data-micro-label") || e.element.hasAttribute("data-kpi-label") || e.element.classList.contains("micro-label") || e.element.classList.contains("kpi-label"))) return i;
    const s = e.computedStyle || getComputedStyle(e.element), a = s.fontFamily, r = s.textTransform, o = s.letterSpacing;
    h(a) || i.push({
      ruleId: "editorial-micro-labels",
      severity: "error",
      message: "Micro-label MUST use monospace font for editorial style",
      element: e.element,
      suggestion: `Use font-mono or the preset's mono font: ${((c = (d = e.preset.typography) == null ? void 0 : d.fonts) == null ? void 0 : c.mono) || "JetBrains Mono, monospace"}`,
      metadata: {
        currentFont: a
      }
    }), r !== "uppercase" && i.push({
      ruleId: "editorial-micro-labels",
      severity: "error",
      message: "Micro-label MUST use uppercase casing for editorial style",
      element: e.element,
      suggestion: 'Add className="uppercase" or text-transform: uppercase',
      metadata: {
        currentTextTransform: r
      }
    });
    const n = parseFloat(o);
    return !isNaN(n) && n < 1 && i.push({
      ruleId: "editorial-micro-labels",
      severity: "error",
      message: "Micro-label MUST use wide letter-spacing for editorial style",
      element: e.element,
      suggestion: 'Add className="tracking-widest" or letter-spacing: 0.1em',
      metadata: {
        currentLetterSpacing: o
      }
    }), i;
  }
}, x = {
  id: "editorial-kpi-size",
  name: "Editorial KPI Metric Size",
  description: "Ensures KPI metrics use large display sizes (5xl/6xl) for editorial impact",
  severity: "error",
  validate: (e) => {
    var o, n, l;
    const i = [];
    if (((o = e.preset.dataAttributes) == null ? void 0 : o.style) !== "editorial" || !(e.element.hasAttribute("data-kpi-metric") || e.element.classList.contains("kpi-metric") || e.element.classList.contains("metric-value"))) return i;
    const s = e.computedStyle || getComputedStyle(e.element), a = parseFloat(s.fontSize), r = 36;
    return a < r && i.push({
      ruleId: "editorial-kpi-size",
      severity: "error",
      message: `KPI metric font size (${a}px) is too small for editorial style - MUST be at least ${r}px`,
      element: e.element,
      suggestion: `Use text-5xl (48px) or text-6xl (60px) for impactful KPI metrics. Preset recommends: ${((n = e.preset.kpiStyling) == null ? void 0 : n.metricSize) || "5xl"}`,
      metadata: {
        currentSize: `${a}px`,
        recommendedSize: ((l = e.preset.kpiStyling) == null ? void 0 : l.metricSize) || "5xl",
        minSize: `${r}px`
      }
    }), i;
  }
}, T = {
  id: "editorial-spacing-density",
  name: "Editorial Spacing Density",
  description: "Ensures editorial presets use spacious/generous spacing",
  severity: "error",
  validate: (e) => {
    var o;
    const i = [];
    if (((o = e.preset.dataAttributes) == null ? void 0 : o.style) !== "editorial") return i;
    const t = e.element.getAttribute("data-density");
    t && t !== "spacious" && t !== "relaxed" && i.push({
      ruleId: "editorial-spacing-density",
      severity: "error",
      message: `Density "${t}" CONFLICTS with editorial style - MUST use spacious density`,
      element: e.element,
      suggestion: 'Use data-density="spacious" for editorial presets',
      metadata: {
        currentDensity: t,
        recommendedDensity: "spacious"
      }
    });
    const s = e.element.className, a = [
      /\bp-1\b/,
      /\bp-2\b/,
      /\bgap-1\b/,
      /\bgap-2\b/,
      /\bspace-y-1\b/,
      /\bspace-y-2\b/
    ];
    if (e.componentName === "Card" || e.componentName === "Section" || e.element.hasAttribute("data-section")) {
      for (const n of a)
        if (n.test(s)) {
          i.push({
            ruleId: "editorial-spacing-density",
            severity: "error",
            message: "Compact spacing detected on container - editorial style REQUIRES generous whitespace",
            element: e.element,
            suggestion: "Use larger spacing values (p-6, gap-6, etc.) for editorial aesthetic",
            metadata: {
              detectedPattern: n.toString()
            }
          });
          break;
        }
    }
    return i;
  }
}, D = {
  id: "editorial-data-identifiers",
  name: "Editorial Data Identifiers",
  description: "Ensures data identifiers use the editorial pattern [TYPE:ID]",
  severity: "error",
  validate: (e) => {
    var o;
    const i = [];
    if (((o = e.preset.dataAttributes) == null ? void 0 : o.style) !== "editorial" || !(e.element.hasAttribute("data-identifier") || e.element.classList.contains("data-identifier") || e.element.classList.contains("entity-id"))) return i;
    const s = e.computedStyle || getComputedStyle(e.element), a = s.fontFamily, r = parseFloat(s.opacity);
    return h(a) || i.push({
      ruleId: "editorial-data-identifiers",
      severity: "error",
      message: "Data identifier MUST use monospace font for editorial style",
      element: e.element,
      suggestion: "Use font-mono for data identifiers"
    }), r > 0.7 && i.push({
      ruleId: "editorial-data-identifiers",
      severity: "error",
      message: "Data identifier MUST have reduced opacity for editorial style",
      element: e.element,
      suggestion: "Add opacity-50 or similar to de-emphasize data identifiers",
      metadata: {
        currentOpacity: r,
        recommendedOpacity: "0.4-0.5"
      }
    }), i;
  }
}, A = {
  id: "flat-ui-detection",
  name: "Flat UI Detection",
  description: "Detects flat, generic UI patterns that lack editorial sophistication",
  severity: "error",
  validate: (e) => {
    var n, l, d, c, m, u;
    const i = [];
    if (((n = e.preset.dataAttributes) == null ? void 0 : n.style) !== "editorial") return i;
    const s = (e.computedStyle || getComputedStyle(e.element)).fontFamily.toLowerCase(), r = ["system-ui", "ui-sans-serif", "-apple-system", "segoe ui", "arial", "helvetica"].some((g) => s.includes(g)) && !f.some((g) => s.includes(g));
    if ((e.componentName === "Typography" || /^h[1-6]$/i.test(e.element.tagName)) && r) {
      const g = (l = e.props) == null ? void 0 : l.variant;
      (g === "display" || g === "h1" || g === "h2") && i.push({
        ruleId: "flat-ui-detection",
        severity: "error",
        message: "FLAT UI DETECTED: Headline using generic system font - editorial style REQUIRES custom serif typography",
        element: e.element,
        suggestion: `Load and use the preset's display font: ${(c = (d = e.preset.typography) == null ? void 0 : d.fonts) == null ? void 0 : c.display}`,
        metadata: {
          currentFont: s,
          presetDisplayFont: (u = (m = e.preset.typography) == null ? void 0 : m.fonts) == null ? void 0 : u.display
        }
      });
    }
    return i;
  }
}, k = [
  b,
  S,
  v,
  w,
  B,
  F,
  // Editorial typography rules (v2.0)
  C,
  E,
  x,
  T,
  D,
  A
];
function I(e, i) {
  return {
    preset: i,
    element: e,
    componentName: e.getAttribute("data-component") || void 0,
    props: P(e),
    computedStyle: getComputedStyle(e)
  };
}
function P(e) {
  const i = {};
  for (const s of e.attributes)
    if (s.name.startsWith("data-prop-")) {
      const a = s.name.slice(10);
      try {
        i[a] = JSON.parse(s.value);
      } catch {
        i[a] = s.value;
      }
    }
  const t = e.getAttribute("data-variant");
  return t && (i.variant = t), i;
}
function M(e, i, t = {}) {
  const { rules: s = k, includeInfo: a = !1 } = t, r = I(e, i), o = [];
  for (const n of s)
    try {
      const l = n.validate(r);
      o.push(...l);
    } catch (l) {
      console.warn(`Validation rule "${n.id}" threw an error:`, l);
    }
  return o.filter((n) => !(n.severity === "info" && !a));
}
function zi(e, i, t = {}) {
  const s = [], a = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT);
  let r = a.currentNode;
  for (; r && (r instanceof HTMLElement && s.push(...M(r, i, t)), r = a.nextNode(), !!r); )
    ;
  return s;
}
function Ci(e) {
  const i = /* @__PURE__ */ new Map();
  for (const t of e) {
    const s = i.get(t.ruleId) || [];
    s.push(t), i.set(t.ruleId, s);
  }
  return i;
}
function Ei(e) {
  return {
    error: e.filter((i) => i.severity === "error"),
    warning: e.filter((i) => i.severity === "warning"),
    info: e.filter((i) => i.severity === "info")
  };
}
const O = {
  id: "saas-modern-minimal",
  name: "Modern Minimal",
  description: "Editorial-inspired SaaS dashboard with refined serif headlines, generous whitespace, and restrained elegance. Perfect for modern applications that prioritize clarity and typographic sophistication.",
  category: "saas-dashboard",
  tags: ["editorial", "clean", "minimal", "spacious", "modern", "professional", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Editorial New", "Playfair Display", "Georgia", serif',
      heading: '"Neue Montreal", "Inter var", "Inter", system-ui, sans-serif',
      body: '"Neue Montreal", "Inter var", "Inter", system-ui, sans-serif',
      mono: '"JetBrains Mono", "IBM Plex Mono", monospace'
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "tight",
      weight: "medium",
      lineHeight: "1.1"
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "normal",
      lineHeight: "1.0",
      style: "serif"
    },
    body: {
      letterSpacing: "normal",
      weight: "normal",
      lineHeight: "1.6"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.6
    }
  },
  spacing: {
    density: "spacious",
    paddingScale: 1.25,
    gapScale: 1.2,
    sectionSpacing: "generous",
    contentMaxWidth: "1200px",
    readingMaxWidth: "65ch"
  },
  cards: {
    defaultVariant: "elevated",
    radius: "lg",
    showBorder: !0,
    borderStyle: "subtle",
    accentEdge: "none",
    elevation: 1,
    hoverEffect: "lift",
    padding: "lg"
  },
  dataViz: {
    sequential: ["#F5F5F4", "#D6D3D1", "#A8A29E", "#78716C", "#44403C"],
    categorical: [
      "#44403C",
      "#78716C",
      "#0C4A6E",
      "#166534",
      "#92400E",
      "#7C2D12"
    ],
    diverging: {
      negative: "#991B1B",
      neutral: "#78716C",
      positive: "#166534"
    },
    semantic: {
      positive: "#166534",
      negative: "#991B1B",
      neutral: "#78716C",
      warning: "#92400E"
    }
  },
  kpiStyling: {
    metricSize: "5xl",
    metricWeight: "normal",
    metricFont: "display",
    labelSize: "xs",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !1,
    trendIndicator: "pill",
    sparklineStyle: "area",
    cardTreatment: "elevated"
  },
  accents: {
    primary: "220 13% 18%",
    // Near black - restrained
    secondary: "24 10% 50%",
    // Warm gray
    application: {
      buttons: "filled",
      links: "underline",
      focus: "ring",
      selection: "subtle"
    },
    gradients: {
      primaryGradient: "none",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "smooth",
    interactionScale: {
      hover: 1.01,
      press: 0.99
    },
    pageTransitions: !0,
    listAnimation: "fade",
    duration: "normal"
  },
  dataAttributes: {
    mode: "light",
    style: "editorial",
    density: "spacious",
    motion: "smooth"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "md",
      pressable: !1
    },
    Card: {
      variant: "elevated",
      padding: "lg",
      hoverable: !0
    },
    Badge: {
      style: "soft",
      size: "md"
    },
    DataTable: {
      density: "spacious",
      stripedRows: !1,
      showRowBorders: !0
    },
    KpiCard: {
      elevated: !0,
      displayFont: !0
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    },
    Input: {
      variant: "default"
    }
  },
  references: [
    "https://linear.app",
    "https://vercel.com/dashboard",
    "https://stripe.com/atlas"
  ]
}, R = {
  id: "saas-data-dense",
  name: "Data Dense",
  description: "Editorial-inspired data dashboard with newspaper-quality typography. Compact layout optimized for power users while maintaining refined typographic hierarchy and visual sophistication.",
  category: "saas-dashboard",
  tags: ["editorial", "compact", "data", "dense", "power-user", "analytics", "newspaper"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Libre Baskerville", "Crimson Pro", "Georgia", serif',
      heading: '"Source Sans 3", "Source Sans Pro", system-ui, sans-serif',
      body: '"Source Sans 3", "Source Sans Pro", system-ui, sans-serif',
      mono: '"IBM Plex Mono", "JetBrains Mono", monospace'
    },
    scale: {
      displaySize: "4xl",
      h1Size: "2xl",
      h2Size: "xl",
      h3Size: "lg",
      bodySize: "sm",
      smallSize: "xs"
    },
    headings: {
      letterSpacing: "tight",
      weight: "semibold",
      lineHeight: "1.2"
    },
    display: {
      letterSpacing: "-0.01em",
      weight: "bold",
      lineHeight: "1.1",
      style: "serif"
    },
    body: {
      letterSpacing: "normal",
      weight: "normal",
      lineHeight: "1.5"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "semibold",
      casing: "uppercase",
      size: "xxs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xxs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "comfortable",
    paddingScale: 0.9,
    gapScale: 0.85,
    sectionSpacing: "normal",
    contentMaxWidth: "1400px",
    readingMaxWidth: "60ch"
  },
  cards: {
    defaultVariant: "outlined",
    radius: "md",
    showBorder: !0,
    borderStyle: "medium",
    accentEdge: "left",
    elevation: 0,
    hoverEffect: "border",
    padding: "md"
  },
  dataViz: {
    sequential: ["#F5F5F4", "#D6D3D1", "#78716C", "#44403C", "#1C1917"],
    categorical: [
      "#1C1917",
      "#44403C",
      "#0C4A6E",
      "#14532D",
      "#7C2D12",
      "#581C87"
    ],
    diverging: {
      negative: "#7F1D1D",
      neutral: "#57534E",
      positive: "#14532D"
    },
    semantic: {
      positive: "#14532D",
      negative: "#7F1D1D",
      neutral: "#57534E",
      warning: "#78350F"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "bold",
    metricFont: "display",
    labelSize: "xxs",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !0,
    trendIndicator: "arrow",
    sparklineStyle: "line",
    cardTreatment: "bordered"
  },
  accents: {
    primary: "220 13% 13%",
    // Near black
    secondary: "30 6% 45%",
    // Warm gray
    application: {
      buttons: "outline",
      links: "underline",
      focus: "outline",
      selection: "bold"
    },
    gradients: {
      primaryGradient: "none",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "minimal",
    interactionScale: {
      hover: 1,
      press: 0.99
    },
    pageTransitions: !1,
    listAnimation: "none",
    duration: "fast"
  },
  dataAttributes: {
    mode: "light",
    style: "editorial",
    density: "comfortable",
    motion: "minimal"
  },
  componentDefaults: {
    Button: {
      variant: "outline",
      size: "sm",
      pressable: !1
    },
    Card: {
      variant: "outlined",
      padding: "md",
      hoverable: !1
    },
    Badge: {
      style: "outline",
      size: "sm"
    },
    DataTable: {
      density: "compact",
      stripedRows: !1,
      showRowBorders: !0,
      headerStyle: "uppercase"
    },
    KpiCard: {
      elevated: !1,
      displayFont: !0
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: [
    "https://bloomberg.com/markets",
    "https://ft.com",
    "https://mixpanel.com"
  ]
}, H = {
  id: "saas-enterprise-clean",
  name: "Enterprise Clean",
  description: "Editorial-inspired enterprise dashboard with authoritative serif headlines and clean sans-serif body text. Balances corporate trustworthiness with refined typographic sophistication.",
  category: "saas-dashboard",
  tags: ["editorial", "enterprise", "professional", "corporate", "trustworthy", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Merriweather", "Lora", "Georgia", serif',
      heading: '"Open Sans", "Source Sans 3", system-ui, sans-serif',
      body: '"Open Sans", "Source Sans 3", system-ui, sans-serif',
      mono: '"IBM Plex Mono", "Consolas", monospace'
    },
    scale: {
      displaySize: "4xl",
      h1Size: "2xl",
      h2Size: "xl",
      h3Size: "lg",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "normal",
      weight: "semibold",
      lineHeight: "1.25"
    },
    display: {
      letterSpacing: "-0.01em",
      weight: "bold",
      lineHeight: "1.15",
      style: "serif"
    },
    body: {
      letterSpacing: "normal",
      weight: "normal",
      lineHeight: "1.6"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "semibold",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.15,
    gapScale: 1.1,
    sectionSpacing: "generous",
    contentMaxWidth: "1280px",
    readingMaxWidth: "65ch"
  },
  cards: {
    defaultVariant: "outlined",
    radius: "md",
    showBorder: !0,
    borderStyle: "medium",
    accentEdge: "top",
    elevation: 0,
    hoverEffect: "border",
    padding: "lg"
  },
  dataViz: {
    sequential: ["#F8FAFC", "#CBD5E1", "#64748B", "#334155", "#0F172A"],
    categorical: [
      "#0F172A",
      "#1E40AF",
      "#166534",
      "#92400E",
      "#7C2D12",
      "#581C87"
    ],
    diverging: {
      negative: "#991B1B",
      neutral: "#64748B",
      positive: "#166534"
    },
    semantic: {
      positive: "#166534",
      negative: "#991B1B",
      neutral: "#64748B",
      warning: "#92400E"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "bold",
    metricFont: "display",
    labelSize: "xs",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !0,
    trendIndicator: "pill",
    sparklineStyle: "line",
    cardTreatment: "bordered"
  },
  accents: {
    primary: "222 47% 11%",
    // Slate 900
    secondary: "215 28% 47%",
    // Slate 500
    application: {
      buttons: "filled",
      links: "underline",
      focus: "outline",
      selection: "subtle"
    },
    gradients: {
      primaryGradient: "none",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "minimal",
    interactionScale: {
      hover: 1,
      press: 1
    },
    pageTransitions: !1,
    listAnimation: "fade",
    duration: "normal"
  },
  dataAttributes: {
    mode: "light",
    style: "editorial",
    density: "comfortable",
    motion: "minimal"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "md",
      pressable: !1
    },
    Card: {
      variant: "outlined",
      padding: "lg",
      hoverable: !1
    },
    Badge: {
      style: "soft",
      size: "md"
    },
    DataTable: {
      density: "comfortable",
      stripedRows: !1,
      showRowBorders: !0,
      headerStyle: "uppercase"
    },
    KpiCard: {
      elevated: !1,
      displayFont: !0
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: [
    "https://economist.com",
    "https://wsj.com",
    "https://salesforce.com"
  ]
}, G = {
  id: "saas-startup-fresh",
  name: "Startup Fresh",
  description: "Editorial-inspired startup dashboard with expressive serif headlines and modern sans-serif body. Combines playful energy with sophisticated typographic hierarchy.",
  category: "saas-dashboard",
  tags: ["editorial", "startup", "vibrant", "modern", "playful", "bold", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Fraunces", "Playfair Display", "Georgia", serif',
      heading: '"DM Sans", "Plus Jakarta Sans", system-ui, sans-serif',
      body: '"DM Sans", "Plus Jakarta Sans", system-ui, sans-serif',
      mono: '"Fira Code", "JetBrains Mono", monospace'
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "tight",
      weight: "semibold",
      lineHeight: "1.2"
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "medium",
      lineHeight: "1.0",
      style: "serif",
      optical: !0
    },
    body: {
      letterSpacing: "normal",
      weight: "normal",
      lineHeight: "1.6"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "semibold",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "spacious",
    paddingScale: 1.2,
    gapScale: 1.15,
    sectionSpacing: "generous",
    contentMaxWidth: "1200px",
    readingMaxWidth: "65ch"
  },
  cards: {
    defaultVariant: "elevated",
    radius: "xl",
    showBorder: !1,
    elevation: 2,
    hoverEffect: "lift",
    padding: "lg"
  },
  dataViz: {
    sequential: ["#FFF1F2", "#FECDD3", "#FDA4AF", "#F43F5E", "#BE123C"],
    categorical: [
      "#BE123C",
      "#7C3AED",
      "#0891B2",
      "#059669",
      "#D97706",
      "#4338CA"
    ],
    diverging: {
      negative: "#BE123C",
      neutral: "#71717A",
      positive: "#059669"
    },
    semantic: {
      positive: "#059669",
      negative: "#BE123C",
      neutral: "#71717A",
      warning: "#D97706"
    }
  },
  kpiStyling: {
    metricSize: "5xl",
    metricWeight: "medium",
    metricFont: "display",
    labelSize: "xs",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !1,
    trendIndicator: "pill",
    sparklineStyle: "area",
    cardTreatment: "elevated"
  },
  accents: {
    primary: "347 77% 50%",
    // Rose
    secondary: "263 70% 50%",
    // Violet
    application: {
      buttons: "filled",
      links: "color-only",
      focus: "ring",
      selection: "subtle"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(347 77% 50%) 0%, hsl(263 70% 50%) 100%)",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "smooth",
    interactionScale: {
      hover: 1.02,
      press: 0.98
    },
    pageTransitions: !0,
    listAnimation: "stagger",
    duration: "normal"
  },
  dataAttributes: {
    mode: "light",
    style: "editorial",
    density: "spacious",
    motion: "smooth"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "md",
      pressable: !0
    },
    Card: {
      variant: "elevated",
      padding: "lg",
      hoverable: !0
    },
    Badge: {
      style: "soft",
      size: "md"
    },
    DataTable: {
      density: "spacious",
      stripedRows: !1,
      showRowBorders: !1,
      headerStyle: "uppercase"
    },
    KpiCard: {
      elevated: !0,
      displayFont: !0
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: [
    "https://notion.so",
    "https://figma.com",
    "https://pitch.com"
  ]
}, V = {
  id: "saas-executive-premium",
  name: "Executive Premium",
  description: "Luxurious editorial design for executive dashboards and C-suite reports. Premium serif typography with gold accents creates a refined, authoritative presence.",
  category: "saas-dashboard",
  tags: ["editorial", "executive", "premium", "luxury", "sophisticated", "gold", "elegant"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Playfair Display", "Cormorant Garamond", "Georgia", serif',
      heading: '"Inter var", "Inter", system-ui, sans-serif',
      body: '"Inter var", "Inter", system-ui, sans-serif',
      mono: '"IBM Plex Mono", "JetBrains Mono", monospace'
    },
    scale: {
      displaySize: "6xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "normal",
      weight: "medium",
      lineHeight: "1.2"
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "normal",
      lineHeight: "1.0",
      style: "serif",
      italic: !1
    },
    body: {
      letterSpacing: "normal",
      weight: "normal",
      lineHeight: "1.7"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "spacious",
    paddingScale: 1.35,
    gapScale: 1.25,
    sectionSpacing: "generous",
    contentMaxWidth: "1200px",
    readingMaxWidth: "60ch"
  },
  cards: {
    defaultVariant: "elevated",
    radius: "lg",
    showBorder: !0,
    borderStyle: "subtle",
    accentEdge: "top",
    accentColor: "primary",
    elevation: 2,
    hoverEffect: "glow",
    padding: "xl"
  },
  dataViz: {
    sequential: ["#FFFBEB", "#FDE68A", "#FBBF24", "#D97706", "#92400E"],
    categorical: [
      "#92400E",
      "#1F2937",
      "#4B5563",
      "#78716C",
      "#B45309",
      "#6B7280"
    ],
    diverging: {
      negative: "#991B1B",
      neutral: "#78716C",
      positive: "#166534"
    },
    semantic: {
      positive: "#166534",
      negative: "#991B1B",
      neutral: "#78716C",
      warning: "#92400E"
    }
  },
  kpiStyling: {
    metricSize: "6xl",
    metricWeight: "normal",
    metricFont: "display",
    labelSize: "xs",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !1,
    trendIndicator: "pill-accent",
    sparklineStyle: "line",
    cardTreatment: "gradient-accent"
  },
  accents: {
    primary: "38 92% 50%",
    // Gold/Amber
    secondary: "220 13% 18%",
    // Dark slate
    application: {
      buttons: "filled",
      links: "underline",
      focus: "ring",
      selection: "subtle"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(38 92% 50%) 0%, hsl(28 80% 45%) 100%)",
      useOnButtons: !1,
      useOnCards: !0,
      useOnText: !1
    }
  },
  motion: {
    style: "smooth",
    interactionScale: {
      hover: 1.01,
      press: 0.99
    },
    pageTransitions: !0,
    listAnimation: "fade",
    duration: "slow"
  },
  dataAttributes: {
    mode: "light",
    style: "editorial",
    density: "spacious",
    motion: "smooth"
  },
  cssVariables: {
    "--ds-accent-gold": "38 92% 50%",
    "--ds-accent-gold-muted": "38 70% 75%"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "lg",
      pressable: !1
    },
    Card: {
      variant: "elevated",
      padding: "xl",
      hoverable: !0
    },
    Badge: {
      style: "soft",
      size: "md"
    },
    DataTable: {
      density: "spacious",
      stripedRows: !1,
      showRowBorders: !0,
      headerStyle: "uppercase"
    },
    KpiCard: {
      elevated: !0,
      displayFont: !0,
      accentBorder: !0
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: [
    "https://bloomberg.com",
    "https://stripe.com/atlas",
    "https://barrons.com"
  ]
}, L = {
  id: "saas-dark-mode-pro",
  name: "Dark Mode Pro",
  description: "Editorial dark theme with elegant serif headlines and warm amber accents. Optimized for extended use with careful contrast ratios and refined typography.",
  category: "saas-dashboard",
  tags: ["editorial", "dark", "pro", "night", "amber", "developer", "focus", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Crimson Pro", "Libre Baskerville", "Georgia", serif',
      heading: '"Inter var", "Inter", system-ui, sans-serif',
      body: '"Inter var", "Inter", system-ui, sans-serif',
      mono: '"JetBrains Mono", "Fira Code", monospace'
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "tight",
      weight: "medium",
      lineHeight: "1.2"
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "semibold",
      lineHeight: "1.05",
      style: "serif"
    },
    body: {
      letterSpacing: "normal",
      weight: "normal",
      lineHeight: "1.65"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.4
    }
  },
  spacing: {
    density: "spacious",
    paddingScale: 1.2,
    gapScale: 1.15,
    sectionSpacing: "generous",
    contentMaxWidth: "1200px",
    readingMaxWidth: "65ch"
  },
  cards: {
    defaultVariant: "elevated",
    radius: "lg",
    showBorder: !0,
    borderStyle: "subtle",
    accentEdge: "left",
    accentColor: "primary",
    elevation: 1,
    hoverEffect: "glow",
    padding: "lg"
  },
  dataViz: {
    sequential: ["#451A03", "#78350F", "#B45309", "#F59E0B", "#FDE68A"],
    categorical: [
      "#F59E0B",
      "#34D399",
      "#60A5FA",
      "#F472B6",
      "#A78BFA",
      "#FBBF24"
    ],
    diverging: {
      negative: "#F87171",
      neutral: "#9CA3AF",
      positive: "#34D399"
    },
    semantic: {
      positive: "#34D399",
      negative: "#F87171",
      neutral: "#9CA3AF",
      warning: "#FBBF24"
    }
  },
  kpiStyling: {
    metricSize: "5xl",
    metricWeight: "semibold",
    metricFont: "display",
    labelSize: "xs",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !1,
    trendIndicator: "pill",
    sparklineStyle: "line",
    cardTreatment: "elevated"
  },
  accents: {
    primary: "38 92% 50%",
    // Amber
    secondary: "158 64% 52%",
    // Emerald
    application: {
      buttons: "filled",
      links: "color-only",
      focus: "glow",
      selection: "subtle"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(38 92% 50%) 0%, hsl(28 80% 45%) 100%)",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "smooth",
    interactionScale: {
      hover: 1.01,
      press: 0.99
    },
    pageTransitions: !0,
    listAnimation: "fade",
    duration: "normal"
  },
  dataAttributes: {
    mode: "dark",
    style: "editorial",
    density: "spacious",
    motion: "smooth"
  },
  cssVariables: {
    "--ds-background": "220 20% 8%",
    "--ds-foreground": "40 20% 95%",
    "--ds-surface": "220 18% 12%",
    "--ds-card": "220 18% 12%",
    "--ds-border": "220 15% 20%",
    "--ds-muted": "220 15% 16%",
    "--ds-muted-foreground": "220 10% 60%"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "md",
      pressable: !1
    },
    Card: {
      variant: "elevated",
      padding: "lg",
      hoverable: !0
    },
    Badge: {
      style: "soft",
      size: "md"
    },
    DataTable: {
      density: "spacious",
      stripedRows: !1,
      showRowBorders: !0,
      headerStyle: "uppercase"
    },
    KpiCard: {
      elevated: !0,
      displayFont: !0
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: [
    "https://github.com",
    "https://linear.app",
    "https://railway.app"
  ]
}, W = {
  id: "saas-pastel-soft",
  name: "Pastel Soft",
  description: "Editorial wellness design with gentle serif headlines and soft pastel colors. Creates a calming, mindful experience with refined typographic sophistication.",
  category: "saas-dashboard",
  tags: ["editorial", "pastel", "soft", "calm", "wellness", "gentle", "lavender", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Lora", "Cormorant", "Georgia", serif',
      heading: '"Nunito", "DM Sans", system-ui, sans-serif',
      body: '"Nunito", "DM Sans", system-ui, sans-serif',
      mono: '"Fira Code", "IBM Plex Mono", monospace'
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "normal",
      weight: "semibold",
      lineHeight: "1.25"
    },
    display: {
      letterSpacing: "-0.01em",
      weight: "medium",
      lineHeight: "1.1",
      style: "serif",
      italic: !1
    },
    body: {
      letterSpacing: "normal",
      weight: "normal",
      lineHeight: "1.7"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.4
    }
  },
  spacing: {
    density: "spacious",
    paddingScale: 1.3,
    gapScale: 1.2,
    sectionSpacing: "generous",
    contentMaxWidth: "1100px",
    readingMaxWidth: "60ch"
  },
  cards: {
    defaultVariant: "elevated",
    radius: "2xl",
    showBorder: !1,
    elevation: 1,
    hoverEffect: "lift",
    padding: "xl"
  },
  dataViz: {
    sequential: ["#FAF5FF", "#E9D5FF", "#C4B5FD", "#A78BFA", "#7C3AED"],
    categorical: [
      "#8B5CF6",
      "#34D399",
      "#F472B6",
      "#60A5FA",
      "#FBBF24",
      "#A78BFA"
    ],
    diverging: {
      negative: "#F9A8D4",
      neutral: "#D1D5DB",
      positive: "#6EE7B7"
    },
    semantic: {
      positive: "#34D399",
      negative: "#F472B6",
      neutral: "#A1A1AA",
      warning: "#FBBF24"
    }
  },
  kpiStyling: {
    metricSize: "5xl",
    metricWeight: "medium",
    metricFont: "display",
    labelSize: "xs",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !1,
    trendIndicator: "pill",
    sparklineStyle: "area",
    cardTreatment: "elevated"
  },
  accents: {
    primary: "263 70% 58%",
    // Lavender
    secondary: "152 76% 55%",
    // Mint
    application: {
      buttons: "filled",
      links: "color-only",
      focus: "ring",
      selection: "subtle"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(263 70% 58%) 0%, hsl(280 65% 65%) 100%)",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "smooth",
    interactionScale: {
      hover: 1.01,
      press: 0.99
    },
    pageTransitions: !0,
    listAnimation: "fade",
    duration: "slow"
  },
  dataAttributes: {
    mode: "light",
    style: "editorial",
    density: "spacious",
    motion: "smooth"
  },
  cssVariables: {
    "--ds-background": "270 30% 99%",
    "--ds-surface": "270 25% 97%",
    "--ds-muted": "270 20% 95%"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "md",
      pressable: !1,
      pill: !0
    },
    Card: {
      variant: "elevated",
      padding: "xl",
      hoverable: !0
    },
    Badge: {
      style: "soft",
      size: "md"
    },
    DataTable: {
      density: "spacious",
      stripedRows: !1,
      showRowBorders: !1,
      headerStyle: "uppercase"
    },
    KpiCard: {
      elevated: !0,
      displayFont: !0
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: [
    "https://headspace.com",
    "https://calm.com",
    "https://flodesk.com"
  ]
}, q = {
  id: "saas-neon-cyberpunk",
  name: "Neon Cyberpunk",
  description: "Editorial futurism with dramatic serif headlines and vibrant neon accents. High-fashion typography meets cyberpunk aesthetics for bold, statement-making dashboards.",
  category: "saas-dashboard",
  tags: ["editorial", "neon", "cyberpunk", "futuristic", "dark", "bold", "magenta", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Bodoni Moda", "Playfair Display", "Georgia", serif',
      heading: '"Space Grotesk", "Inter", system-ui, sans-serif',
      body: '"Space Grotesk", "Inter", system-ui, sans-serif',
      mono: '"JetBrains Mono", "Fira Code", monospace'
    },
    scale: {
      displaySize: "6xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "tight",
      weight: "medium",
      lineHeight: "1.15"
    },
    display: {
      letterSpacing: "-0.03em",
      weight: "normal",
      lineHeight: "0.95",
      style: "serif",
      italic: !0
    },
    body: {
      letterSpacing: "normal",
      weight: "normal",
      lineHeight: "1.6"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "spacious",
    paddingScale: 1.2,
    gapScale: 1.15,
    sectionSpacing: "generous",
    contentMaxWidth: "1200px",
    readingMaxWidth: "65ch"
  },
  cards: {
    defaultVariant: "glass",
    radius: "lg",
    showBorder: !0,
    borderStyle: "accent",
    accentEdge: "top-gradient",
    accentColor: "primary",
    elevation: 0,
    hoverEffect: "glow",
    padding: "lg"
  },
  dataViz: {
    sequential: ["#2E1065", "#5B21B6", "#8B5CF6", "#C4B5FD", "#EDE9FE"],
    categorical: [
      "#F0ABFC",
      "#22D3EE",
      "#4ADE80",
      "#FACC15",
      "#FB923C",
      "#A78BFA"
    ],
    diverging: {
      negative: "#F472B6",
      neutral: "#A1A1AA",
      positive: "#4ADE80"
    },
    semantic: {
      positive: "#4ADE80",
      negative: "#F472B6",
      neutral: "#A1A1AA",
      warning: "#FACC15"
    }
  },
  kpiStyling: {
    metricSize: "6xl",
    metricWeight: "normal",
    metricFont: "display",
    metricItalic: !0,
    labelSize: "xs",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !1,
    trendIndicator: "pill-glow",
    sparklineStyle: "line",
    cardTreatment: "glass"
  },
  accents: {
    primary: "293 69% 78%",
    // Fuchsia/Magenta
    secondary: "186 94% 53%",
    // Cyan
    application: {
      buttons: "filled",
      links: "color-only",
      focus: "glow",
      selection: "bold"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(293 69% 78%) 0%, hsl(186 94% 53%) 100%)",
      useOnButtons: !1,
      useOnCards: !0,
      useOnText: !0
    }
  },
  motion: {
    style: "smooth",
    interactionScale: {
      hover: 1.02,
      press: 0.98
    },
    pageTransitions: !0,
    listAnimation: "stagger",
    duration: "normal"
  },
  dataAttributes: {
    mode: "dark",
    style: "editorial",
    density: "spacious",
    motion: "smooth"
  },
  cssVariables: {
    "--ds-background": "270 50% 5%",
    "--ds-foreground": "270 10% 95%",
    "--ds-surface": "270 40% 10%",
    "--ds-card": "270 40% 10%",
    "--ds-border": "293 50% 25%",
    "--ds-muted": "270 30% 15%",
    "--ds-muted-foreground": "270 15% 65%",
    "--ds-glow-color": "hsl(293 69% 78% / 0.4)"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "md",
      pressable: !0
    },
    Card: {
      variant: "glass",
      padding: "lg",
      hoverable: !0
    },
    Badge: {
      style: "solid",
      size: "sm"
    },
    DataTable: {
      density: "spacious",
      stripedRows: !1,
      showRowBorders: !0,
      headerStyle: "uppercase"
    },
    KpiCard: {
      elevated: !1,
      displayFont: !0,
      glowEffect: !0
    },
    Typography: {
      display: !0,
      serifHeadings: !0,
      gradientText: !0
    }
  },
  references: [
    "https://vogue.com",
    "https://wmagazine.com",
    "https://discord.com"
  ]
}, K = {
  id: "saas-warm-earthy",
  name: "Warm Earthy",
  description: "Editorial organic design with artisanal serif headlines and warm earth tones. Perfect for sustainability, lifestyle, and craft-focused applications.",
  category: "saas-dashboard",
  tags: ["editorial", "warm", "earthy", "natural", "organic", "sustainable", "terracotta", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Fraunces", "Libre Baskerville", "Georgia", serif',
      heading: '"Source Sans 3", "Source Sans Pro", system-ui, sans-serif',
      body: '"Source Sans 3", "Source Sans Pro", system-ui, sans-serif',
      mono: '"IBM Plex Mono", "JetBrains Mono", monospace'
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "normal",
      weight: "semibold",
      lineHeight: "1.2"
    },
    display: {
      letterSpacing: "-0.01em",
      weight: "medium",
      lineHeight: "1.05",
      style: "serif",
      optical: !0
    },
    body: {
      letterSpacing: "normal",
      weight: "normal",
      lineHeight: "1.7"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "semibold",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "spacious",
    paddingScale: 1.25,
    gapScale: 1.15,
    sectionSpacing: "generous",
    contentMaxWidth: "1100px",
    readingMaxWidth: "60ch"
  },
  cards: {
    defaultVariant: "outlined",
    radius: "lg",
    showBorder: !0,
    borderStyle: "medium",
    accentEdge: "left",
    accentColor: "primary",
    elevation: 0,
    hoverEffect: "lift",
    padding: "lg"
  },
  dataViz: {
    sequential: ["#FEF3C7", "#FDE68A", "#FCD34D", "#D97706", "#92400E"],
    categorical: [
      "#92400E",
      "#166534",
      "#78350F",
      "#1E3A5F",
      "#B45309",
      "#365314"
    ],
    diverging: {
      negative: "#991B1B",
      neutral: "#78716C",
      positive: "#166534"
    },
    semantic: {
      positive: "#166534",
      negative: "#991B1B",
      neutral: "#78716C",
      warning: "#92400E"
    }
  },
  kpiStyling: {
    metricSize: "5xl",
    metricWeight: "medium",
    metricFont: "display",
    labelSize: "xs",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !1,
    trendIndicator: "pill",
    sparklineStyle: "area",
    cardTreatment: "bordered"
  },
  accents: {
    primary: "24 95% 40%",
    // Terracotta
    secondary: "142 76% 30%",
    // Forest green
    application: {
      buttons: "filled",
      links: "underline",
      focus: "ring",
      selection: "subtle"
    },
    gradients: {
      primaryGradient: "none",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "smooth",
    interactionScale: {
      hover: 1.01,
      press: 0.99
    },
    pageTransitions: !0,
    listAnimation: "fade",
    duration: "normal"
  },
  dataAttributes: {
    mode: "light",
    style: "editorial",
    density: "spacious",
    motion: "smooth"
  },
  cssVariables: {
    "--ds-background": "40 30% 98%",
    "--ds-surface": "40 25% 96%",
    "--ds-muted": "40 20% 93%"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "md",
      pressable: !1
    },
    Card: {
      variant: "outlined",
      padding: "lg",
      hoverable: !0
    },
    Badge: {
      style: "soft",
      size: "md"
    },
    DataTable: {
      density: "spacious",
      stripedRows: !1,
      showRowBorders: !0,
      headerStyle: "uppercase"
    },
    KpiCard: {
      elevated: !1,
      displayFont: !0,
      accentBorder: !0
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: [
    "https://kinfolk.com",
    "https://patagonia.com",
    "https://allbirds.com"
  ]
}, Y = {
  id: "saas-minimal-mono",
  name: "Minimal Mono",
  description: "Editorial monochrome design with striking serif headlines and Swiss precision. Maximum focus on typography and content hierarchy through black and white contrast.",
  category: "saas-dashboard",
  tags: ["editorial", "minimal", "mono", "black", "white", "typography", "focus", "clean", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Cormorant Garamond", "Libre Baskerville", "Georgia", serif',
      heading: '"Inter var", "Inter", system-ui, sans-serif',
      body: '"Inter var", "Inter", system-ui, sans-serif',
      mono: '"JetBrains Mono", "SF Mono", monospace'
    },
    scale: {
      displaySize: "6xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "tight",
      weight: "medium",
      lineHeight: "1.15"
    },
    display: {
      letterSpacing: "-0.03em",
      weight: "semibold",
      lineHeight: "0.95",
      style: "serif"
    },
    body: {
      letterSpacing: "normal",
      weight: "normal",
      lineHeight: "1.7"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xxs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.4
    }
  },
  spacing: {
    density: "spacious",
    paddingScale: 1.3,
    gapScale: 1.25,
    sectionSpacing: "generous",
    contentMaxWidth: "1000px",
    readingMaxWidth: "55ch"
  },
  cards: {
    defaultVariant: "ghost",
    radius: "none",
    showBorder: !0,
    borderStyle: "bold",
    accentEdge: "none",
    elevation: 0,
    hoverEffect: "none",
    padding: "xl"
  },
  dataViz: {
    sequential: ["#FAFAFA", "#E5E5E5", "#A3A3A3", "#525252", "#171717"],
    categorical: [
      "#171717",
      "#525252",
      "#737373",
      "#A3A3A3",
      "#D4D4D4",
      "#404040"
    ],
    diverging: {
      negative: "#171717",
      neutral: "#737373",
      positive: "#171717"
    },
    semantic: {
      positive: "#171717",
      negative: "#171717",
      neutral: "#737373",
      warning: "#525252"
    }
  },
  kpiStyling: {
    metricSize: "6xl",
    metricWeight: "semibold",
    metricFont: "display",
    labelSize: "xxs",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !1,
    trendIndicator: "text",
    sparklineStyle: "line",
    cardTreatment: "minimal"
  },
  accents: {
    primary: "0 0% 9%",
    // Near black
    secondary: "0 0% 45%",
    // Gray
    application: {
      buttons: "outline",
      links: "underline",
      focus: "outline",
      selection: "bold"
    },
    gradients: {
      primaryGradient: "none",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "minimal",
    interactionScale: {
      hover: 1,
      press: 1
    },
    pageTransitions: !1,
    listAnimation: "none",
    duration: "fast"
  },
  dataAttributes: {
    mode: "light",
    style: "editorial",
    density: "spacious",
    motion: "minimal"
  },
  cssVariables: {
    "--ds-primary": "0 0% 9%",
    "--ds-secondary": "0 0% 45%",
    "--ds-border": "0 0% 20%"
  },
  componentDefaults: {
    Button: {
      variant: "outline",
      size: "md",
      pressable: !1
    },
    Card: {
      variant: "ghost",
      padding: "xl",
      hoverable: !1
    },
    Badge: {
      style: "outline",
      size: "md"
    },
    DataTable: {
      density: "spacious",
      stripedRows: !1,
      showRowBorders: !0,
      headerStyle: "uppercase"
    },
    KpiCard: {
      elevated: !1,
      displayFont: !0
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: [
    "https://ia.net/writer",
    "https://nytimes.com",
    "https://theparisreview.org"
  ]
}, N = [
  O,
  R,
  H,
  G,
  V,
  L,
  W,
  q,
  K,
  Y
];
p(N);
const U = {
  id: "analytics-bloomberg-inspired",
  name: "Bloomberg Inspired",
  description: "Dark, data-dense, terminal-like interface inspired by Bloomberg Terminal with editorial serif refinement. High contrast text, minimal decoration, and maximum information density for professional traders and analysts.",
  category: "analytics-platform",
  tags: ["dark", "terminal", "dense", "finance", "trading", "professional", "bloomberg", "high-contrast", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Editorial New", "Playfair Display", "Bodoni Moda", serif',
      heading: '"Inter var", "Inter", system-ui, sans-serif',
      body: '"Inter var", "Inter", system-ui, sans-serif',
      mono: '"Bloomberg Mono", "Consolas", "SF Mono", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "medium",
      lineHeight: "1.05",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "normal",
      weight: "bold",
      casing: "uppercase"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "compact",
    paddingScale: 1.1,
    gapScale: 0.5,
    sectionSpacing: "tight"
  },
  cards: {
    defaultVariant: "outlined",
    radius: "none",
    showBorder: !0,
    borderStyle: "medium",
    accentEdge: "none",
    elevation: 0,
    hoverEffect: "none"
  },
  dataViz: {
    sequential: ["#1a1a2e", "#2d2d4a", "#4a4a6a", "#6a6a8a", "#8a8aaa"],
    categorical: [
      "#ff8c00",
      // Bloomberg Orange
      "#00d4aa",
      // Teal/Green
      "#ff4444",
      // Red
      "#4488ff",
      // Blue
      "#ffcc00",
      // Yellow
      "#cc44ff",
      // Purple
      "#00ccff",
      // Cyan
      "#88ff44"
      // Lime
    ],
    diverging: {
      negative: "#ff4444",
      neutral: "#888888",
      positive: "#00d4aa"
    },
    semantic: {
      positive: "#00d4aa",
      negative: "#ff4444",
      neutral: "#888888",
      warning: "#ff8c00"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "bold",
    metricFont: "display",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !0,
    sparklineStyle: "line",
    cardTreatment: "bordered"
  },
  accents: {
    primary: "33 100% 50%",
    // Bloomberg Orange
    secondary: "165 100% 42%",
    // Teal
    application: {
      buttons: "outline",
      links: "color-only",
      focus: "outline",
      selection: "bold"
    }
  },
  motion: {
    style: "minimal",
    interactionScale: {
      hover: 1,
      press: 1
    },
    pageTransitions: !1,
    listAnimation: "none"
  },
  dataAttributes: {
    mode: "dark",
    density: "compact",
    motion: "minimal",
    style: "neo-dark"
  },
  cssVariables: {
    "--ds-background": "240 10% 5%",
    "--ds-foreground": "0 0% 95%",
    "--ds-surface": "240 10% 8%",
    "--ds-card": "240 10% 8%",
    "--ds-border": "240 10% 20%",
    "--ds-muted": "240 10% 18%",
    "--ds-muted-foreground": "220 14% 74%"
  },
  componentDefaults: {
    Button: {
      variant: "outline",
      size: "sm",
      pressable: !1
    },
    Card: {
      variant: "outlined",
      padding: "sm",
      hoverable: !1
    },
    Badge: {
      style: "solid",
      size: "sm"
    },
    DataTable: {
      density: "compact",
      stripedRows: !1,
      showRowBorders: !0
    },
    KpiCard: {
      elevated: !1,
      displayFont: !0
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    },
    Input: {
      variant: "flushed"
    }
  },
  references: ["https://www.bloomberg.com/professional/solution/bloomberg-terminal/"]
}, J = {
  id: "analytics-mixpanel-style",
  name: "Mixpanel Style",
  description: "Clean, colorful charts with a focus on product analytics and editorial serif refinement. Purple-centric palette with vibrant data visualizations and a modern, approachable interface for understanding user behavior.",
  category: "analytics-platform",
  tags: ["product-analytics", "colorful", "purple", "modern", "charts", "user-behavior", "funnel", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Fraunces", "Playfair Display", "Libre Baskerville", serif',
      heading: '"Inter var", "Inter", system-ui, sans-serif',
      body: '"Inter var", "Inter", system-ui, sans-serif',
      mono: '"SF Mono", "Fira Code", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "semibold",
      lineHeight: "1.1",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "tight",
      weight: "semibold"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.15,
    gapScale: 1,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "elevated",
    radius: "lg",
    showBorder: !0,
    borderStyle: "subtle",
    accentEdge: "none",
    elevation: 1,
    hoverEffect: "lift"
  },
  dataViz: {
    sequential: ["#F3E8FF", "#DDD6FE", "#A78BFA", "#7C3AED", "#5B21B6"],
    categorical: [
      "#7C3AED",
      // Purple (primary)
      "#06B6D4",
      // Cyan
      "#F59E0B",
      // Amber
      "#10B981",
      // Emerald
      "#EC4899",
      // Pink
      "#3B82F6",
      // Blue
      "#EF4444",
      // Red
      "#8B5CF6"
      // Violet
    ],
    diverging: {
      negative: "#EF4444",
      neutral: "#6B7280",
      positive: "#10B981"
    },
    semantic: {
      positive: "#10B981",
      negative: "#EF4444",
      neutral: "#6B7280",
      warning: "#F59E0B"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "bold",
    metricFont: "display",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !0,
    sparklineStyle: "area",
    cardTreatment: "elevated"
  },
  accents: {
    primary: "263 70% 50%",
    // Mixpanel Purple
    secondary: "186 95% 43%",
    // Cyan
    application: {
      buttons: "filled",
      links: "color-only",
      focus: "ring",
      selection: "subtle"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(263 70% 50%) 0%, hsl(280 85% 55%) 100%)",
      useOnButtons: !0,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "smooth",
    interactionScale: {
      hover: 1.02,
      press: 0.98
    },
    pageTransitions: !0,
    listAnimation: "stagger"
  },
  dataAttributes: {
    mode: "light",
    density: "comfortable",
    motion: "smooth",
    style: "maximal-luxe"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "md",
      pressable: !0
    },
    Card: {
      variant: "elevated",
      padding: "md",
      hoverable: !0
    },
    Badge: {
      style: "soft",
      size: "md"
    },
    DataTable: {
      density: "comfortable",
      stripedRows: !1,
      showRowBorders: !0
    },
    KpiCard: {
      elevated: !0,
      displayFont: !0
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    },
    Input: {
      variant: "default"
    },
    Tabs: {
      variant: "underline"
    }
  },
  references: ["https://mixpanel.com"]
}, $ = {
  id: "analytics-data-studio",
  name: "Data Studio",
  description: "Google Data Studio inspired design with Material Design influences and editorial serif refinement. Clean, accessible, and familiar interface optimized for creating and sharing data reports with broad audiences.",
  category: "analytics-platform",
  tags: ["google", "material", "accessible", "reporting", "clean", "familiar", "blue", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Merriweather", "Lora", "Crimson Pro", serif',
      heading: '"Google Sans", "Roboto", system-ui, sans-serif',
      body: '"Roboto", system-ui, sans-serif',
      mono: '"Roboto Mono", "Consolas", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "normal",
      lineHeight: "1.1",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "normal",
      weight: "medium"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.1,
    gapScale: 1,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "elevated",
    radius: "md",
    showBorder: !1,
    elevation: 1,
    hoverEffect: "lift"
  },
  dataViz: {
    sequential: ["#E3F2FD", "#90CAF9", "#42A5F5", "#1976D2", "#0D47A1"],
    categorical: [
      "#4285F4",
      // Google Blue
      "#EA4335",
      // Google Red
      "#FBBC04",
      // Google Yellow
      "#34A853",
      // Google Green
      "#FF6D00",
      // Orange
      "#46BDC6",
      // Teal
      "#7BAAF7",
      // Light Blue
      "#F07B72"
      // Light Red
    ],
    diverging: {
      negative: "#EA4335",
      neutral: "#9E9E9E",
      positive: "#34A853"
    },
    semantic: {
      positive: "#34A853",
      negative: "#EA4335",
      neutral: "#9E9E9E",
      warning: "#FBBC04"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "medium",
    metricFont: "display",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !0,
    sparklineStyle: "line",
    cardTreatment: "elevated"
  },
  accents: {
    primary: "217 89% 61%",
    // Google Blue
    secondary: "142 71% 45%",
    // Google Green
    application: {
      buttons: "filled",
      links: "color-only",
      focus: "ring",
      selection: "subtle"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(217 89% 61%) 0%, hsl(217 89% 50%) 100%)",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "smooth",
    interactionScale: {
      hover: 1.01,
      press: 0.99
    },
    pageTransitions: !0,
    listAnimation: "fade"
  },
  dataAttributes: {
    mode: "light",
    density: "comfortable",
    motion: "smooth",
    style: "minimal-contrast"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "md",
      pressable: !0,
      pill: !1
    },
    Card: {
      variant: "elevated",
      padding: "md",
      hoverable: !0
    },
    Badge: {
      style: "soft",
      size: "md"
    },
    DataTable: {
      density: "comfortable",
      stripedRows: !1,
      showRowBorders: !0
    },
    KpiCard: {
      elevated: !0,
      displayFont: !0
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    },
    Input: {
      variant: "filled"
    },
    Tabs: {
      variant: "underline"
    }
  },
  references: ["https://lookerstudio.google.com", "https://material.io"]
}, j = {
  id: "analytics-grafana-dark",
  name: "Grafana Dark",
  description: "Dark monitoring dashboard inspired by Grafana with editorial serif refinement. Optimized for real-time metrics, time-series visualization, and DevOps workflows with high-contrast data displays.",
  category: "analytics-platform",
  tags: ["dark", "monitoring", "devops", "metrics", "real-time", "grafana", "observability", "time-series", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Cormorant Garamond", "Playfair Display", "Bodoni Moda", serif',
      heading: '"Inter var", "Inter", system-ui, sans-serif',
      body: '"Inter var", "Inter", system-ui, sans-serif',
      mono: '"Roboto Mono", "SF Mono", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "medium",
      lineHeight: "1.0",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "tight",
      weight: "medium"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "compact",
    paddingScale: 1.1,
    gapScale: 0.75,
    sectionSpacing: "tight"
  },
  cards: {
    defaultVariant: "outlined",
    radius: "sm",
    showBorder: !0,
    borderStyle: "subtle",
    accentEdge: "top",
    elevation: 0,
    hoverEffect: "glow"
  },
  dataViz: {
    sequential: ["#1F1D2B", "#2C2A3A", "#3D3B4F", "#5A5873", "#7B7897"],
    categorical: [
      "#73BF69",
      // Grafana Green
      "#F2CC0C",
      // Yellow
      "#FF9830",
      // Orange
      "#E02F44",
      // Red
      "#8AB8FF",
      // Blue
      "#CA95E5",
      // Purple
      "#FFB357",
      // Light Orange
      "#5794F2"
      // Bright Blue
    ],
    diverging: {
      negative: "#E02F44",
      neutral: "#8E8EA0",
      positive: "#73BF69"
    },
    semantic: {
      positive: "#73BF69",
      negative: "#E02F44",
      neutral: "#8E8EA0",
      warning: "#F2CC0C"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "semibold",
    metricFont: "display",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !0,
    sparklineStyle: "line",
    cardTreatment: "bordered"
  },
  accents: {
    primary: "96 48% 58%",
    // Grafana Green
    secondary: "214 79% 65%",
    // Grafana Blue
    application: {
      buttons: "filled",
      links: "color-only",
      focus: "glow",
      selection: "bold"
    }
  },
  motion: {
    style: "minimal",
    interactionScale: {
      hover: 1.01,
      press: 0.99
    },
    pageTransitions: !1,
    listAnimation: "fade"
  },
  dataAttributes: {
    mode: "dark",
    density: "compact",
    motion: "minimal",
    style: "neo-dark"
  },
  cssVariables: {
    "--ds-background": "229 21% 11%",
    "--ds-foreground": "220 13% 91%",
    "--ds-surface": "229 21% 14%",
    "--ds-card": "229 21% 14%",
    "--ds-border": "229 14% 22%",
    "--ds-muted": "229 10% 20%",
    "--ds-muted-foreground": "220 14% 74%"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "sm",
      pressable: !1
    },
    Card: {
      variant: "outlined",
      padding: "sm",
      hoverable: !1
    },
    Badge: {
      style: "solid",
      size: "sm"
    },
    DataTable: {
      density: "compact",
      stripedRows: !1,
      showRowBorders: !0
    },
    KpiCard: {
      elevated: !1,
      displayFont: !0
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    },
    Input: {
      variant: "filled"
    }
  },
  references: ["https://grafana.com", "https://play.grafana.org"]
}, Q = {
  id: "analytics-tableau-classic",
  name: "Tableau Classic",
  description: "Enterprise BI look inspired by Tableau with editorial serif refinement. Professional, data-focused design with rich visualization capabilities and a trusted aesthetic for business intelligence reporting.",
  category: "analytics-platform",
  tags: ["enterprise", "bi", "business-intelligence", "professional", "tableau", "visualization", "reporting", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Libre Baskerville", "Lora", "Crimson Pro", serif',
      heading: '"Benton Sans", "Segoe UI", system-ui, sans-serif',
      body: '"Benton Sans", "Segoe UI", system-ui, sans-serif',
      mono: '"Consolas", "SF Mono", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "normal",
      lineHeight: "1.1",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "normal",
      weight: "semibold"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.15,
    gapScale: 1,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "outlined",
    radius: "sm",
    showBorder: !0,
    borderStyle: "medium",
    accentEdge: "none",
    elevation: 1,
    hoverEffect: "lift"
  },
  dataViz: {
    sequential: ["#F7D4BC", "#F0A77B", "#E67C40", "#CC5500", "#993D00"],
    categorical: [
      "#4E79A7",
      // Tableau Blue
      "#F28E2B",
      // Orange
      "#E15759",
      // Red
      "#76B7B2",
      // Teal
      "#59A14F",
      // Green
      "#EDC948",
      // Yellow
      "#B07AA1",
      // Purple
      "#FF9DA7",
      // Pink
      "#9C755F",
      // Brown
      "#BAB0AC"
      // Gray
    ],
    diverging: {
      negative: "#E15759",
      neutral: "#BAB0AC",
      positive: "#59A14F"
    },
    semantic: {
      positive: "#59A14F",
      negative: "#E15759",
      neutral: "#BAB0AC",
      warning: "#EDC948"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "bold",
    metricFont: "display",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !0,
    sparklineStyle: "bar",
    cardTreatment: "bordered"
  },
  accents: {
    primary: "211 47% 48%",
    // Tableau Blue
    secondary: "27 88% 56%",
    // Tableau Orange
    application: {
      buttons: "filled",
      links: "underline",
      focus: "outline",
      selection: "bold"
    }
  },
  motion: {
    style: "smooth",
    interactionScale: {
      hover: 1.01,
      press: 0.99
    },
    pageTransitions: !0,
    listAnimation: "fade"
  },
  dataAttributes: {
    mode: "light",
    density: "comfortable",
    motion: "smooth",
    style: "executive"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "md",
      pressable: !0
    },
    Card: {
      variant: "outlined",
      padding: "md",
      hoverable: !0
    },
    Badge: {
      style: "soft",
      size: "md"
    },
    DataTable: {
      density: "comfortable",
      stripedRows: !0,
      showRowBorders: !1
    },
    KpiCard: {
      elevated: !0,
      displayFont: !0
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    },
    Input: {
      variant: "default"
    },
    Tabs: {
      variant: "enclosed"
    }
  },
  references: ["https://www.tableau.com", "https://public.tableau.com"]
}, Z = {
  id: "analytics-amplitude-modern",
  name: "Amplitude Modern",
  description: "Modern product analytics inspired by Amplitude with editorial serif refinement. Clean, sophisticated interface with blue-centric palette, excellent data clarity, and thoughtful user experience for behavioral analytics.",
  category: "analytics-platform",
  tags: ["product-analytics", "modern", "blue", "behavioral", "sophisticated", "amplitude", "cohorts", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Playfair Display", "Fraunces", "Bodoni Moda", serif',
      heading: '"Inter var", "Inter", system-ui, sans-serif',
      body: '"Inter var", "Inter", system-ui, sans-serif',
      mono: '"SF Mono", "Fira Code", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "semibold",
      lineHeight: "1.05",
      style: "serif"
    },
    scale: {
      displaySize: "6xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "tight",
      weight: "semibold"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.2,
    gapScale: 1,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "elevated",
    radius: "xl",
    showBorder: !0,
    borderStyle: "subtle",
    accentEdge: "none",
    elevation: 1,
    hoverEffect: "lift"
  },
  dataViz: {
    sequential: ["#E8F1FF", "#B3D4FF", "#66A3FF", "#1A75FF", "#0047B3"],
    categorical: [
      "#1A75FF",
      // Amplitude Blue
      "#00C2B2",
      // Teal
      "#FF6B6B",
      // Coral
      "#A855F7",
      // Purple
      "#FBBF24",
      // Amber
      "#10B981",
      // Emerald
      "#F472B6",
      // Pink
      "#6366F1"
      // Indigo
    ],
    diverging: {
      negative: "#FF6B6B",
      neutral: "#94A3B8",
      positive: "#00C2B2"
    },
    semantic: {
      positive: "#00C2B2",
      negative: "#FF6B6B",
      neutral: "#94A3B8",
      warning: "#FBBF24"
    }
  },
  kpiStyling: {
    metricSize: "5xl",
    metricWeight: "semibold",
    metricFont: "display",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !0,
    sparklineStyle: "area",
    cardTreatment: "elevated"
  },
  accents: {
    primary: "217 100% 55%",
    // Amplitude Blue
    secondary: "174 100% 38%",
    // Teal
    application: {
      buttons: "filled",
      links: "color-only",
      focus: "ring",
      selection: "subtle"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(217 100% 55%) 0%, hsl(240 80% 60%) 100%)",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !0
    }
  },
  motion: {
    style: "smooth",
    interactionScale: {
      hover: 1.02,
      press: 0.98
    },
    pageTransitions: !0,
    listAnimation: "stagger"
  },
  dataAttributes: {
    mode: "light",
    density: "comfortable",
    motion: "smooth",
    style: "aero-mica"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "md",
      pressable: !0,
      pill: !0
    },
    Card: {
      variant: "elevated",
      padding: "lg",
      hoverable: !0
    },
    Badge: {
      style: "soft",
      size: "md"
    },
    DataTable: {
      density: "comfortable",
      stripedRows: !1,
      showRowBorders: !0
    },
    KpiCard: {
      elevated: !0,
      displayFont: !0
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    },
    Input: {
      variant: "default"
    },
    Tabs: {
      variant: "pills"
    },
    Modal: {
      size: "lg"
    }
  },
  references: ["https://amplitude.com"]
}, _ = {
  id: "analytics-metabase-friendly",
  name: "Metabase Friendly",
  description: "Approachable, friendly analytics inspired by Metabase with editorial serif refinement. Designed to make data accessible to non-technical users with warm, inviting aesthetics and clear visual hierarchy.",
  category: "analytics-platform",
  tags: ["friendly", "accessible", "warm", "approachable", "metabase", "self-serve", "simple", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Lora", "Merriweather", "Crimson Pro", serif',
      heading: '"Lato", "Open Sans", system-ui, sans-serif',
      body: '"Lato", "Open Sans", system-ui, sans-serif',
      mono: '"Source Code Pro", "Fira Code", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "medium",
      lineHeight: "1.15",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "normal",
      weight: "bold"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "spacious",
    paddingScale: 1.3,
    gapScale: 1.25,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "elevated",
    radius: "lg",
    showBorder: !1,
    elevation: 2,
    hoverEffect: "lift"
  },
  dataViz: {
    sequential: ["#F0F5FF", "#C4D9F8", "#88B4F5", "#509EE3", "#2E78C2"],
    categorical: [
      "#509EE3",
      // Metabase Blue
      "#88BF4D",
      // Green
      "#A989C5",
      // Purple
      "#EF8C8C",
      // Salmon
      "#F9D45C",
      // Yellow
      "#F2A86F",
      // Orange
      "#98D9D9",
      // Teal
      "#7172AD"
      // Lavender
    ],
    diverging: {
      negative: "#EF8C8C",
      neutral: "#A6A6A6",
      positive: "#88BF4D"
    },
    semantic: {
      positive: "#88BF4D",
      negative: "#EF8C8C",
      neutral: "#A6A6A6",
      warning: "#F9D45C"
    }
  },
  kpiStyling: {
    metricSize: "5xl",
    metricWeight: "bold",
    metricFont: "display",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !0,
    sparklineStyle: "area",
    cardTreatment: "elevated"
  },
  accents: {
    primary: "209 74% 60%",
    // Metabase Blue
    secondary: "88 46% 52%",
    // Green
    application: {
      buttons: "filled",
      links: "color-only",
      focus: "ring",
      selection: "subtle"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(209 74% 60%) 0%, hsl(209 74% 45%) 100%)",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "playful",
    interactionScale: {
      hover: 1.03,
      press: 0.97
    },
    pageTransitions: !0,
    listAnimation: "stagger"
  },
  dataAttributes: {
    mode: "light",
    density: "spacious",
    motion: "playful",
    style: "glass-luxe"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "lg",
      pressable: !0,
      pill: !0
    },
    Card: {
      variant: "elevated",
      padding: "lg",
      hoverable: !0
    },
    Badge: {
      style: "soft",
      size: "md"
    },
    DataTable: {
      density: "comfortable",
      stripedRows: !1,
      showRowBorders: !0
    },
    KpiCard: {
      elevated: !0,
      displayFont: !0
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    },
    Input: {
      variant: "default"
    },
    Tabs: {
      variant: "underline"
    },
    Modal: {
      size: "md"
    },
    Alert: {
      variant: "info"
    }
  },
  references: ["https://www.metabase.com"]
}, X = {
  id: "analytics-looker-enterprise",
  name: "Looker Enterprise",
  description: "Enterprise cloud BI inspired by Looker with editorial serif refinement. Professional, scalable design suited for large organizations with complex data modeling and governance requirements.",
  category: "analytics-platform",
  tags: ["enterprise", "cloud", "looker", "google", "professional", "scalable", "data-modeling", "governance", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Crimson Pro", "Merriweather", "Lora", serif',
      heading: '"Google Sans", "Roboto", system-ui, sans-serif',
      body: '"Roboto", system-ui, sans-serif',
      mono: '"Roboto Mono", "SF Mono", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "medium",
      lineHeight: "1.1",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "normal",
      weight: "medium"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.15,
    gapScale: 1,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "elevated",
    radius: "md",
    showBorder: !0,
    borderStyle: "subtle",
    accentEdge: "none",
    elevation: 1,
    hoverEffect: "lift"
  },
  dataViz: {
    sequential: ["#E8EAF6", "#C5CAE9", "#7986CB", "#3F51B5", "#1A237E"],
    categorical: [
      "#5C6BC0",
      // Looker Indigo
      "#26A69A",
      // Teal
      "#FFA726",
      // Orange
      "#EF5350",
      // Red
      "#AB47BC",
      // Purple
      "#66BB6A",
      // Green
      "#29B6F6",
      // Light Blue
      "#EC407A"
      // Pink
    ],
    diverging: {
      negative: "#EF5350",
      neutral: "#9E9E9E",
      positive: "#26A69A"
    },
    semantic: {
      positive: "#26A69A",
      negative: "#EF5350",
      neutral: "#9E9E9E",
      warning: "#FFA726"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "medium",
    metricFont: "display",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !0,
    sparklineStyle: "line",
    cardTreatment: "elevated"
  },
  accents: {
    primary: "232 50% 56%",
    // Looker Indigo
    secondary: "174 63% 40%",
    // Teal
    application: {
      buttons: "filled",
      links: "color-only",
      focus: "ring",
      selection: "subtle"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(232 50% 56%) 0%, hsl(262 52% 47%) 100%)",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "smooth",
    interactionScale: {
      hover: 1.01,
      press: 0.99
    },
    pageTransitions: !0,
    listAnimation: "fade"
  },
  dataAttributes: {
    mode: "light",
    density: "comfortable",
    motion: "smooth",
    style: "executive"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "md",
      pressable: !0
    },
    Card: {
      variant: "elevated",
      padding: "md",
      hoverable: !0
    },
    Badge: {
      style: "soft",
      size: "md"
    },
    DataTable: {
      density: "comfortable",
      stripedRows: !0,
      showRowBorders: !1
    },
    KpiCard: {
      elevated: !0,
      displayFont: !0
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    },
    Input: {
      variant: "filled"
    },
    Tabs: {
      variant: "underline"
    },
    Modal: {
      size: "lg"
    }
  },
  references: ["https://cloud.google.com/looker", "https://lookerstudio.google.com"]
}, ee = [
  U,
  J,
  $,
  j,
  Q,
  Z,
  _,
  X
];
p(ee);
const ie = {
  id: "ecommerce-luxury-boutique",
  name: "Luxury Boutique",
  description: "Elegant, sophisticated editorial design with refined serif typography, generous whitespace, and muted color palette. Perfect for high-end fashion, jewelry, and premium lifestyle brands.",
  category: "e-commerce",
  tags: ["luxury", "elegant", "serif", "minimal", "premium", "fashion", "boutique", "editorial"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Cormorant Garamond", "Playfair Display", Georgia, serif',
      heading: '"Cormorant Garamond", Georgia, serif',
      body: '"Inter var", "Inter", system-ui, sans-serif',
      mono: '"IBM Plex Mono", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "normal",
      lineHeight: "1.05",
      style: "serif"
    },
    scale: {
      displaySize: "6xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "wide",
      weight: "medium",
      casing: "uppercase"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "spacious",
    paddingScale: 1.6,
    gapScale: 1.4,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "ghost",
    radius: "none",
    showBorder: !0,
    borderStyle: "subtle",
    accentEdge: "none",
    elevation: 0,
    hoverEffect: "none"
  },
  dataViz: {
    sequential: ["#F5F5F4", "#D6D3D1", "#A8A29E", "#78716C", "#44403C"],
    categorical: [
      "#1C1917",
      "#78716C",
      "#B8860B",
      "#A8A29E",
      "#44403C",
      "#D6D3D1"
    ],
    diverging: {
      negative: "#9F1239",
      neutral: "#78716C",
      positive: "#166534"
    },
    semantic: {
      positive: "#166534",
      negative: "#9F1239",
      neutral: "#78716C",
      warning: "#B8860B"
    }
  },
  kpiStyling: {
    metricSize: "5xl",
    metricWeight: "medium",
    metricFont: "display",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !1,
    sparklineStyle: "line",
    cardTreatment: "minimal"
  },
  accents: {
    primary: "43 74% 49%",
    // Antique Gold
    secondary: "24 10% 10%",
    // Near Black
    application: {
      buttons: "outline",
      links: "underline",
      focus: "outline",
      selection: "subtle"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(43 74% 49%) 0%, hsl(43 60% 40%) 100%)",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "smooth",
    interactionScale: {
      hover: 1,
      press: 0.99
    },
    pageTransitions: !0,
    listAnimation: "fade"
  },
  dataAttributes: {
    mode: "light",
    density: "spacious",
    motion: "smooth",
    style: "editorial"
  },
  cssVariables: {
    "--ds-background": "0 0% 100%",
    "--ds-foreground": "24 10% 10%",
    "--ds-surface": "60 9% 98%",
    "--ds-muted": "60 5% 96%",
    "--ds-border": "24 6% 90%"
  },
  componentDefaults: {
    Button: {
      variant: "outline",
      size: "lg",
      pill: !1,
      pressable: !1
    },
    Card: {
      variant: "ghost",
      padding: "lg",
      hoverable: !1
    },
    Badge: {
      style: "outline",
      size: "sm"
    },
    DataTable: {
      density: "spacious",
      stripedRows: !1,
      showRowBorders: !0
    },
    KpiCard: {
      elevated: !1,
      displayFont: !0
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    },
    Input: {
      variant: "flushed"
    }
  },
  references: ["https://net-a-porter.com", "https://farfetch.com", "https://mrporter.com"]
}, te = {
  id: "ecommerce-modern-marketplace",
  name: "Modern Marketplace",
  description: "Clean, trustworthy editorial design with clear hierarchy and efficient layouts. Optimized for multi-vendor marketplaces, product discovery, and conversion-focused experiences.",
  category: "e-commerce",
  tags: ["marketplace", "multi-vendor", "trustworthy", "clean", "conversion", "ecommerce", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Playfair Display", "Libre Baskerville", Georgia, serif',
      heading: '"Inter var", "Inter", system-ui, sans-serif',
      body: '"Inter var", "Inter", system-ui, sans-serif',
      mono: '"SF Mono", "Fira Code", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "medium",
      lineHeight: "1.1",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "tight",
      weight: "semibold"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.1,
    gapScale: 1,
    sectionSpacing: "normal"
  },
  cards: {
    defaultVariant: "outlined",
    radius: "lg",
    showBorder: !0,
    borderStyle: "subtle",
    accentEdge: "none",
    elevation: 1,
    hoverEffect: "lift"
  },
  dataViz: {
    sequential: ["#FEF3C7", "#FCD34D", "#FBBF24", "#F59E0B", "#D97706"],
    categorical: [
      "#F59E0B",
      "#3B82F6",
      "#10B981",
      "#EF4444",
      "#8B5CF6",
      "#EC4899"
    ],
    diverging: {
      negative: "#EF4444",
      neutral: "#6B7280",
      positive: "#10B981"
    },
    semantic: {
      positive: "#10B981",
      negative: "#EF4444",
      neutral: "#6B7280",
      warning: "#F59E0B"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "bold",
    metricFont: "display",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !0,
    sparklineStyle: "bar",
    cardTreatment: "bordered"
  },
  accents: {
    primary: "38 92% 50%",
    // Amazon Orange
    secondary: "221 83% 53%",
    // Trust Blue
    application: {
      buttons: "filled",
      links: "color-only",
      focus: "ring",
      selection: "bold"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(38 92% 50%) 0%, hsl(25 95% 53%) 100%)",
      useOnButtons: !0,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "minimal",
    interactionScale: {
      hover: 1.02,
      press: 0.98
    },
    pageTransitions: !1,
    listAnimation: "none"
  },
  dataAttributes: {
    mode: "light",
    density: "comfortable",
    motion: "minimal",
    style: "editorial"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "md",
      pill: !0,
      pressable: !0
    },
    Card: {
      variant: "outlined",
      padding: "sm",
      hoverable: !0
    },
    Badge: {
      style: "solid",
      size: "sm"
    },
    DataTable: {
      density: "compact",
      stripedRows: !0,
      showRowBorders: !1
    },
    KpiCard: {
      elevated: !1,
      displayFont: !0
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    },
    Input: {
      variant: "default"
    }
  },
  references: ["https://amazon.com", "https://etsy.com", "https://ebay.com"]
}, ae = {
  id: "ecommerce-shopify-admin",
  name: "Shopify Admin",
  description: "Merchant-focused editorial admin dashboard with green accents, clear data visualization, and efficient workflows. Perfect for e-commerce backends, order management, and inventory systems.",
  category: "e-commerce",
  tags: ["admin", "dashboard", "merchant", "shopify", "green", "management", "backend", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Fraunces", "Merriweather", Georgia, serif',
      heading: '"Inter var", "Inter", system-ui, sans-serif',
      body: '"Inter var", "Inter", system-ui, sans-serif',
      mono: '"SF Mono", "Roboto Mono", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "semibold",
      lineHeight: "1.1",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "tight",
      weight: "semibold"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.15,
    gapScale: 1.1,
    sectionSpacing: "normal"
  },
  cards: {
    defaultVariant: "elevated",
    radius: "lg",
    showBorder: !0,
    borderStyle: "subtle",
    accentEdge: "none",
    elevation: 1,
    hoverEffect: "none"
  },
  dataViz: {
    sequential: ["#D1FAE5", "#6EE7B7", "#34D399", "#10B981", "#047857"],
    categorical: [
      "#047857",
      "#6366F1",
      "#F59E0B",
      "#EF4444",
      "#8B5CF6",
      "#06B6D4"
    ],
    diverging: {
      negative: "#DC2626",
      neutral: "#6B7280",
      positive: "#059669"
    },
    semantic: {
      positive: "#059669",
      negative: "#DC2626",
      neutral: "#6B7280",
      warning: "#D97706"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "semibold",
    metricFont: "display",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !0,
    sparklineStyle: "area",
    cardTreatment: "elevated"
  },
  accents: {
    primary: "158 64% 32%",
    // Shopify Green
    secondary: "245 58% 51%",
    // Indigo
    application: {
      buttons: "filled",
      links: "color-only",
      focus: "ring",
      selection: "subtle"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(158 64% 32%) 0%, hsl(160 60% 38%) 100%)",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "smooth",
    interactionScale: {
      hover: 1.01,
      press: 0.99
    },
    pageTransitions: !0,
    listAnimation: "fade"
  },
  dataAttributes: {
    mode: "light",
    density: "comfortable",
    motion: "smooth",
    style: "editorial"
  },
  cssVariables: {
    "--ds-background": "0 0% 98%",
    "--ds-foreground": "222 47% 11%",
    "--ds-surface": "0 0% 100%",
    "--ds-muted": "210 20% 96%",
    "--ds-border": "214 32% 91%"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "md",
      pill: !1,
      pressable: !0
    },
    Card: {
      variant: "elevated",
      padding: "md",
      hoverable: !1
    },
    Badge: {
      style: "soft",
      size: "sm"
    },
    DataTable: {
      density: "comfortable",
      stripedRows: !1,
      showRowBorders: !0
    },
    KpiCard: {
      elevated: !0,
      displayFont: !0
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    },
    Input: {
      variant: "default"
    },
    Tabs: {
      variant: "underline"
    }
  },
  references: ["https://shopify.com/admin", "https://help.shopify.com"]
}, se = {
  id: "ecommerce-fashion-forward",
  name: "Fashion Forward",
  description: "Bold, editorial design with striking serif typography, high contrast, and fashion-forward aesthetics. Perfect for contemporary fashion brands, streetwear, and trend-focused retailers.",
  category: "e-commerce",
  tags: ["fashion", "bold", "editorial", "contemporary", "contrast", "typography", "trendy", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Bodoni Moda", "Playfair Display", "Didot", Georgia, serif',
      heading: '"Bodoni Moda", "Playfair Display", Georgia, serif',
      body: '"Inter var", "Inter", system-ui, sans-serif',
      mono: '"Space Mono", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "normal",
      lineHeight: "1.0",
      style: "serif"
    },
    scale: {
      displaySize: "6xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "tight",
      weight: "bold",
      casing: "uppercase"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "spacious",
    paddingScale: 1.25,
    gapScale: 1.2,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "ghost",
    radius: "none",
    showBorder: !1,
    accentEdge: "none",
    elevation: 0,
    hoverEffect: "scale"
  },
  dataViz: {
    sequential: ["#FAFAFA", "#D4D4D4", "#A3A3A3", "#525252", "#171717"],
    categorical: [
      "#171717",
      "#DC2626",
      "#FAFAFA",
      "#A3A3A3",
      "#EF4444",
      "#525252"
    ],
    diverging: {
      negative: "#DC2626",
      neutral: "#525252",
      positive: "#171717"
    },
    semantic: {
      positive: "#171717",
      negative: "#DC2626",
      neutral: "#525252",
      warning: "#F59E0B"
    }
  },
  kpiStyling: {
    metricSize: "5xl",
    metricWeight: "bold",
    metricFont: "display",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !1,
    sparklineStyle: "bar",
    cardTreatment: "minimal"
  },
  accents: {
    primary: "0 0% 9%",
    // Near Black
    secondary: "0 72% 51%",
    // Bold Red
    application: {
      buttons: "filled",
      links: "bold-color",
      focus: "outline",
      selection: "bold"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(0 0% 9%) 0%, hsl(0 0% 20%) 100%)",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "smooth",
    interactionScale: {
      hover: 1.03,
      press: 0.97
    },
    pageTransitions: !0,
    listAnimation: "stagger"
  },
  dataAttributes: {
    mode: "light",
    density: "spacious",
    motion: "smooth",
    style: "editorial"
  },
  cssVariables: {
    "--ds-background": "0 0% 100%",
    "--ds-foreground": "0 0% 9%",
    "--ds-surface": "0 0% 100%",
    "--ds-muted": "0 0% 96%",
    "--ds-border": "0 0% 90%"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "lg",
      pill: !1,
      pressable: !0
    },
    Card: {
      variant: "ghost",
      padding: "md",
      hoverable: !0
    },
    Badge: {
      style: "solid",
      size: "sm"
    },
    DataTable: {
      density: "comfortable",
      stripedRows: !1,
      showRowBorders: !1
    },
    KpiCard: {
      elevated: !1,
      displayFont: !0
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    },
    Input: {
      variant: "flushed"
    }
  },
  references: ["https://zara.com", "https://hm.com", "https://cos.com"]
}, re = {
  id: "ecommerce-electronics-tech",
  name: "Electronics Tech",
  description: "Tech-focused editorial design with specification-heavy layouts, comparison tools, and clear product hierarchies. Optimized for electronics, gadgets, and tech retail experiences.",
  category: "e-commerce",
  tags: ["electronics", "tech", "specs", "gadgets", "comparison", "blue", "data-rich", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Crimson Pro", "Lora", Georgia, serif',
      heading: '"Inter var", "Inter", system-ui, sans-serif',
      body: '"Inter var", "Inter", system-ui, sans-serif',
      mono: '"JetBrains Mono", "SF Mono", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "semibold",
      lineHeight: "1.1",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "tight",
      weight: "bold"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.1,
    gapScale: 1,
    sectionSpacing: "normal"
  },
  cards: {
    defaultVariant: "outlined",
    radius: "md",
    showBorder: !0,
    borderStyle: "medium",
    accentEdge: "top",
    elevation: 1,
    hoverEffect: "lift"
  },
  dataViz: {
    sequential: ["#DBEAFE", "#93C5FD", "#3B82F6", "#1D4ED8", "#1E3A8A"],
    categorical: [
      "#1D4ED8",
      "#059669",
      "#DC2626",
      "#F59E0B",
      "#7C3AED",
      "#0891B2"
    ],
    diverging: {
      negative: "#DC2626",
      neutral: "#6B7280",
      positive: "#059669"
    },
    semantic: {
      positive: "#059669",
      negative: "#DC2626",
      neutral: "#6B7280",
      warning: "#F59E0B"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "bold",
    metricFont: "display",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !0,
    sparklineStyle: "line",
    cardTreatment: "bordered"
  },
  accents: {
    primary: "221 83% 53%",
    // Tech Blue
    secondary: "158 64% 42%",
    // Success Green
    application: {
      buttons: "filled",
      links: "color-only",
      focus: "ring",
      selection: "bold"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(221 83% 53%) 0%, hsl(243 75% 59%) 100%)",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "minimal",
    interactionScale: {
      hover: 1.01,
      press: 0.99
    },
    pageTransitions: !1,
    listAnimation: "none"
  },
  dataAttributes: {
    mode: "light",
    density: "comfortable",
    motion: "minimal",
    style: "editorial"
  },
  cssVariables: {
    "--ds-background": "210 20% 98%",
    "--ds-foreground": "222 47% 11%",
    "--ds-surface": "0 0% 100%",
    "--ds-muted": "210 20% 96%",
    "--ds-border": "214 32% 91%"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "md",
      pill: !1,
      pressable: !0
    },
    Card: {
      variant: "outlined",
      padding: "sm",
      hoverable: !0
    },
    Badge: {
      style: "soft",
      size: "sm"
    },
    DataTable: {
      density: "compact",
      stripedRows: !0,
      showRowBorders: !0
    },
    KpiCard: {
      elevated: !1,
      displayFont: !0
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    },
    Input: {
      variant: "default"
    },
    Tabs: {
      variant: "enclosed"
    }
  },
  references: ["https://bestbuy.com", "https://newegg.com", "https://apple.com/shop"]
}, ne = {
  id: "ecommerce-grocery-fresh",
  name: "Grocery Fresh",
  description: "Fresh, vibrant editorial design with organic colors and clean layouts optimized for food and grocery retail. Perfect for meal kits, grocery delivery, and farm-to-table platforms.",
  category: "e-commerce",
  tags: ["grocery", "food", "fresh", "organic", "green", "vibrant", "delivery", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Lora", "Merriweather", Georgia, serif',
      heading: '"DM Sans", "Nunito", system-ui, sans-serif',
      body: '"DM Sans", "Inter", system-ui, sans-serif',
      mono: '"IBM Plex Mono", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "medium",
      lineHeight: "1.1",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "tight",
      weight: "bold"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.15,
    gapScale: 1.1,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "elevated",
    radius: "xl",
    showBorder: !1,
    elevation: 1,
    hoverEffect: "lift"
  },
  dataViz: {
    sequential: ["#ECFDF5", "#A7F3D0", "#34D399", "#10B981", "#047857"],
    categorical: [
      "#10B981",
      "#F97316",
      "#FBBF24",
      "#EF4444",
      "#8B5CF6",
      "#06B6D4"
    ],
    diverging: {
      negative: "#EF4444",
      neutral: "#78716C",
      positive: "#10B981"
    },
    semantic: {
      positive: "#10B981",
      negative: "#EF4444",
      neutral: "#78716C",
      warning: "#F97316"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "bold",
    metricFont: "display",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !0,
    sparklineStyle: "area",
    cardTreatment: "elevated"
  },
  accents: {
    primary: "158 64% 42%",
    // Fresh Green
    secondary: "24 95% 53%",
    // Orange (appetizing)
    application: {
      buttons: "filled",
      links: "color-only",
      focus: "ring",
      selection: "subtle"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(158 64% 42%) 0%, hsl(142 71% 45%) 100%)",
      useOnButtons: !0,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "playful",
    interactionScale: {
      hover: 1.03,
      press: 0.97
    },
    pageTransitions: !0,
    listAnimation: "stagger"
  },
  dataAttributes: {
    mode: "light",
    density: "comfortable",
    motion: "playful",
    style: "editorial"
  },
  cssVariables: {
    "--ds-background": "0 0% 100%",
    "--ds-foreground": "165 8% 17%",
    "--ds-surface": "138 76% 99%",
    "--ds-muted": "138 20% 96%",
    "--ds-border": "138 15% 90%"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "md",
      pill: !0,
      pressable: !0
    },
    Card: {
      variant: "elevated",
      padding: "md",
      hoverable: !0
    },
    Badge: {
      style: "soft",
      size: "md"
    },
    DataTable: {
      density: "comfortable",
      stripedRows: !1,
      showRowBorders: !0
    },
    KpiCard: {
      elevated: !0,
      displayFont: !0
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    },
    Input: {
      variant: "filled"
    }
  },
  references: ["https://instacart.com", "https://wholefoodsmarket.com", "https://freshdirect.com"]
}, oe = {
  id: "ecommerce-handmade-artisan",
  name: "Handmade Artisan",
  description: "Warm, craft-focused editorial design with organic aesthetics and authentic visual language. Perfect for handmade goods, artisan products, and boutique craft marketplaces.",
  category: "e-commerce",
  tags: ["handmade", "artisan", "craft", "warm", "organic", "boutique", "authentic", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Libre Baskerville", "Lora", Georgia, serif',
      heading: '"DM Sans", "Inter", system-ui, sans-serif',
      body: '"DM Sans", "Inter", system-ui, sans-serif',
      mono: '"Courier New", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "normal",
      lineHeight: "1.1",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "normal",
      weight: "semibold"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "relaxed",
    paddingScale: 1.3,
    gapScale: 1.2,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "elevated",
    radius: "lg",
    showBorder: !0,
    borderStyle: "subtle",
    accentEdge: "none",
    elevation: 1,
    hoverEffect: "lift"
  },
  dataViz: {
    sequential: ["#FEF7ED", "#FDBA74", "#FB923C", "#EA580C", "#9A3412"],
    categorical: [
      "#EA580C",
      "#0D9488",
      "#B45309",
      "#78716C",
      "#DC2626",
      "#7C3AED"
    ],
    diverging: {
      negative: "#DC2626",
      neutral: "#78716C",
      positive: "#0D9488"
    },
    semantic: {
      positive: "#0D9488",
      negative: "#DC2626",
      neutral: "#78716C",
      warning: "#B45309"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "semibold",
    metricFont: "display",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !1,
    sparklineStyle: "area",
    cardTreatment: "elevated"
  },
  accents: {
    primary: "24 95% 48%",
    // Warm Orange/Terracotta
    secondary: "174 58% 28%",
    // Muted Teal
    application: {
      buttons: "filled",
      links: "underline",
      focus: "ring",
      selection: "subtle"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(24 95% 48%) 0%, hsl(30 80% 45%) 100%)",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "smooth",
    interactionScale: {
      hover: 1.02,
      press: 0.98
    },
    pageTransitions: !0,
    listAnimation: "fade"
  },
  dataAttributes: {
    mode: "light",
    density: "relaxed",
    motion: "smooth",
    style: "editorial"
  },
  cssVariables: {
    "--ds-background": "36 39% 98%",
    "--ds-foreground": "24 10% 15%",
    "--ds-surface": "36 50% 99%",
    "--ds-muted": "36 33% 95%",
    "--ds-border": "30 20% 88%"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "md",
      pill: !1,
      pressable: !0
    },
    Card: {
      variant: "elevated",
      padding: "lg",
      hoverable: !0
    },
    Badge: {
      style: "soft",
      size: "md"
    },
    DataTable: {
      density: "comfortable",
      stripedRows: !1,
      showRowBorders: !0
    },
    KpiCard: {
      elevated: !0,
      displayFont: !0
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    },
    Input: {
      variant: "default"
    }
  },
  references: ["https://etsy.com/c/handmade", "https://uncommongoods.com", "https://society6.com"]
}, le = {
  id: "ecommerce-streetwear-bold",
  name: "Streetwear Bold",
  description: "Urban, high-contrast editorial design with bold serif typography and aggressive visual language. Perfect for streetwear brands, sneaker marketplaces, and youth-focused fashion retail.",
  category: "e-commerce",
  tags: ["streetwear", "urban", "bold", "high-contrast", "dark", "neon", "sneakers", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Editorial New", "Bodoni Moda", "Didot", Georgia, serif',
      heading: '"Editorial New", "Bodoni Moda", Georgia, serif',
      body: '"Inter var", "Inter", system-ui, sans-serif',
      mono: '"JetBrains Mono", "Fira Code", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "normal",
      lineHeight: "1.0",
      style: "serif"
    },
    scale: {
      displaySize: "6xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "tight",
      weight: "extrabold",
      casing: "uppercase"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.1,
    gapScale: 1,
    sectionSpacing: "normal"
  },
  cards: {
    defaultVariant: "outlined",
    radius: "none",
    showBorder: !0,
    borderStyle: "thick",
    accentEdge: "left",
    elevation: 0,
    hoverEffect: "glow"
  },
  dataViz: {
    sequential: ["#18181B", "#3F3F46", "#71717A", "#A1A1AA", "#F4F4F5"],
    categorical: [
      "#F4F4F5",
      "#EF4444",
      "#22C55E",
      "#FACC15",
      "#3B82F6",
      "#F472B6"
    ],
    diverging: {
      negative: "#EF4444",
      neutral: "#71717A",
      positive: "#22C55E"
    },
    semantic: {
      positive: "#22C55E",
      negative: "#EF4444",
      neutral: "#71717A",
      warning: "#FACC15"
    }
  },
  kpiStyling: {
    metricSize: "5xl",
    metricWeight: "extrabold",
    metricFont: "display",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !0,
    sparklineStyle: "bar",
    cardTreatment: "bordered"
  },
  accents: {
    primary: "0 0% 96%",
    // Near White on Dark
    secondary: "0 84% 60%",
    // Neon Red
    application: {
      buttons: "filled",
      links: "bold-color",
      focus: "glow",
      selection: "bold"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(0 84% 60%) 0%, hsl(335 78% 60%) 100%)",
      useOnButtons: !0,
      useOnCards: !0,
      useOnText: !0
    }
  },
  motion: {
    style: "playful",
    interactionScale: {
      hover: 1.05,
      press: 0.95
    },
    pageTransitions: !0,
    listAnimation: "stagger"
  },
  dataAttributes: {
    mode: "dark",
    density: "comfortable",
    motion: "playful",
    style: "editorial"
  },
  cssVariables: {
    "--ds-background": "0 0% 7%",
    "--ds-foreground": "0 0% 96%",
    "--ds-surface": "0 0% 10%",
    "--ds-card": "0 0% 10%",
    "--ds-muted": "0 0% 15%",
    "--ds-border": "0 0% 20%",
    "--ds-glow-color": "hsl(0 84% 60% / 0.5)"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "lg",
      pill: !1,
      pressable: !0
    },
    Card: {
      variant: "outlined",
      padding: "md",
      hoverable: !0
    },
    Badge: {
      style: "solid",
      size: "sm"
    },
    DataTable: {
      density: "compact",
      stripedRows: !1,
      showRowBorders: !0
    },
    KpiCard: {
      elevated: !1,
      displayFont: !0
    },
    Typography: {
      display: !0,
      serifHeadings: !0,
      gradient: !0
    },
    Input: {
      variant: "filled"
    }
  },
  references: ["https://supremenewyork.com", "https://stockx.com", "https://goat.com"]
}, de = [
  ie,
  te,
  ae,
  se,
  re,
  ne,
  oe,
  le
];
p(de);
const ce = {
  id: "crm-salesforce-style",
  name: "Salesforce Style",
  description: "Enterprise CRM design inspired by Salesforce Lightning with editorial refinement. Professional blues, serif display typography, clear hierarchy, and data-focused layouts optimized for sales teams and complex workflows.",
  category: "crm-system",
  tags: ["enterprise", "salesforce", "professional", "blue", "data-dense", "crm", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Playfair Display", "Libre Baskerville", Georgia, serif',
      heading: '"Salesforce Sans", "SF Pro Text", system-ui, sans-serif',
      body: '"Salesforce Sans", "SF Pro Text", system-ui, sans-serif',
      mono: '"SF Mono", "Consolas", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "semibold",
      lineHeight: "1.1",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "normal",
      weight: "semibold"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "compact",
    paddingScale: 1.1,
    gapScale: 0.9,
    sectionSpacing: "normal"
  },
  cards: {
    defaultVariant: "outlined",
    radius: "md",
    showBorder: !0,
    borderStyle: "subtle",
    accentEdge: "left",
    elevation: 0,
    hoverEffect: "none"
  },
  dataViz: {
    sequential: ["#D4EDFC", "#82CFFF", "#35B4F5", "#0176D3", "#014486"],
    categorical: [
      "#0176D3",
      "#2E844A",
      "#E65100",
      "#BA0517",
      "#5867E8",
      "#C23934"
    ],
    diverging: {
      negative: "#BA0517",
      neutral: "#706E6B",
      positive: "#2E844A"
    },
    semantic: {
      positive: "#2E844A",
      negative: "#BA0517",
      neutral: "#706E6B",
      warning: "#E65100"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "semibold",
    metricFont: "display",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !0,
    sparklineStyle: "bar",
    cardTreatment: "bordered"
  },
  accents: {
    primary: "206 99% 41%",
    // Salesforce Blue
    secondary: "138 56% 40%",
    // Success Green
    application: {
      buttons: "filled",
      links: "color-only",
      focus: "outline",
      selection: "subtle"
    }
  },
  motion: {
    style: "minimal",
    interactionScale: {
      hover: 1,
      press: 1
    },
    pageTransitions: !1,
    listAnimation: "fade"
  },
  dataAttributes: {
    mode: "light",
    density: "compact",
    motion: "minimal",
    style: "editorial"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "md",
      pressable: !1
    },
    Card: {
      variant: "outlined",
      padding: "md",
      hoverable: !1
    },
    Badge: {
      style: "soft",
      size: "sm"
    },
    DataTable: {
      density: "compact",
      stripedRows: !0,
      showRowBorders: !0
    },
    KpiCard: {
      elevated: !1,
      displayFont: !0
    },
    Input: {
      variant: "default"
    },
    Tabs: {
      variant: "underline"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: ["https://salesforce.com", "https://lightning.design"]
}, pe = {
  id: "crm-hubspot-modern",
  name: "HubSpot Modern",
  description: "Friendly, approachable CRM design inspired by HubSpot with editorial refinement. Warm orange accents, serif display typography, generous spacing, and welcoming aesthetics for marketing and sales teams.",
  category: "crm-system",
  tags: ["friendly", "hubspot", "orange", "modern", "approachable", "marketing", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Fraunces", "Playfair Display", Georgia, serif',
      heading: '"Lexend", "Avenir Next", system-ui, sans-serif',
      body: '"Lexend", "Avenir Next", system-ui, sans-serif',
      mono: '"JetBrains Mono", "Fira Code", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "medium",
      lineHeight: "1.1",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "tight",
      weight: "semibold"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.2,
    gapScale: 1.1,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "elevated",
    radius: "xl",
    showBorder: !0,
    borderStyle: "subtle",
    accentEdge: "none",
    elevation: 1,
    hoverEffect: "lift"
  },
  dataViz: {
    sequential: ["#FFF1E6", "#FFD4B2", "#FFAB67", "#FF7A59", "#CC3D22"],
    categorical: [
      "#FF7A59",
      "#00BDA5",
      "#516F90",
      "#F2545B",
      "#7C98B6",
      "#F5C26B"
    ],
    diverging: {
      negative: "#F2545B",
      neutral: "#7C98B6",
      positive: "#00BDA5"
    },
    semantic: {
      positive: "#00BDA5",
      negative: "#F2545B",
      neutral: "#7C98B6",
      warning: "#F5C26B"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "bold",
    metricFont: "display",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !0,
    sparklineStyle: "area",
    cardTreatment: "elevated"
  },
  accents: {
    primary: "14 100% 67%",
    // HubSpot Orange
    secondary: "173 100% 37%",
    // Teal
    application: {
      buttons: "filled",
      links: "color-only",
      focus: "ring",
      selection: "subtle"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(14 100% 67%) 0%, hsl(33 100% 65%) 100%)",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "smooth",
    interactionScale: {
      hover: 1.02,
      press: 0.98
    },
    pageTransitions: !0,
    listAnimation: "stagger"
  },
  dataAttributes: {
    mode: "light",
    density: "comfortable",
    motion: "smooth",
    style: "editorial"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "md",
      pressable: !0,
      pill: !0
    },
    Card: {
      variant: "elevated",
      padding: "lg",
      hoverable: !0
    },
    Badge: {
      style: "soft",
      size: "md"
    },
    DataTable: {
      density: "comfortable",
      stripedRows: !1,
      showRowBorders: !0
    },
    KpiCard: {
      elevated: !0,
      displayFont: !0
    },
    Input: {
      variant: "default"
    },
    Tabs: {
      variant: "pills"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: ["https://hubspot.com", "https://canvas.hubspot.com"]
}, ge = {
  id: "crm-pipeline-focused",
  name: "Pipeline Focused",
  description: "Deal-centric CRM design optimized for sales pipelines and kanban views with editorial refinement. Clear visual hierarchy, serif display typography with stage-based color coding for tracking opportunities.",
  category: "crm-system",
  tags: ["pipeline", "kanban", "sales", "deals", "stages", "visual", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Crimson Pro", "Merriweather", Georgia, serif',
      heading: '"Inter var", "Inter", system-ui, sans-serif',
      body: '"Inter var", "Inter", system-ui, sans-serif',
      mono: '"SF Mono", "Fira Code", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "semibold",
      lineHeight: "1.05",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "tight",
      weight: "semibold"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "compact",
    paddingScale: 1.1,
    gapScale: 0.85,
    sectionSpacing: "normal"
  },
  cards: {
    defaultVariant: "elevated",
    radius: "lg",
    showBorder: !0,
    borderStyle: "subtle",
    accentEdge: "left",
    elevation: 1,
    hoverEffect: "lift"
  },
  dataViz: {
    sequential: ["#EDE9FE", "#C4B5FD", "#8B5CF6", "#7C3AED", "#5B21B6"],
    categorical: [
      "#8B5CF6",
      // Prospect
      "#3B82F6",
      // Qualified
      "#06B6D4",
      // Proposal
      "#10B981",
      // Negotiation
      "#F59E0B",
      // Closing
      "#EF4444"
      // Lost
    ],
    diverging: {
      negative: "#EF4444",
      neutral: "#6B7280",
      positive: "#10B981"
    },
    semantic: {
      positive: "#10B981",
      negative: "#EF4444",
      neutral: "#6B7280",
      warning: "#F59E0B"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "bold",
    metricFont: "display",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !0,
    sparklineStyle: "bar",
    cardTreatment: "minimal"
  },
  accents: {
    primary: "258 90% 66%",
    // Purple (Pipeline)
    secondary: "217 91% 60%",
    // Blue (Secondary)
    application: {
      buttons: "filled",
      links: "color-only",
      focus: "ring",
      selection: "bold"
    },
    gradients: {
      primaryGradient: "linear-gradient(90deg, hsl(258 90% 66%) 0%, hsl(217 91% 60%) 100%)",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "smooth",
    interactionScale: {
      hover: 1.02,
      press: 0.98
    },
    pageTransitions: !0,
    listAnimation: "stagger"
  },
  dataAttributes: {
    mode: "light",
    density: "compact",
    motion: "smooth",
    style: "editorial"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "sm",
      pressable: !0
    },
    Card: {
      variant: "elevated",
      padding: "sm",
      hoverable: !0
    },
    Badge: {
      style: "solid",
      size: "sm"
    },
    DataTable: {
      density: "compact",
      stripedRows: !1,
      showRowBorders: !0
    },
    KpiCard: {
      elevated: !0,
      displayFont: !0
    },
    Input: {
      variant: "default"
    },
    Tabs: {
      variant: "underline"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: ["https://pipedrive.com", "https://close.com"]
}, me = {
  id: "crm-zoho-practical",
  name: "Zoho Practical",
  description: "Practical, feature-rich CRM design inspired by Zoho with editorial refinement. Functional aesthetics with serif display typography for efficient data presentation tailored for small and medium businesses.",
  category: "crm-system",
  tags: ["practical", "zoho", "functional", "smb", "efficient", "red", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Lora", "Libre Baskerville", Georgia, serif',
      heading: '"Roboto", "Open Sans", system-ui, sans-serif',
      body: '"Roboto", "Open Sans", system-ui, sans-serif',
      mono: '"Roboto Mono", "Consolas", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "medium",
      lineHeight: "1.15",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "normal",
      weight: "medium"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "compact",
    paddingScale: 1.1,
    gapScale: 0.85,
    sectionSpacing: "normal"
  },
  cards: {
    defaultVariant: "outlined",
    radius: "sm",
    showBorder: !0,
    borderStyle: "medium",
    accentEdge: "none",
    elevation: 0,
    hoverEffect: "none"
  },
  dataViz: {
    sequential: ["#FFEBEE", "#FFCDD2", "#EF9A9A", "#E53935", "#B71C1C"],
    categorical: [
      "#E53935",
      "#1E88E5",
      "#43A047",
      "#FB8C00",
      "#8E24AA",
      "#00ACC1"
    ],
    diverging: {
      negative: "#E53935",
      neutral: "#757575",
      positive: "#43A047"
    },
    semantic: {
      positive: "#43A047",
      negative: "#E53935",
      neutral: "#757575",
      warning: "#FB8C00"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "semibold",
    metricFont: "display",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !0,
    sparklineStyle: "line",
    cardTreatment: "bordered"
  },
  accents: {
    primary: "4 82% 56%",
    // Zoho Red
    secondary: "212 80% 51%",
    // Blue
    application: {
      buttons: "filled",
      links: "underline",
      focus: "outline",
      selection: "subtle"
    }
  },
  motion: {
    style: "minimal",
    interactionScale: {
      hover: 1,
      press: 1
    },
    pageTransitions: !1,
    listAnimation: "none"
  },
  dataAttributes: {
    mode: "light",
    density: "compact",
    motion: "minimal",
    style: "editorial"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "sm",
      pressable: !1
    },
    Card: {
      variant: "outlined",
      padding: "sm",
      hoverable: !1
    },
    Badge: {
      style: "outline",
      size: "sm"
    },
    DataTable: {
      density: "compact",
      stripedRows: !0,
      showRowBorders: !0
    },
    KpiCard: {
      elevated: !1,
      displayFont: !0
    },
    Input: {
      variant: "filled"
    },
    Tabs: {
      variant: "enclosed"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: ["https://zoho.com/crm", "https://zoho.com"]
}, ue = {
  id: "crm-freshworks-friendly",
  name: "Freshworks Friendly",
  description: "Cheerful, user-friendly CRM design inspired by Freshworks with editorial refinement. Green accents, serif display typography, playful elements, and delightful micro-interactions for customer-centric teams.",
  category: "crm-system",
  tags: ["friendly", "freshworks", "green", "cheerful", "playful", "customer-centric", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Merriweather", "Cormorant Garamond", Georgia, serif',
      heading: '"Nunito Sans", "Open Sans", system-ui, sans-serif',
      body: '"Nunito Sans", "Open Sans", system-ui, sans-serif',
      mono: '"Fira Code", "Consolas", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "normal",
      lineHeight: "1.1",
      style: "serif"
    },
    scale: {
      displaySize: "6xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "normal",
      weight: "bold"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.15,
    gapScale: 1,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "elevated",
    radius: "lg",
    showBorder: !1,
    elevation: 1,
    hoverEffect: "lift"
  },
  dataViz: {
    sequential: ["#D1FAE5", "#6EE7B7", "#34D399", "#10B981", "#047857"],
    categorical: [
      "#10B981",
      "#6366F1",
      "#F59E0B",
      "#EF4444",
      "#EC4899",
      "#14B8A6"
    ],
    diverging: {
      negative: "#EF4444",
      neutral: "#6B7280",
      positive: "#10B981"
    },
    semantic: {
      positive: "#10B981",
      negative: "#EF4444",
      neutral: "#6B7280",
      warning: "#F59E0B"
    }
  },
  kpiStyling: {
    metricSize: "5xl",
    metricWeight: "bold",
    metricFont: "display",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !0,
    sparklineStyle: "area",
    cardTreatment: "elevated"
  },
  accents: {
    primary: "160 84% 39%",
    // Freshworks Green
    secondary: "239 84% 67%",
    // Indigo
    application: {
      buttons: "filled",
      links: "color-only",
      focus: "ring",
      selection: "subtle"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(160 84% 39%) 0%, hsl(173 80% 40%) 100%)",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "playful",
    interactionScale: {
      hover: 1.03,
      press: 0.97
    },
    pageTransitions: !0,
    listAnimation: "stagger"
  },
  dataAttributes: {
    mode: "light",
    density: "comfortable",
    motion: "playful",
    style: "editorial"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "md",
      pressable: !0,
      pill: !0
    },
    Card: {
      variant: "elevated",
      padding: "md",
      hoverable: !0
    },
    Badge: {
      style: "soft",
      size: "md"
    },
    DataTable: {
      density: "comfortable",
      stripedRows: !1,
      showRowBorders: !1
    },
    KpiCard: {
      elevated: !0,
      displayFont: !0
    },
    Input: {
      variant: "default"
    },
    Tabs: {
      variant: "pills"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: ["https://freshworks.com", "https://freshsales.io"]
}, ye = {
  id: "crm-enterprise-crm",
  name: "Enterprise CRM",
  description: "Sophisticated, large-scale CRM design for enterprise organizations with editorial refinement. Navy blue palette, serif display typography, data-dense layouts, and executive-level presentation for complex sales operations.",
  category: "crm-system",
  tags: ["enterprise", "sophisticated", "navy", "executive", "data-dense", "corporate", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Bodoni Moda", "Playfair Display", Georgia, serif',
      heading: '"IBM Plex Sans", "Source Sans 3", system-ui, sans-serif',
      body: '"IBM Plex Sans", "Source Sans 3", system-ui, sans-serif',
      mono: '"IBM Plex Mono", "SF Mono", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "medium",
      lineHeight: "1.0",
      style: "serif"
    },
    scale: {
      displaySize: "6xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "tight",
      weight: "semibold"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "compact",
    paddingScale: 1.1,
    gapScale: 0.9,
    sectionSpacing: "normal"
  },
  cards: {
    defaultVariant: "outlined",
    radius: "md",
    showBorder: !0,
    borderStyle: "medium",
    accentEdge: "top",
    elevation: 0,
    hoverEffect: "none"
  },
  dataViz: {
    sequential: ["#E0E7FF", "#A5B4FC", "#6366F1", "#4338CA", "#1E1B4B"],
    categorical: [
      "#1E3A5F",
      "#0891B2",
      "#059669",
      "#D97706",
      "#DC2626",
      "#7C3AED"
    ],
    diverging: {
      negative: "#DC2626",
      neutral: "#64748B",
      positive: "#059669"
    },
    semantic: {
      positive: "#059669",
      negative: "#DC2626",
      neutral: "#64748B",
      warning: "#D97706"
    }
  },
  kpiStyling: {
    metricSize: "5xl",
    metricWeight: "semibold",
    metricFont: "display",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !0,
    sparklineStyle: "line",
    cardTreatment: "bordered"
  },
  accents: {
    primary: "213 56% 24%",
    // Navy Blue
    secondary: "192 91% 36%",
    // Cyan
    application: {
      buttons: "filled",
      links: "underline",
      focus: "outline",
      selection: "subtle"
    }
  },
  motion: {
    style: "minimal",
    interactionScale: {
      hover: 1,
      press: 1
    },
    pageTransitions: !1,
    listAnimation: "fade"
  },
  dataAttributes: {
    mode: "light",
    density: "compact",
    motion: "minimal",
    style: "editorial"
  },
  cssVariables: {
    "--ds-primary": "213 56% 24%",
    "--ds-primary-foreground": "0 0% 100%"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "md",
      pressable: !1
    },
    Card: {
      variant: "outlined",
      padding: "md",
      hoverable: !1
    },
    Badge: {
      style: "soft",
      size: "sm"
    },
    DataTable: {
      density: "compact",
      stripedRows: !0,
      showRowBorders: !0
    },
    KpiCard: {
      elevated: !1,
      displayFont: !0
    },
    Input: {
      variant: "default"
    },
    Tabs: {
      variant: "underline"
    },
    Modal: {
      size: "lg"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: ["https://dynamics.microsoft.com", "https://oracle.com/cx"]
}, fe = [
  ce,
  pe,
  ge,
  me,
  ue,
  ye
];
p(fe);
const he = {
  id: "marketing-landing-page-bold",
  name: "Landing Page Bold",
  description: "High-impact editorial landing page design with bold serif typography and strong CTAs. Optimized for conversions with attention-grabbing hero sections and clear value propositions.",
  category: "marketing-site",
  tags: ["bold", "landing-page", "conversion", "hero", "cta", "high-impact", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Bodoni Moda", "Playfair Display", Georgia, serif',
      heading: '"Fraunces", "Playfair Display", Georgia, serif',
      body: '"Inter var", "Inter", system-ui, sans-serif',
      mono: '"JetBrains Mono", monospace'
    },
    headings: {
      letterSpacing: "tighter",
      weight: "extrabold"
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "semibold",
      lineHeight: "1.0",
      style: "serif"
    },
    scale: {
      displaySize: "6xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "spacious",
    paddingScale: 1.3,
    gapScale: 1.2,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "elevated",
    radius: "2xl",
    showBorder: !1,
    elevation: 2,
    hoverEffect: "lift"
  },
  dataViz: {
    sequential: ["#FEE2E2", "#FECACA", "#F87171", "#EF4444", "#B91C1C"],
    categorical: [
      "#EF4444",
      "#8B5CF6",
      "#06B6D4",
      "#10B981",
      "#F59E0B",
      "#EC4899"
    ],
    diverging: {
      negative: "#EF4444",
      neutral: "#6B7280",
      positive: "#10B981"
    },
    semantic: {
      positive: "#10B981",
      negative: "#EF4444",
      neutral: "#6B7280",
      warning: "#F59E0B"
    }
  },
  kpiStyling: {
    metricSize: "5xl",
    metricWeight: "extrabold",
    metricFont: "display",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !1,
    sparklineStyle: "area",
    cardTreatment: "elevated"
  },
  accents: {
    primary: "0 84% 60%",
    // Vibrant Red
    secondary: "262 83% 58%",
    // Purple
    application: {
      buttons: "filled",
      links: "bold-color",
      focus: "glow",
      selection: "bold"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(0 84% 60%) 0%, hsl(330 80% 55%) 100%)",
      useOnButtons: !0,
      useOnCards: !1,
      useOnText: !0
    }
  },
  motion: {
    style: "playful",
    interactionScale: {
      hover: 1.05,
      press: 0.95
    },
    pageTransitions: !0,
    listAnimation: "stagger"
  },
  dataAttributes: {
    mode: "light",
    density: "spacious",
    motion: "playful",
    style: "editorial"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "lg",
      pressable: !0
    },
    Card: {
      variant: "elevated",
      padding: "xl",
      hoverable: !0
    },
    Badge: {
      style: "solid",
      size: "md"
    },
    Typography: {
      display: !0,
      gradient: !0,
      serifHeadings: !0
    },
    Modal: {
      size: "md"
    },
    KpiCard: {
      elevated: !0,
      displayFont: !0
    }
  },
  references: ["https://stripe.com", "https://linear.app"]
}, be = {
  id: "marketing-editorial-elegant",
  name: "Editorial Elegant",
  description: "Sophisticated editorial design with refined serif typography and ample whitespace. Perfect for content-heavy marketing sites, magazines, and brand storytelling.",
  category: "marketing-site",
  tags: ["editorial", "elegant", "typography", "whitespace", "sophisticated", "content", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Cormorant Garamond", "Playfair Display", Georgia, serif',
      heading: '"Fraunces", "Playfair Display", Georgia, serif',
      body: '"Source Serif 4", "Charter", Georgia, serif',
      mono: '"IBM Plex Mono", monospace'
    },
    headings: {
      letterSpacing: "tight",
      weight: "medium"
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "normal",
      lineHeight: "1.05",
      style: "serif"
    },
    scale: {
      displaySize: "6xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "relaxed",
    paddingScale: 1.4,
    gapScale: 1.3,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "ghost",
    radius: "none",
    showBorder: !0,
    borderStyle: "subtle",
    accentEdge: "none",
    elevation: 0,
    hoverEffect: "none"
  },
  dataViz: {
    sequential: ["#F5F5F4", "#D6D3D1", "#A8A29E", "#78716C", "#292524"],
    categorical: [
      "#292524",
      "#991B1B",
      "#1E3A8A",
      "#166534",
      "#92400E",
      "#581C87"
    ],
    diverging: {
      negative: "#991B1B",
      neutral: "#78716C",
      positive: "#166534"
    },
    semantic: {
      positive: "#166534",
      negative: "#991B1B",
      neutral: "#78716C",
      warning: "#92400E"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "medium",
    metricFont: "display",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !1,
    sparklineStyle: "line",
    cardTreatment: "minimal"
  },
  accents: {
    primary: "20 14% 12%",
    // Near black
    secondary: "0 72% 35%",
    // Deep burgundy
    application: {
      buttons: "outline",
      links: "underline",
      focus: "outline",
      selection: "subtle"
    }
  },
  motion: {
    style: "minimal",
    interactionScale: {
      hover: 1,
      press: 1
    },
    pageTransitions: !0,
    listAnimation: "fade"
  },
  dataAttributes: {
    mode: "light",
    density: "relaxed",
    motion: "minimal",
    style: "editorial"
  },
  componentDefaults: {
    Button: {
      variant: "outline",
      size: "md",
      pressable: !1
    },
    Card: {
      variant: "ghost",
      padding: "lg",
      hoverable: !1
    },
    Badge: {
      style: "outline",
      size: "sm"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    },
    Tabs: {
      variant: "underline"
    },
    KpiCard: {
      elevated: !1,
      displayFont: !0
    }
  },
  references: ["https://medium.com", "https://nytimes.com"]
}, Se = {
  id: "marketing-product-showcase",
  name: "Product Showcase",
  description: "Clean, editorial product-focused design that puts features front and center. Ideal for showcasing software products, physical goods, or professional services with refined serif typography.",
  category: "marketing-site",
  tags: ["product", "showcase", "features", "clean", "modern", "professional", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Libre Baskerville", "Merriweather", Georgia, serif',
      heading: '"Lora", "Libre Baskerville", Georgia, serif',
      body: '"SF Pro Text", "Inter", system-ui, sans-serif',
      mono: '"SF Mono", "JetBrains Mono", monospace'
    },
    headings: {
      letterSpacing: "tight",
      weight: "semibold"
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "medium",
      lineHeight: "1.1",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.2,
    gapScale: 1.1,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "elevated",
    radius: "xl",
    showBorder: !0,
    borderStyle: "subtle",
    accentEdge: "none",
    elevation: 1,
    hoverEffect: "scale"
  },
  dataViz: {
    sequential: ["#DBEAFE", "#93C5FD", "#3B82F6", "#1D4ED8", "#1E3A8A"],
    categorical: [
      "#3B82F6",
      "#10B981",
      "#F59E0B",
      "#EF4444",
      "#8B5CF6",
      "#EC4899"
    ],
    diverging: {
      negative: "#EF4444",
      neutral: "#6B7280",
      positive: "#10B981"
    },
    semantic: {
      positive: "#10B981",
      negative: "#EF4444",
      neutral: "#6B7280",
      warning: "#F59E0B"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "semibold",
    metricFont: "display",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !0,
    sparklineStyle: "area",
    cardTreatment: "elevated"
  },
  accents: {
    primary: "217 91% 60%",
    // Apple Blue
    secondary: "158 64% 42%",
    // Teal
    application: {
      buttons: "filled",
      links: "color-only",
      focus: "ring",
      selection: "subtle"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(217 91% 60%) 0%, hsl(240 80% 65%) 100%)",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "smooth",
    interactionScale: {
      hover: 1.02,
      press: 0.98
    },
    pageTransitions: !0,
    listAnimation: "stagger"
  },
  dataAttributes: {
    mode: "light",
    density: "comfortable",
    motion: "smooth",
    style: "editorial"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "md",
      pressable: !0
    },
    Card: {
      variant: "elevated",
      padding: "lg",
      hoverable: !0
    },
    Badge: {
      style: "soft",
      size: "md"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    },
    Modal: {
      size: "lg"
    },
    KpiCard: {
      elevated: !0,
      displayFont: !0
    }
  },
  references: ["https://apple.com", "https://notion.so"]
}, ve = {
  id: "marketing-agency-creative",
  name: "Agency Creative",
  description: "Expressive, editorial artistic design for creative agencies and studios. Bold serif typography, experimental layouts, and vibrant color usage that showcases creativity.",
  category: "marketing-site",
  tags: ["creative", "agency", "artistic", "bold", "experimental", "vibrant", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Playfair Display", "Bodoni Moda", Georgia, serif',
      heading: '"Fraunces", "Crimson Pro", Georgia, serif',
      body: '"Manrope", "Inter", system-ui, sans-serif',
      mono: '"Space Mono", "JetBrains Mono", monospace'
    },
    headings: {
      letterSpacing: "tighter",
      weight: "bold",
      casing: "uppercase"
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "semibold",
      lineHeight: "1.0",
      style: "serif"
    },
    scale: {
      displaySize: "6xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "spacious",
    paddingScale: 1.3,
    gapScale: 1.2,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "ghost",
    radius: "none",
    showBorder: !0,
    borderStyle: "thick",
    accentEdge: "none",
    elevation: 0,
    hoverEffect: "scale"
  },
  dataViz: {
    sequential: ["#FDF4FF", "#F5D0FE", "#E879F9", "#C026D3", "#701A75"],
    categorical: [
      "#F43F5E",
      "#FACC15",
      "#22D3EE",
      "#A855F7",
      "#4ADE80",
      "#FB923C"
    ],
    diverging: {
      negative: "#F43F5E",
      neutral: "#71717A",
      positive: "#4ADE80"
    },
    semantic: {
      positive: "#4ADE80",
      negative: "#F43F5E",
      neutral: "#71717A",
      warning: "#FACC15"
    }
  },
  kpiStyling: {
    metricSize: "5xl",
    metricWeight: "bold",
    metricFont: "display",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !1,
    sparklineStyle: "bar",
    cardTreatment: "minimal"
  },
  accents: {
    primary: "333 71% 51%",
    // Hot Pink
    secondary: "48 96% 53%",
    // Yellow
    application: {
      buttons: "outline",
      links: "bold-color",
      focus: "glow",
      selection: "bold"
    },
    gradients: {
      primaryGradient: "linear-gradient(90deg, hsl(333 71% 51%) 0%, hsl(48 96% 53%) 50%, hsl(186 94% 53%) 100%)",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !0
    }
  },
  motion: {
    style: "playful",
    interactionScale: {
      hover: 1.05,
      press: 0.95
    },
    pageTransitions: !0,
    listAnimation: "stagger"
  },
  dataAttributes: {
    mode: "light",
    density: "spacious",
    motion: "playful",
    style: "maximal-luxe"
  },
  cssVariables: {
    "--ds-border-width": "2px"
  },
  componentDefaults: {
    Button: {
      variant: "outline",
      size: "lg",
      pressable: !0
    },
    Card: {
      variant: "ghost",
      padding: "lg",
      hoverable: !0
    },
    Badge: {
      style: "solid",
      size: "md"
    },
    Typography: {
      display: !0,
      gradient: !0,
      serifHeadings: !0
    },
    Tabs: {
      variant: "pills"
    },
    KpiCard: {
      elevated: !1,
      displayFont: !0
    }
  },
  references: ["https://awwwards.com", "https://dribbble.com"]
}, we = {
  id: "marketing-corporate-trust",
  name: "Corporate Trust",
  description: "Professional, trustworthy editorial design for corporate and B2B marketing. Conservative serif aesthetics that convey reliability, credibility, and enterprise-grade quality.",
  category: "marketing-site",
  tags: ["corporate", "trust", "professional", "b2b", "enterprise", "reliable", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Merriweather", "Libre Baskerville", Georgia, serif',
      heading: '"Lora", "Crimson Pro", Georgia, serif',
      body: '"Source Sans 3", "Open Sans", system-ui, sans-serif',
      mono: '"IBM Plex Mono", "Consolas", monospace'
    },
    headings: {
      letterSpacing: "normal",
      weight: "semibold"
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "medium",
      lineHeight: "1.15",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.15,
    gapScale: 1.1,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "outlined",
    radius: "md",
    showBorder: !0,
    borderStyle: "medium",
    accentEdge: "none",
    elevation: 0,
    hoverEffect: "none"
  },
  dataViz: {
    sequential: ["#DBEAFE", "#93C5FD", "#3B82F6", "#1D4ED8", "#1E3A8A"],
    categorical: [
      "#1E3A8A",
      "#047857",
      "#B45309",
      "#BE123C",
      "#6D28D9",
      "#0E7490"
    ],
    diverging: {
      negative: "#BE123C",
      neutral: "#6B7280",
      positive: "#047857"
    },
    semantic: {
      positive: "#047857",
      negative: "#BE123C",
      neutral: "#6B7280",
      warning: "#B45309"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "semibold",
    metricFont: "display",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !0,
    sparklineStyle: "line",
    cardTreatment: "bordered"
  },
  accents: {
    primary: "224 76% 33%",
    // Navy Blue
    secondary: "160 84% 22%",
    // Dark Teal
    application: {
      buttons: "filled",
      links: "underline",
      focus: "outline",
      selection: "subtle"
    }
  },
  motion: {
    style: "minimal",
    interactionScale: {
      hover: 1,
      press: 1
    },
    pageTransitions: !1,
    listAnimation: "fade"
  },
  dataAttributes: {
    mode: "light",
    density: "comfortable",
    motion: "minimal",
    style: "editorial"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "md",
      pressable: !1
    },
    Card: {
      variant: "outlined",
      padding: "md",
      hoverable: !1
    },
    Badge: {
      style: "soft",
      size: "md"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    },
    Tabs: {
      variant: "underline"
    },
    KpiCard: {
      elevated: !1,
      displayFont: !0
    }
  },
  references: ["https://ibm.com", "https://mckinsey.com"]
}, Be = {
  id: "marketing-conversion-focused",
  name: "Conversion Focused",
  description: "Data-driven editorial design optimized for maximum conversions. Clear visual hierarchy with serif typography, prominent CTAs, and minimal distractions to guide users toward action.",
  category: "marketing-site",
  tags: ["conversion", "cta", "optimization", "focused", "clean", "action", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Crimson Pro", "Lora", Georgia, serif',
      heading: '"Libre Baskerville", "Merriweather", Georgia, serif',
      body: '"Inter var", "Inter", system-ui, sans-serif',
      mono: '"JetBrains Mono", monospace'
    },
    headings: {
      letterSpacing: "tight",
      weight: "bold"
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "semibold",
      lineHeight: "1.1",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.2,
    gapScale: 1.1,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "elevated",
    radius: "lg",
    showBorder: !1,
    elevation: 2,
    hoverEffect: "lift"
  },
  dataViz: {
    sequential: ["#DCFCE7", "#86EFAC", "#22C55E", "#16A34A", "#14532D"],
    categorical: [
      "#22C55E",
      "#3B82F6",
      "#F59E0B",
      "#EF4444",
      "#8B5CF6",
      "#EC4899"
    ],
    diverging: {
      negative: "#EF4444",
      neutral: "#6B7280",
      positive: "#22C55E"
    },
    semantic: {
      positive: "#22C55E",
      negative: "#EF4444",
      neutral: "#6B7280",
      warning: "#F59E0B"
    }
  },
  kpiStyling: {
    metricSize: "5xl",
    metricWeight: "bold",
    metricFont: "display",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !0,
    sparklineStyle: "area",
    cardTreatment: "elevated"
  },
  accents: {
    primary: "142 71% 45%",
    // Green (Action)
    secondary: "217 91% 60%",
    // Blue
    application: {
      buttons: "filled",
      links: "color-only",
      focus: "ring",
      selection: "bold"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(142 71% 45%) 0%, hsl(160 84% 39%) 100%)",
      useOnButtons: !0,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "smooth",
    interactionScale: {
      hover: 1.03,
      press: 0.97
    },
    pageTransitions: !0,
    listAnimation: "stagger"
  },
  dataAttributes: {
    mode: "light",
    density: "comfortable",
    motion: "smooth",
    style: "editorial"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "lg",
      pressable: !0
    },
    Card: {
      variant: "elevated",
      padding: "lg",
      hoverable: !0
    },
    Badge: {
      style: "solid",
      size: "md"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    },
    Input: {
      variant: "default"
    },
    Alert: {
      variant: "success"
    },
    KpiCard: {
      elevated: !0,
      displayFont: !0
    }
  },
  references: ["https://basecamp.com", "https://mailchimp.com"]
}, Fe = {
  id: "marketing-brand-storytelling",
  name: "Brand Storytelling",
  description: "Immersive editorial design for narrative-driven brand experiences. Full-bleed imagery, cinematic layouts, refined serif typography, and emotional connections that bring brand stories to life.",
  category: "marketing-site",
  tags: ["storytelling", "immersive", "narrative", "cinematic", "brand", "emotional", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Cormorant Garamond", "Playfair Display", Georgia, serif',
      heading: '"Fraunces", "Libre Baskerville", Georgia, serif',
      body: '"Lato", "Open Sans", system-ui, sans-serif',
      mono: '"DM Mono", "Consolas", monospace'
    },
    headings: {
      letterSpacing: "normal",
      weight: "medium"
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "normal",
      lineHeight: "1.05",
      style: "serif"
    },
    scale: {
      displaySize: "6xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "relaxed",
    paddingScale: 1.5,
    gapScale: 1.4,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "glass",
    radius: "lg",
    showBorder: !1,
    elevation: 0,
    hoverEffect: "none"
  },
  dataViz: {
    sequential: ["#F5F5F4", "#E7E5E4", "#A8A29E", "#57534E", "#1C1917"],
    categorical: [
      "#1C1917",
      "#78350F",
      "#064E3B",
      "#1E3A8A",
      "#4C1D95",
      "#831843"
    ],
    diverging: {
      negative: "#9F1239",
      neutral: "#78716C",
      positive: "#065F46"
    },
    semantic: {
      positive: "#065F46",
      negative: "#9F1239",
      neutral: "#78716C",
      warning: "#92400E"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "medium",
    metricFont: "display",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !1,
    sparklineStyle: "line",
    cardTreatment: "minimal"
  },
  accents: {
    primary: "24 10% 10%",
    // Warm black
    secondary: "24 70% 25%",
    // Warm brown
    application: {
      buttons: "subtle",
      links: "underline",
      focus: "outline",
      selection: "subtle"
    },
    gradients: {
      primaryGradient: "linear-gradient(180deg, transparent 0%, hsl(24 10% 10% / 0.8) 100%)",
      useOnButtons: !1,
      useOnCards: !0,
      useOnText: !1
    }
  },
  motion: {
    style: "smooth",
    interactionScale: {
      hover: 1,
      press: 1
    },
    pageTransitions: !0,
    listAnimation: "fade"
  },
  dataAttributes: {
    mode: "light",
    density: "relaxed",
    motion: "smooth",
    style: "editorial"
  },
  componentDefaults: {
    Button: {
      variant: "ghost",
      size: "lg",
      pressable: !1
    },
    Card: {
      variant: "glass",
      padding: "xl",
      hoverable: !1
    },
    Badge: {
      style: "outline",
      size: "sm"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    },
    Modal: {
      size: "full"
    },
    KpiCard: {
      elevated: !1,
      displayFont: !0
    }
  },
  references: ["https://airbnb.com/about", "https://patagonia.com"]
}, ze = {
  id: "marketing-saas-landing",
  name: "SaaS Landing",
  description: "Modern editorial SaaS landing page design with tech-forward serif aesthetics. Perfect for software products, developer tools, and tech startups seeking a sophisticated look.",
  category: "marketing-site",
  tags: ["saas", "tech", "startup", "modern", "software", "developer", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Editorial New", "Fraunces", Georgia, serif',
      heading: '"Crimson Pro", "Lora", Georgia, serif',
      body: '"Inter var", "Inter", system-ui, sans-serif',
      mono: '"Geist Mono", "JetBrains Mono", monospace'
    },
    headings: {
      letterSpacing: "tight",
      weight: "semibold"
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "medium",
      lineHeight: "1.0",
      style: "serif"
    },
    scale: {
      displaySize: "6xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.2,
    gapScale: 1.1,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "glass",
    radius: "xl",
    showBorder: !0,
    borderStyle: "subtle",
    accentEdge: "none",
    elevation: 0,
    hoverEffect: "glow"
  },
  dataViz: {
    sequential: ["#E0E7FF", "#A5B4FC", "#6366F1", "#4338CA", "#312E81"],
    categorical: [
      "#6366F1",
      "#22D3EE",
      "#A855F7",
      "#F43F5E",
      "#14B8A6",
      "#FACC15"
    ],
    diverging: {
      negative: "#F43F5E",
      neutral: "#71717A",
      positive: "#14B8A6"
    },
    semantic: {
      positive: "#14B8A6",
      negative: "#F43F5E",
      neutral: "#71717A",
      warning: "#FACC15"
    }
  },
  kpiStyling: {
    metricSize: "5xl",
    metricWeight: "bold",
    metricFont: "display",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !0,
    sparklineStyle: "area",
    cardTreatment: "gradient-accent"
  },
  accents: {
    primary: "245 82% 60%",
    // Indigo
    secondary: "186 94% 53%",
    // Cyan
    application: {
      buttons: "filled",
      links: "color-only",
      focus: "glow",
      selection: "subtle"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(245 82% 60%) 0%, hsl(280 85% 60%) 50%, hsl(330 80% 55%) 100%)",
      useOnButtons: !0,
      useOnCards: !0,
      useOnText: !0
    }
  },
  motion: {
    style: "smooth",
    interactionScale: {
      hover: 1.02,
      press: 0.98
    },
    pageTransitions: !0,
    listAnimation: "stagger"
  },
  dataAttributes: {
    mode: "dark",
    density: "comfortable",
    motion: "smooth",
    style: "editorial"
  },
  cssVariables: {
    "--ds-background": "240 10% 4%",
    "--ds-foreground": "0 0% 98%",
    "--ds-surface": "240 6% 10%",
    "--ds-card": "240 6% 10%",
    "--ds-border": "240 5% 17%",
    "--ds-glow-color": "hsl(245 82% 60% / 0.3)"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "md",
      pressable: !0
    },
    Card: {
      variant: "glass",
      padding: "lg",
      hoverable: !0
    },
    Badge: {
      style: "soft",
      size: "md"
    },
    Typography: {
      display: !0,
      gradient: !0,
      serifHeadings: !0
    },
    Input: {
      variant: "filled"
    },
    Tabs: {
      variant: "pills"
    },
    KpiCard: {
      elevated: !1,
      displayFont: !0
    }
  },
  references: ["https://vercel.com", "https://linear.app", "https://raycast.com"]
}, Ce = [
  he,
  be,
  Se,
  ve,
  we,
  Be,
  Fe,
  ze
];
p(Ce);
const Ee = {
  id: "devtools-github-inspired",
  name: "GitHub Inspired",
  description: "Clean, familiar editorial design inspired by GitHub. Serif display typography, excellent readability, subtle borders, and a professional blue accent that developers trust.",
  category: "developer-tools",
  tags: ["github", "clean", "familiar", "code", "developer", "blue", "professional", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Libre Baskerville", "Merriweather", Georgia, "Times New Roman", serif',
      heading: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Noto Sans", Helvetica, Arial, sans-serif',
      body: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Noto Sans", Helvetica, Arial, sans-serif',
      mono: 'ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, "Liberation Mono", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "semibold",
      lineHeight: "1.1",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "normal",
      weight: "semibold"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.1,
    gapScale: 1,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "outlined",
    radius: "md",
    showBorder: !0,
    borderStyle: "medium",
    accentEdge: "none",
    elevation: 0,
    hoverEffect: "none"
  },
  dataViz: {
    sequential: ["#DCE6F3", "#79AAD9", "#0969DA", "#0550AE", "#033D8B"],
    categorical: [
      "#0969DA",
      "#1A7F37",
      "#BF8700",
      "#CF222E",
      "#8250DF",
      "#BF3989"
    ],
    diverging: {
      negative: "#CF222E",
      neutral: "#656D76",
      positive: "#1A7F37"
    },
    semantic: {
      positive: "#1A7F37",
      negative: "#CF222E",
      neutral: "#656D76",
      warning: "#9A6700"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "semibold",
    metricFont: "display",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !0,
    sparklineStyle: "line",
    cardTreatment: "bordered"
  },
  accents: {
    primary: "212 92% 45%",
    // GitHub Blue
    secondary: "140 61% 29%",
    // GitHub Green
    application: {
      buttons: "filled",
      links: "color-only",
      focus: "outline",
      selection: "subtle"
    },
    gradients: {
      primaryGradient: "linear-gradient(180deg, hsl(212 92% 45%) 0%, hsl(212 92% 40%) 100%)",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "minimal",
    interactionScale: {
      hover: 1,
      press: 0.98
    },
    pageTransitions: !1,
    listAnimation: "none"
  },
  dataAttributes: {
    mode: "light",
    density: "comfortable",
    motion: "minimal",
    style: "editorial"
  },
  cssVariables: {
    "--ds-background": "210 17% 98%",
    "--ds-foreground": "215 14% 18%",
    "--ds-surface": "0 0% 100%",
    "--ds-card": "0 0% 100%",
    "--ds-border": "210 18% 87%"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "md",
      pressable: !1
    },
    Card: {
      variant: "outlined",
      padding: "md",
      hoverable: !1
    },
    Badge: {
      style: "soft",
      size: "sm"
    },
    DataTable: {
      density: "comfortable",
      stripedRows: !1,
      showRowBorders: !0
    },
    KpiCard: {
      elevated: !1,
      displayFont: !0
    },
    Input: {
      variant: "default"
    },
    Tabs: {
      variant: "underline"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: ["https://github.com", "https://primer.style"]
}, xe = {
  id: "devtools-vercel-style",
  name: "Vercel Style",
  description: "Minimal black and white editorial design with extremely subtle accents. Serif display typography with ultra-clean interface inspired by Vercel that puts content first.",
  category: "developer-tools",
  tags: ["vercel", "minimal", "monochrome", "black", "white", "clean", "modern", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Playfair Display", "Fraunces", "Bodoni Moda", Georgia, serif',
      heading: '"Geist", "Inter var", system-ui, sans-serif',
      body: '"Geist", "Inter var", system-ui, sans-serif',
      mono: '"Geist Mono", "JetBrains Mono", ui-monospace, monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "medium",
      lineHeight: "1.05",
      style: "serif"
    },
    scale: {
      displaySize: "6xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "tight",
      weight: "medium"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "spacious",
    paddingScale: 1.35,
    gapScale: 1.25,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "outlined",
    radius: "lg",
    showBorder: !0,
    borderStyle: "subtle",
    accentEdge: "none",
    elevation: 0,
    hoverEffect: "none"
  },
  dataViz: {
    sequential: ["#F5F5F5", "#D4D4D4", "#737373", "#404040", "#171717"],
    categorical: [
      "#171717",
      "#0070F3",
      "#7928CA",
      "#F5A623",
      "#FF0080",
      "#00C48B"
    ],
    diverging: {
      negative: "#EE0000",
      neutral: "#737373",
      positive: "#00C48B"
    },
    semantic: {
      positive: "#00C48B",
      negative: "#EE0000",
      neutral: "#737373",
      warning: "#F5A623"
    }
  },
  kpiStyling: {
    metricSize: "5xl",
    metricWeight: "medium",
    metricFont: "display",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !0,
    sparklineStyle: "line",
    cardTreatment: "bordered"
  },
  accents: {
    primary: "0 0% 9%",
    // Near Black
    secondary: "211 100% 48%",
    // Vercel Blue
    application: {
      buttons: "filled",
      links: "color-only",
      focus: "ring",
      selection: "subtle"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(0 0% 0%) 0%, hsl(0 0% 20%) 100%)",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "smooth",
    interactionScale: {
      hover: 1,
      press: 0.98
    },
    pageTransitions: !0,
    listAnimation: "fade"
  },
  dataAttributes: {
    mode: "light",
    density: "spacious",
    motion: "smooth",
    style: "editorial"
  },
  cssVariables: {
    "--ds-background": "0 0% 100%",
    "--ds-foreground": "0 0% 9%",
    "--ds-surface": "0 0% 100%",
    "--ds-card": "0 0% 100%",
    "--ds-border": "0 0% 90%",
    "--ds-muted": "0 0% 96%"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "md",
      pressable: !1,
      pill: !1
    },
    Card: {
      variant: "outlined",
      padding: "lg",
      hoverable: !1
    },
    Badge: {
      style: "outline",
      size: "sm"
    },
    DataTable: {
      density: "comfortable",
      stripedRows: !1,
      showRowBorders: !0
    },
    KpiCard: {
      elevated: !1,
      displayFont: !0
    },
    Input: {
      variant: "default"
    },
    Tabs: {
      variant: "underline"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: ["https://vercel.com", "https://nextjs.org/docs"]
}, Te = {
  id: "devtools-api-console",
  name: "API Console",
  description: "Technical, code-focused editorial design for API documentation and developer consoles. Serif display typography with optimized code snippets and HTTP method color coding.",
  category: "developer-tools",
  tags: ["api", "console", "technical", "code", "documentation", "rest", "developer", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Cormorant Garamond", "Crimson Pro", "Libre Baskerville", Georgia, serif',
      heading: '"Source Sans Pro", "Inter", system-ui, sans-serif',
      body: '"Source Sans Pro", "Inter", system-ui, sans-serif',
      mono: '"Source Code Pro", "Fira Code", ui-monospace, monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "semibold",
      lineHeight: "1.1",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "normal",
      weight: "semibold"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "compact",
    paddingScale: 1.1,
    gapScale: 0.875,
    sectionSpacing: "normal"
  },
  cards: {
    defaultVariant: "outlined",
    radius: "sm",
    showBorder: !0,
    borderStyle: "medium",
    accentEdge: "left",
    elevation: 0,
    hoverEffect: "none"
  },
  dataViz: {
    sequential: ["#EDE9FE", "#C4B5FD", "#8B5CF6", "#6D28D9", "#4C1D95"],
    categorical: [
      "#22C55E",
      // GET - Green
      "#3B82F6",
      // POST - Blue
      "#F59E0B",
      // PUT - Yellow
      "#EF4444",
      // DELETE - Red
      "#8B5CF6",
      // PATCH - Purple
      "#06B6D4"
      // OPTIONS - Cyan
    ],
    diverging: {
      negative: "#EF4444",
      neutral: "#71717A",
      positive: "#22C55E"
    },
    semantic: {
      positive: "#22C55E",
      negative: "#EF4444",
      neutral: "#71717A",
      warning: "#F59E0B"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "semibold",
    metricFont: "display",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !0,
    sparklineStyle: "bar",
    cardTreatment: "bordered"
  },
  accents: {
    primary: "250 89% 63%",
    // Violet for endpoints
    secondary: "142 71% 45%",
    // Green for success
    application: {
      buttons: "outline",
      links: "underline",
      focus: "outline",
      selection: "subtle"
    },
    gradients: {
      primaryGradient: "linear-gradient(90deg, hsl(250 89% 63%) 0%, hsl(280 85% 60%) 100%)",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "minimal",
    interactionScale: {
      hover: 1,
      press: 1
    },
    pageTransitions: !1,
    listAnimation: "none"
  },
  dataAttributes: {
    mode: "light",
    density: "compact",
    motion: "minimal",
    style: "editorial"
  },
  cssVariables: {
    "--ds-background": "240 10% 98%",
    "--ds-foreground": "240 10% 15%",
    "--ds-surface": "0 0% 100%",
    "--ds-card": "0 0% 100%",
    "--ds-border": "240 6% 85%",
    "--ds-code-bg": "240 10% 96%",
    "--ds-http-get": "142 71% 45%",
    "--ds-http-post": "217 91% 60%",
    "--ds-http-put": "38 92% 50%",
    "--ds-http-delete": "0 84% 60%",
    "--ds-http-patch": "250 89% 63%"
  },
  componentDefaults: {
    Button: {
      variant: "outline",
      size: "sm",
      pressable: !1
    },
    Card: {
      variant: "outlined",
      padding: "sm",
      hoverable: !1
    },
    Badge: {
      style: "solid",
      size: "sm"
    },
    DataTable: {
      density: "compact",
      stripedRows: !0,
      showRowBorders: !1
    },
    KpiCard: {
      elevated: !1,
      displayFont: !0
    },
    Input: {
      variant: "filled"
    },
    Tabs: {
      variant: "pills"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: ["https://swagger.io", "https://developer.chrome.com"]
}, De = {
  id: "devtools-ide-dark",
  name: "IDE Dark",
  description: "VS Code inspired dark editorial theme optimized for developer tools. Serif display typography with comfortable contrast ratios for extended coding sessions and familiar syntax highlighting colors.",
  category: "developer-tools",
  tags: ["vscode", "ide", "dark", "coding", "editor", "developer", "night", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Lora", "Merriweather", "Crimson Pro", Georgia, serif',
      heading: '"Segoe UI", system-ui, -apple-system, sans-serif',
      body: '"Segoe UI", system-ui, -apple-system, sans-serif',
      mono: '"Cascadia Code", "Fira Code", "JetBrains Mono", ui-monospace, monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "medium",
      lineHeight: "1.1",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "normal",
      weight: "medium"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "compact",
    paddingScale: 1.1,
    gapScale: 0.875,
    sectionSpacing: "normal"
  },
  cards: {
    defaultVariant: "ghost",
    radius: "sm",
    showBorder: !0,
    borderStyle: "subtle",
    accentEdge: "left",
    elevation: 0,
    hoverEffect: "none"
  },
  dataViz: {
    sequential: ["#1E1E1E", "#37373D", "#4E4E56", "#6E6E7A", "#9D9DA5"],
    categorical: [
      "#569CD6",
      // Blue - keywords
      "#4EC9B0",
      // Teal - types
      "#CE9178",
      // Orange - strings
      "#DCDCAA",
      // Yellow - functions
      "#C586C0",
      // Purple - control
      "#9CDCFE"
      // Light blue - variables
    ],
    diverging: {
      negative: "#F14C4C",
      neutral: "#808080",
      positive: "#89D185"
    },
    semantic: {
      positive: "#89D185",
      negative: "#F14C4C",
      neutral: "#808080",
      warning: "#CCA700"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "medium",
    metricFont: "display",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !0,
    sparklineStyle: "line",
    cardTreatment: "minimal"
  },
  accents: {
    primary: "207 80% 59%",
    // VS Code Blue
    secondary: "174 60% 55%",
    // Teal
    application: {
      buttons: "subtle",
      links: "color-only",
      focus: "outline",
      selection: "bold"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(207 80% 59%) 0%, hsl(174 60% 55%) 100%)",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "minimal",
    interactionScale: {
      hover: 1,
      press: 1
    },
    pageTransitions: !1,
    listAnimation: "none"
  },
  dataAttributes: {
    mode: "dark",
    density: "compact",
    motion: "minimal",
    style: "editorial"
  },
  cssVariables: {
    "--ds-background": "0 0% 12%",
    // #1E1E1E
    "--ds-foreground": "0 0% 85%",
    // #D4D4D4
    "--ds-surface": "0 0% 15%",
    // #252526
    "--ds-card": "0 0% 15%",
    "--ds-border": "0 0% 23%",
    // #3C3C3C
    "--ds-sidebar": "0 0% 14%",
    // #252526
    "--ds-activity-bar": "0 0% 20%",
    // #333333
    "--ds-editor": "0 0% 12%",
    "--ds-line-highlight": "210 13% 20%",
    "--ds-selection": "210 50% 30%"
  },
  componentDefaults: {
    Button: {
      variant: "ghost",
      size: "sm",
      pressable: !1
    },
    Card: {
      variant: "ghost",
      padding: "sm",
      hoverable: !1
    },
    Badge: {
      style: "soft",
      size: "sm"
    },
    DataTable: {
      density: "compact",
      stripedRows: !1,
      showRowBorders: !1
    },
    KpiCard: {
      elevated: !1,
      displayFont: !0
    },
    Input: {
      variant: "filled"
    },
    Tabs: {
      variant: "enclosed"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: ["https://code.visualstudio.com", "https://github.com/microsoft/vscode"]
}, Ae = {
  id: "devtools-stripe-docs",
  name: "Stripe Docs",
  description: "Beautiful editorial documentation design with elegant purple accents. Serif display typography inspired by Stripe's world-class developer documentation with perfect typography and spacing.",
  category: "developer-tools",
  tags: ["stripe", "documentation", "purple", "elegant", "beautiful", "developer", "docs", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Editorial New", "Fraunces", "Playfair Display", Georgia, serif',
      heading: '"Inter var", "Inter", -apple-system, system-ui, sans-serif',
      body: '"Inter var", "Inter", -apple-system, system-ui, sans-serif',
      mono: '"Roboto Mono", "SF Mono", ui-monospace, monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "semibold",
      lineHeight: "1.05",
      style: "serif"
    },
    scale: {
      displaySize: "6xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "tight",
      weight: "semibold"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "spacious",
    paddingScale: 1.25,
    gapScale: 1.125,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "elevated",
    radius: "lg",
    showBorder: !1,
    borderStyle: "subtle",
    accentEdge: "none",
    elevation: 1,
    hoverEffect: "lift"
  },
  dataViz: {
    sequential: ["#F3E8FF", "#D8B4FE", "#A855F7", "#7C3AED", "#5B21B6"],
    categorical: [
      "#635BFF",
      // Stripe Purple
      "#00D4FF",
      // Cyan
      "#FF9F43",
      // Orange
      "#F7B500",
      // Yellow
      "#FF4461",
      // Pink
      "#32D58F"
      // Green
    ],
    diverging: {
      negative: "#FF4461",
      neutral: "#8898AA",
      positive: "#32D58F"
    },
    semantic: {
      positive: "#32D58F",
      negative: "#FF4461",
      neutral: "#8898AA",
      warning: "#F7B500"
    }
  },
  kpiStyling: {
    metricSize: "5xl",
    metricWeight: "semibold",
    metricFont: "display",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !0,
    sparklineStyle: "area",
    cardTreatment: "elevated"
  },
  accents: {
    primary: "245 90% 68%",
    // Stripe Purple #635BFF
    secondary: "184 100% 50%",
    // Cyan
    application: {
      buttons: "filled",
      links: "color-only",
      focus: "ring",
      selection: "subtle"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(245 90% 68%) 0%, hsl(280 70% 60%) 50%, hsl(184 100% 50%) 100%)",
      useOnButtons: !0,
      useOnCards: !1,
      useOnText: !0
    }
  },
  motion: {
    style: "smooth",
    interactionScale: {
      hover: 1.02,
      press: 0.98
    },
    pageTransitions: !0,
    listAnimation: "fade"
  },
  dataAttributes: {
    mode: "light",
    density: "spacious",
    motion: "smooth",
    style: "editorial"
  },
  cssVariables: {
    "--ds-background": "220 20% 99%",
    "--ds-foreground": "210 12% 16%",
    "--ds-surface": "0 0% 100%",
    "--ds-card": "0 0% 100%",
    "--ds-border": "220 13% 91%",
    "--ds-muted": "220 14% 96%",
    "--ds-code-bg": "245 20% 97%",
    "--ds-stripe-gradient": "linear-gradient(135deg, #667eea 0%, #764ba2 50%, #6B8DD6 100%)"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "md",
      pressable: !0,
      pill: !0
    },
    Card: {
      variant: "elevated",
      padding: "lg",
      hoverable: !0
    },
    Badge: {
      style: "soft",
      size: "sm"
    },
    DataTable: {
      density: "comfortable",
      stripedRows: !1,
      showRowBorders: !0
    },
    KpiCard: {
      elevated: !0,
      displayFont: !0
    },
    Input: {
      variant: "default"
    },
    Typography: {
      gradient: !1,
      display: !0,
      serifHeadings: !0
    },
    Tabs: {
      variant: "underline"
    }
  },
  references: ["https://stripe.com/docs", "https://stripe.com/docs/api"]
}, ke = {
  id: "devtools-terminal-green",
  name: "Terminal Green",
  description: "Matrix-inspired green on dark editorial terminal aesthetic. Serif display typography with phosphor green glow effects for CLI tools and hacker-style interfaces.",
  category: "developer-tools",
  tags: ["terminal", "matrix", "green", "hacker", "cli", "monospace", "retro", "dark", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Bodoni Moda", "Playfair Display", "Cormorant Garamond", Georgia, serif',
      heading: '"IBM Plex Mono", "Fira Code", ui-monospace, monospace',
      body: '"IBM Plex Mono", "JetBrains Mono", ui-monospace, monospace',
      mono: '"IBM Plex Mono", "Fira Code", ui-monospace, monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "normal",
      lineHeight: "1.0",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "normal",
      weight: "medium",
      casing: "uppercase"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "compact",
    paddingScale: 1.1,
    gapScale: 0.75,
    sectionSpacing: "normal"
  },
  cards: {
    defaultVariant: "outlined",
    radius: "none",
    showBorder: !0,
    borderStyle: "accent",
    accentEdge: "none",
    elevation: 0,
    hoverEffect: "glow"
  },
  dataViz: {
    sequential: ["#001A00", "#003300", "#00CC00", "#00FF00", "#AAFFAA"],
    categorical: [
      "#00FF00",
      // Bright Green
      "#00FFFF",
      // Cyan
      "#FFFF00",
      // Yellow
      "#FF00FF",
      // Magenta
      "#FF8800",
      // Orange
      "#00FF88"
      // Mint
    ],
    diverging: {
      negative: "#FF3333",
      neutral: "#888888",
      positive: "#00FF00"
    },
    semantic: {
      positive: "#00FF00",
      negative: "#FF3333",
      neutral: "#888888",
      warning: "#FFFF00"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "medium",
    metricFont: "display",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !0,
    sparklineStyle: "line",
    cardTreatment: "bordered"
  },
  accents: {
    primary: "120 100% 50%",
    // Matrix Green #00FF00
    secondary: "180 100% 50%",
    // Cyan
    application: {
      buttons: "outline",
      links: "bold-color",
      focus: "glow",
      selection: "bold"
    },
    gradients: {
      primaryGradient: "linear-gradient(180deg, hsl(120 100% 50%) 0%, hsl(120 100% 30%) 100%)",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !0
    }
  },
  motion: {
    style: "minimal",
    interactionScale: {
      hover: 1,
      press: 1
    },
    pageTransitions: !1,
    listAnimation: "fade"
  },
  dataAttributes: {
    mode: "dark",
    density: "compact",
    motion: "minimal",
    style: "editorial"
  },
  cssVariables: {
    "--ds-background": "120 50% 2%",
    // Near black with green tint
    "--ds-foreground": "120 100% 50%",
    // Matrix green
    "--ds-surface": "120 40% 5%",
    "--ds-card": "120 40% 5%",
    "--ds-border": "120 100% 25%",
    "--ds-muted": "120 30% 15%",
    "--ds-glow-color": "hsl(120 100% 50% / 0.3)",
    "--ds-text-glow": "0 0 10px hsl(120 100% 50% / 0.5)",
    "--ds-cursor-blink": "1s step-end infinite"
  },
  componentDefaults: {
    Button: {
      variant: "outline",
      size: "md",
      pressable: !1
    },
    Card: {
      variant: "outlined",
      padding: "md",
      hoverable: !0
    },
    Badge: {
      style: "outline",
      size: "sm"
    },
    DataTable: {
      density: "compact",
      stripedRows: !1,
      showRowBorders: !0
    },
    KpiCard: {
      elevated: !1,
      displayFont: !0
    },
    Input: {
      variant: "flushed"
    },
    Tabs: {
      variant: "underline"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: ["https://hyper.is", "https://iterm2.com"]
}, Ie = {
  id: "devtools-gitlab-orange",
  name: "GitLab Orange",
  description: "DevOps-focused editorial design with GitLab's signature tangerine orange. Serif display typography optimized for CI/CD pipelines, repository management, and DevOps workflow visualization.",
  category: "developer-tools",
  tags: ["gitlab", "devops", "orange", "cicd", "pipeline", "repository", "developer", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Merriweather", "Lora", "Libre Baskerville", Georgia, serif',
      heading: '"Source Sans Pro", "Inter", system-ui, sans-serif',
      body: '"Source Sans Pro", "Inter", system-ui, sans-serif',
      mono: '"JetBrains Mono", "Source Code Pro", ui-monospace, monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "semibold",
      lineHeight: "1.1",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "normal",
      weight: "semibold"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.15,
    gapScale: 1,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "outlined",
    radius: "md",
    showBorder: !0,
    borderStyle: "medium",
    accentEdge: "left",
    elevation: 0,
    hoverEffect: "none"
  },
  dataViz: {
    sequential: ["#FFECD9", "#FFBF80", "#FC6D26", "#E24329", "#C23420"],
    categorical: [
      "#FC6D26",
      // GitLab Orange
      "#6B4FBB",
      // Purple
      "#1AAA55",
      // Green
      "#428BCA",
      // Blue
      "#DB3B21",
      // Red
      "#FCA326"
      // Yellow
    ],
    diverging: {
      negative: "#DB3B21",
      neutral: "#737278",
      positive: "#1AAA55"
    },
    semantic: {
      positive: "#1AAA55",
      negative: "#DB3B21",
      neutral: "#737278",
      warning: "#FCA326"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "semibold",
    metricFont: "display",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !0,
    sparklineStyle: "bar",
    cardTreatment: "bordered"
  },
  accents: {
    primary: "24 98% 57%",
    // GitLab Orange #FC6D26
    secondary: "256 50% 52%",
    // GitLab Purple
    application: {
      buttons: "filled",
      links: "color-only",
      focus: "outline",
      selection: "subtle"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(14 81% 53%) 0%, hsl(24 98% 57%) 100%)",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "minimal",
    interactionScale: {
      hover: 1,
      press: 0.98
    },
    pageTransitions: !1,
    listAnimation: "none"
  },
  dataAttributes: {
    mode: "light",
    density: "comfortable",
    motion: "minimal",
    style: "editorial"
  },
  cssVariables: {
    "--ds-background": "0 0% 99%",
    "--ds-foreground": "0 0% 20%",
    "--ds-surface": "0 0% 100%",
    "--ds-card": "0 0% 100%",
    "--ds-border": "0 0% 87%",
    "--ds-muted": "0 0% 96%",
    "--ds-pipeline-success": "#1AAA55",
    "--ds-pipeline-failed": "#DB3B21",
    "--ds-pipeline-pending": "#FCA326",
    "--ds-pipeline-running": "#428BCA",
    "--ds-pipeline-canceled": "#737278"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "md",
      pressable: !1
    },
    Card: {
      variant: "outlined",
      padding: "md",
      hoverable: !1
    },
    Badge: {
      style: "solid",
      size: "sm"
    },
    DataTable: {
      density: "comfortable",
      stripedRows: !1,
      showRowBorders: !0
    },
    KpiCard: {
      elevated: !1,
      displayFont: !0
    },
    Input: {
      variant: "default"
    },
    Tabs: {
      variant: "underline"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: ["https://gitlab.com", "https://design.gitlab.com"]
}, Pe = {
  id: "devtools-postman-orange",
  name: "Postman Orange",
  description: "API testing focused editorial design with Postman's warm orange accent. Serif display typography optimized for API development, request builders, response visualization, and team collaboration.",
  category: "developer-tools",
  tags: ["postman", "api", "testing", "orange", "rest", "graphql", "developer", "collaboration", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Crimson Pro", "Lora", "Libre Baskerville", Georgia, serif',
      heading: '"Inter var", "Inter", system-ui, sans-serif',
      body: '"Inter var", "Inter", system-ui, sans-serif',
      mono: '"Fira Code", "JetBrains Mono", ui-monospace, monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "semibold",
      lineHeight: "1.1",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "tight",
      weight: "semibold"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "compact",
    paddingScale: 1.1,
    gapScale: 0.9,
    sectionSpacing: "normal"
  },
  cards: {
    defaultVariant: "elevated",
    radius: "md",
    showBorder: !0,
    borderStyle: "subtle",
    accentEdge: "none",
    elevation: 1,
    hoverEffect: "lift"
  },
  dataViz: {
    sequential: ["#FFF2E6", "#FFD6B3", "#FF9548", "#FF6C37", "#E5501E"],
    categorical: [
      "#FF6C37",
      // Postman Orange
      "#5F9EA0",
      // Teal
      "#9B51E0",
      // Purple
      "#2196F3",
      // Blue
      "#4CAF50",
      // Green
      "#FFC107"
      // Amber
    ],
    diverging: {
      negative: "#FF5252",
      neutral: "#9E9E9E",
      positive: "#4CAF50"
    },
    semantic: {
      positive: "#4CAF50",
      negative: "#FF5252",
      neutral: "#9E9E9E",
      warning: "#FF9800"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "bold",
    metricFont: "display",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !0,
    sparklineStyle: "bar",
    cardTreatment: "elevated"
  },
  accents: {
    primary: "18 100% 61%",
    // Postman Orange #FF6C37
    secondary: "180 25% 50%",
    // Teal
    application: {
      buttons: "filled",
      links: "color-only",
      focus: "ring",
      selection: "subtle"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(18 100% 61%) 0%, hsl(28 100% 55%) 100%)",
      useOnButtons: !0,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "smooth",
    interactionScale: {
      hover: 1.01,
      press: 0.99
    },
    pageTransitions: !0,
    listAnimation: "stagger"
  },
  dataAttributes: {
    mode: "light",
    density: "compact",
    motion: "smooth",
    style: "editorial"
  },
  cssVariables: {
    "--ds-background": "30 25% 98%",
    "--ds-foreground": "0 0% 20%",
    "--ds-surface": "0 0% 100%",
    "--ds-card": "0 0% 100%",
    "--ds-border": "30 10% 90%",
    "--ds-muted": "30 15% 96%",
    "--ds-sidebar": "220 15% 25%",
    "--ds-sidebar-text": "0 0% 95%",
    "--ds-http-get": "#4CAF50",
    "--ds-http-post": "#FF9800",
    "--ds-http-put": "#2196F3",
    "--ds-http-delete": "#FF5252",
    "--ds-http-patch": "#9B51E0",
    "--ds-response-200": "#4CAF50",
    "--ds-response-400": "#FF9800",
    "--ds-response-500": "#FF5252"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "sm",
      pressable: !0
    },
    Card: {
      variant: "elevated",
      padding: "sm",
      hoverable: !0
    },
    Badge: {
      style: "solid",
      size: "sm"
    },
    DataTable: {
      density: "compact",
      stripedRows: !0,
      showRowBorders: !1
    },
    KpiCard: {
      elevated: !0,
      displayFont: !0
    },
    Input: {
      variant: "filled"
    },
    Tabs: {
      variant: "pills"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: ["https://www.postman.com", "https://learning.postman.com"]
}, Me = [
  Ee,
  xe,
  Te,
  De,
  Ae,
  ke,
  Ie,
  Pe
];
p(Me);
const Oe = {
  id: "fintech-banking-professional",
  name: "Banking Professional",
  description: "Traditional, trustworthy banking interface with editorial refinement and serif typography. Conveys stability, security, and financial reliability for established banking applications.",
  category: "fintech",
  tags: ["banking", "professional", "trustworthy", "conservative", "secure", "traditional", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Libre Baskerville", "Georgia", "Times New Roman", serif',
      heading: '"IBM Plex Sans", "Helvetica Neue", system-ui, sans-serif',
      body: '"IBM Plex Sans", "Helvetica Neue", system-ui, sans-serif',
      mono: '"IBM Plex Mono", "Consolas", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "medium",
      lineHeight: "1.1",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "normal",
      weight: "semibold"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.15,
    gapScale: 1.1,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "outlined",
    radius: "md",
    showBorder: !0,
    borderStyle: "medium",
    accentEdge: "none",
    elevation: 0,
    hoverEffect: "none"
  },
  dataViz: {
    sequential: ["#DBEAFE", "#93C5FD", "#3B82F6", "#1D4ED8", "#1E3A8A"],
    categorical: [
      "#1D4ED8",
      "#059669",
      "#0891B2",
      "#7C3AED",
      "#DC2626",
      "#D97706"
    ],
    diverging: {
      negative: "#DC2626",
      neutral: "#6B7280",
      positive: "#059669"
    },
    semantic: {
      positive: "#059669",
      negative: "#DC2626",
      neutral: "#6B7280",
      warning: "#D97706"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "semibold",
    metricFont: "display",
    showTrendArrows: !0,
    sparklineStyle: "line",
    cardTreatment: "bordered",
    labelCasing: "uppercase",
    labelTracking: "widest"
  },
  accents: {
    primary: "221 83% 53%",
    // Deep Blue
    secondary: "160 84% 39%",
    // Banking Green
    application: {
      buttons: "filled",
      links: "underline",
      focus: "outline",
      selection: "subtle"
    }
  },
  motion: {
    style: "minimal",
    interactionScale: {
      hover: 1,
      press: 1
    },
    pageTransitions: !1,
    listAnimation: "fade"
  },
  dataAttributes: {
    mode: "light",
    density: "comfortable",
    motion: "minimal",
    style: "editorial"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "md",
      pressable: !1
    },
    Card: {
      variant: "outlined",
      padding: "md",
      hoverable: !1
    },
    Badge: {
      style: "soft",
      size: "md"
    },
    DataTable: {
      density: "comfortable",
      stripedRows: !0,
      showRowBorders: !0
    },
    KpiCard: {
      elevated: !1,
      displayFont: !0
    },
    Input: {
      variant: "default"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: ["https://chase.com", "https://wellsfargo.com"]
}, Re = {
  id: "fintech-trading-platform",
  name: "Trading Platform",
  description: "High-density, data-rich interface with editorial refinement for trading and market analysis. Dark theme with vibrant indicators and serif display typography for sophisticated financial storytelling.",
  category: "fintech",
  tags: ["trading", "stocks", "crypto", "data-dense", "dark", "real-time", "professional", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Fraunces", "Playfair Display", "Georgia", serif',
      heading: '"Inter var", "Inter", system-ui, sans-serif',
      body: '"Inter var", "Inter", system-ui, sans-serif',
      mono: '"JetBrains Mono", "Fira Code", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "normal",
      lineHeight: "1.05",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "tight",
      weight: "medium"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "compact",
    paddingScale: 1.1,
    gapScale: 0.9,
    sectionSpacing: "normal"
  },
  cards: {
    defaultVariant: "ghost",
    radius: "sm",
    showBorder: !0,
    borderStyle: "subtle",
    accentEdge: "none",
    elevation: 0,
    hoverEffect: "none"
  },
  dataViz: {
    sequential: ["#1E293B", "#334155", "#475569", "#64748B", "#94A3B8"],
    categorical: [
      "#22C55E",
      "#EF4444",
      "#3B82F6",
      "#F59E0B",
      "#8B5CF6",
      "#EC4899"
    ],
    diverging: {
      negative: "#EF4444",
      neutral: "#64748B",
      positive: "#22C55E"
    },
    semantic: {
      positive: "#22C55E",
      negative: "#EF4444",
      neutral: "#64748B",
      warning: "#F59E0B"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "medium",
    metricFont: "display",
    showTrendArrows: !0,
    sparklineStyle: "line",
    cardTreatment: "minimal",
    labelCasing: "uppercase",
    labelTracking: "widest"
  },
  accents: {
    primary: "217 91% 60%",
    // Bright Blue
    secondary: "142 71% 45%",
    // Trading Green
    application: {
      buttons: "subtle",
      links: "color-only",
      focus: "ring",
      selection: "bold"
    }
  },
  motion: {
    style: "minimal",
    interactionScale: {
      hover: 1,
      press: 0.98
    },
    pageTransitions: !1,
    listAnimation: "none"
  },
  dataAttributes: {
    mode: "dark",
    density: "compact",
    motion: "minimal",
    style: "editorial"
  },
  componentDefaults: {
    Button: {
      variant: "ghost",
      size: "sm",
      pressable: !0
    },
    Card: {
      variant: "ghost",
      padding: "sm",
      hoverable: !1
    },
    Badge: {
      style: "solid",
      size: "sm"
    },
    DataTable: {
      density: "compact",
      stripedRows: !1,
      showRowBorders: !0
    },
    KpiCard: {
      elevated: !1,
      displayFont: !0
    },
    Input: {
      variant: "filled"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: ["https://tradingview.com", "https://robinhood.com"]
}, He = {
  id: "fintech-wealth-management",
  name: "Wealth Management",
  description: "Premium, sophisticated interface with editorial serif typography for high-net-worth client portals. Elegant typography, refined color palette, and spacious layouts convey exclusivity and trust.",
  category: "fintech",
  tags: ["wealth", "premium", "luxury", "sophisticated", "elegant", "private-banking", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Cormorant Garamond", "Playfair Display", "Georgia", serif',
      heading: '"DM Sans", "Helvetica Neue", system-ui, sans-serif',
      body: '"DM Sans", "Helvetica Neue", system-ui, sans-serif',
      mono: '"SF Mono", "Monaco", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "medium",
      lineHeight: "1.0",
      style: "serif"
    },
    scale: {
      displaySize: "6xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "normal",
      weight: "medium"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "spacious",
    paddingScale: 1.3,
    gapScale: 1.25,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "elevated",
    radius: "lg",
    showBorder: !0,
    borderStyle: "subtle",
    accentEdge: "top",
    elevation: 1,
    hoverEffect: "lift"
  },
  dataViz: {
    sequential: ["#F5F3F0", "#D4CFC7", "#9A8F82", "#6B5D4D", "#3D3228"],
    categorical: [
      "#0F766E",
      "#1D4ED8",
      "#9A8F82",
      "#7C3AED",
      "#DC2626",
      "#D97706"
    ],
    diverging: {
      negative: "#B91C1C",
      neutral: "#6B5D4D",
      positive: "#0F766E"
    },
    semantic: {
      positive: "#0F766E",
      negative: "#B91C1C",
      neutral: "#6B5D4D",
      warning: "#B45309"
    }
  },
  kpiStyling: {
    metricSize: "5xl",
    metricWeight: "medium",
    metricFont: "display",
    showTrendArrows: !0,
    sparklineStyle: "area",
    cardTreatment: "elevated",
    labelCasing: "uppercase",
    labelTracking: "widest"
  },
  accents: {
    primary: "173 80% 26%",
    // Teal/Emerald
    secondary: "25 95% 50%",
    // Gold accent
    application: {
      buttons: "filled",
      links: "color-only",
      focus: "ring",
      selection: "subtle"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(173 80% 26%) 0%, hsl(173 60% 35%) 100%)",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "smooth",
    interactionScale: {
      hover: 1.01,
      press: 0.99
    },
    pageTransitions: !0,
    listAnimation: "fade"
  },
  dataAttributes: {
    mode: "light",
    density: "spacious",
    motion: "smooth",
    style: "editorial"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "lg",
      pressable: !0
    },
    Card: {
      variant: "elevated",
      padding: "lg",
      hoverable: !0
    },
    Badge: {
      style: "soft",
      size: "md"
    },
    DataTable: {
      density: "comfortable",
      stripedRows: !1,
      showRowBorders: !1
    },
    KpiCard: {
      elevated: !0,
      displayFont: !0
    },
    Input: {
      variant: "default"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: ["https://privatebank.jpmorgan.com", "https://ubs.com"]
}, Ge = {
  id: "fintech-crypto-modern",
  name: "Crypto Modern",
  description: "Bold, futuristic interface with editorial serif typography for cryptocurrency and Web3 applications. Features gradient accents, dark mode aesthetics, and sophisticated typography for the crypto-native audience.",
  category: "fintech",
  tags: ["crypto", "web3", "blockchain", "modern", "dark", "futuristic", "defi", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Bodoni Moda", "Playfair Display", "Georgia", serif',
      heading: '"Space Grotesk", "Inter", system-ui, sans-serif',
      body: '"Inter var", "Inter", system-ui, sans-serif',
      mono: '"JetBrains Mono", "Fira Code", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "normal",
      lineHeight: "1.0",
      style: "serif"
    },
    scale: {
      displaySize: "6xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "tight",
      weight: "bold"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.15,
    gapScale: 1.15,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "glass",
    radius: "xl",
    showBorder: !0,
    borderStyle: "subtle",
    accentEdge: "top-gradient",
    elevation: 1,
    hoverEffect: "glow"
  },
  dataViz: {
    sequential: ["#1E1B4B", "#3730A3", "#6366F1", "#A5B4FC", "#E0E7FF"],
    categorical: [
      "#8B5CF6",
      "#22C55E",
      "#3B82F6",
      "#F59E0B",
      "#EC4899",
      "#06B6D4"
    ],
    diverging: {
      negative: "#EF4444",
      neutral: "#64748B",
      positive: "#22C55E"
    },
    semantic: {
      positive: "#22C55E",
      negative: "#EF4444",
      neutral: "#64748B",
      warning: "#F59E0B"
    }
  },
  kpiStyling: {
    metricSize: "5xl",
    metricWeight: "bold",
    metricFont: "display",
    showTrendArrows: !0,
    sparklineStyle: "area",
    cardTreatment: "gradient-accent",
    labelCasing: "uppercase",
    labelTracking: "widest"
  },
  accents: {
    primary: "263 70% 58%",
    // Purple/Violet
    secondary: "142 71% 45%",
    // Crypto Green
    application: {
      buttons: "filled",
      links: "color-only",
      focus: "glow",
      selection: "bold"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(263 70% 58%) 0%, hsl(330 80% 60%) 50%, hsl(25 95% 60%) 100%)",
      useOnButtons: !0,
      useOnCards: !0,
      useOnText: !0
    }
  },
  motion: {
    style: "playful",
    interactionScale: {
      hover: 1.03,
      press: 0.97
    },
    pageTransitions: !0,
    listAnimation: "stagger"
  },
  dataAttributes: {
    mode: "dark",
    density: "comfortable",
    motion: "playful",
    style: "retrofuture"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "md",
      pill: !0,
      pressable: !0
    },
    Card: {
      variant: "glass",
      padding: "md",
      hoverable: !0
    },
    Badge: {
      style: "solid",
      size: "sm"
    },
    DataTable: {
      density: "comfortable",
      stripedRows: !1,
      showRowBorders: !0
    },
    KpiCard: {
      elevated: !0,
      displayFont: !0
    },
    Input: {
      variant: "filled"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: ["https://coinbase.com", "https://phantom.app"]
}, Ve = {
  id: "fintech-insurance-trust",
  name: "Insurance Trust",
  description: "Reassuring, dependable interface with editorial serif typography for insurance and protection services. Warm, approachable colors with clear information hierarchy to build trust and confidence.",
  category: "fintech",
  tags: ["insurance", "trust", "protection", "security", "reliable", "approachable", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Merriweather", "Georgia", "Times New Roman", serif',
      heading: '"Nunito Sans", "Open Sans", system-ui, sans-serif',
      body: '"Nunito Sans", "Open Sans", system-ui, sans-serif',
      mono: '"Roboto Mono", "Consolas", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "medium",
      lineHeight: "1.1",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "normal",
      weight: "bold"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.2,
    gapScale: 1.15,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "elevated",
    radius: "lg",
    showBorder: !1,
    borderStyle: "subtle",
    accentEdge: "left",
    elevation: 1,
    hoverEffect: "lift"
  },
  dataViz: {
    sequential: ["#ECFDF5", "#A7F3D0", "#34D399", "#059669", "#065F46"],
    categorical: [
      "#0D9488",
      "#2563EB",
      "#7C3AED",
      "#DC2626",
      "#D97706",
      "#EC4899"
    ],
    diverging: {
      negative: "#DC2626",
      neutral: "#6B7280",
      positive: "#0D9488"
    },
    semantic: {
      positive: "#0D9488",
      negative: "#DC2626",
      neutral: "#6B7280",
      warning: "#D97706"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "bold",
    metricFont: "display",
    showTrendArrows: !0,
    sparklineStyle: "area",
    cardTreatment: "elevated",
    labelCasing: "uppercase",
    labelTracking: "widest"
  },
  accents: {
    primary: "172 66% 31%",
    // Teal
    secondary: "221 83% 53%",
    // Blue
    application: {
      buttons: "filled",
      links: "underline",
      focus: "ring",
      selection: "subtle"
    }
  },
  motion: {
    style: "smooth",
    interactionScale: {
      hover: 1.01,
      press: 0.99
    },
    pageTransitions: !0,
    listAnimation: "fade"
  },
  dataAttributes: {
    mode: "light",
    density: "comfortable",
    motion: "smooth",
    style: "editorial"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "lg",
      pressable: !0
    },
    Card: {
      variant: "elevated",
      padding: "lg",
      hoverable: !0
    },
    Badge: {
      style: "soft",
      size: "md"
    },
    DataTable: {
      density: "comfortable",
      stripedRows: !0,
      showRowBorders: !0
    },
    KpiCard: {
      elevated: !0,
      displayFont: !0
    },
    Input: {
      variant: "default"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: ["https://lemonade.com", "https://geico.com"]
}, Le = {
  id: "fintech-payment-gateway",
  name: "Payment Gateway",
  description: "Clean, efficient interface with editorial serif typography for payment processing and checkout experiences. Optimized for conversion with clear CTAs, minimal friction, and trust-building elements.",
  category: "fintech",
  tags: ["payments", "checkout", "e-commerce", "conversion", "clean", "stripe", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Crimson Pro", "Playfair Display", "Georgia", serif',
      heading: '"Inter var", "Inter", system-ui, sans-serif',
      body: '"Inter var", "Inter", system-ui, sans-serif',
      mono: '"SF Mono", "Fira Code", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "semibold",
      lineHeight: "1.1",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "tight",
      weight: "semibold"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    },
    dataIdentifiers: {
      pattern: "[{TYPE}:{ID}]",
      font: "mono",
      size: "xs",
      opacity: 0.5
    }
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.15,
    gapScale: 1.1,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "outlined",
    radius: "lg",
    showBorder: !0,
    borderStyle: "subtle",
    accentEdge: "none",
    elevation: 0,
    hoverEffect: "none"
  },
  dataViz: {
    sequential: ["#E0E7FF", "#A5B4FC", "#6366F1", "#4F46E5", "#3730A3"],
    categorical: [
      "#6366F1",
      "#10B981",
      "#F59E0B",
      "#EF4444",
      "#8B5CF6",
      "#06B6D4"
    ],
    diverging: {
      negative: "#EF4444",
      neutral: "#6B7280",
      positive: "#10B981"
    },
    semantic: {
      positive: "#10B981",
      negative: "#EF4444",
      neutral: "#6B7280",
      warning: "#F59E0B"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "semibold",
    metricFont: "display",
    showTrendArrows: !0,
    sparklineStyle: "line",
    cardTreatment: "bordered",
    labelCasing: "uppercase",
    labelTracking: "widest"
  },
  accents: {
    primary: "239 84% 67%",
    // Indigo (Stripe-like)
    secondary: "158 64% 42%",
    // Green for success states
    application: {
      buttons: "filled",
      links: "color-only",
      focus: "ring",
      selection: "subtle"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(239 84% 67%) 0%, hsl(280 75% 60%) 100%)",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "smooth",
    interactionScale: {
      hover: 1.02,
      press: 0.98
    },
    pageTransitions: !1,
    listAnimation: "fade"
  },
  dataAttributes: {
    mode: "light",
    density: "comfortable",
    motion: "smooth",
    style: "editorial"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "md",
      pressable: !0
    },
    Card: {
      variant: "outlined",
      padding: "md",
      hoverable: !1
    },
    Badge: {
      style: "soft",
      size: "sm"
    },
    DataTable: {
      density: "comfortable",
      stripedRows: !1,
      showRowBorders: !0
    },
    KpiCard: {
      elevated: !1,
      displayFont: !0
    },
    Input: {
      variant: "default"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: ["https://stripe.com", "https://squareup.com"]
}, We = [
  Oe,
  Re,
  He,
  Ge,
  Ve,
  Le
];
p(We);
const qe = {
  id: "healthcare-clinical-clean",
  name: "Clinical Clean",
  description: "Professional, sterile interface for clinical and medical applications. High-contrast, accessible design prioritizing clarity and precision for healthcare professionals. Features editorial serif typography for refined authority.",
  category: "healthcare",
  tags: ["clinical", "medical", "professional", "clean", "sterile", "accessible", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Playfair Display", "Libre Baskerville", Georgia, serif',
      heading: '"Inter var", "Inter", system-ui, sans-serif',
      body: '"Inter var", "Inter", system-ui, sans-serif',
      mono: '"Roboto Mono", "Consolas", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "medium",
      lineHeight: "1.1",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "normal",
      weight: "semibold"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "semibold",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    }
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.15,
    gapScale: 1.1,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "outlined",
    radius: "md",
    showBorder: !0,
    borderStyle: "medium",
    accentEdge: "none",
    elevation: 0,
    hoverEffect: "none"
  },
  dataViz: {
    sequential: ["#E0F2FE", "#7DD3FC", "#38BDF8", "#0284C7", "#075985"],
    categorical: [
      "#0284C7",
      "#059669",
      "#7C3AED",
      "#DC2626",
      "#D97706",
      "#EC4899"
    ],
    diverging: {
      negative: "#DC2626",
      neutral: "#6B7280",
      positive: "#059669"
    },
    semantic: {
      positive: "#059669",
      negative: "#DC2626",
      neutral: "#6B7280",
      warning: "#D97706"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "semibold",
    metricFont: "display",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !0,
    sparklineStyle: "line",
    cardTreatment: "bordered"
  },
  accents: {
    primary: "199 89% 48%",
    // Medical Blue
    secondary: "160 84% 39%",
    // Healthcare Green
    application: {
      buttons: "filled",
      links: "underline",
      focus: "outline",
      selection: "subtle"
    }
  },
  motion: {
    style: "minimal",
    interactionScale: {
      hover: 1,
      press: 1
    },
    pageTransitions: !1,
    listAnimation: "fade"
  },
  dataAttributes: {
    mode: "light",
    density: "comfortable",
    motion: "minimal",
    style: "editorial"
  },
  dataIdentifiers: {
    pattern: "[{TYPE}:{ID}]"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "md",
      pressable: !1
    },
    Card: {
      variant: "outlined",
      padding: "md",
      hoverable: !1
    },
    Badge: {
      style: "soft",
      size: "md"
    },
    DataTable: {
      density: "comfortable",
      stripedRows: !0,
      showRowBorders: !0
    },
    KpiCard: {
      elevated: !1,
      displayFont: !0
    },
    Input: {
      variant: "default"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: ["https://epic.com", "https://cerner.com"]
}, Ke = {
  id: "healthcare-patient-portal",
  name: "Patient Portal",
  description: "Friendly, accessible interface for patient-facing healthcare applications. Large touch targets, clear typography, and calming colors make health management approachable. Features editorial serif typography for warmth and trust.",
  category: "healthcare",
  tags: ["patient", "portal", "accessible", "friendly", "user-friendly", "calming", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Merriweather", "Lora", Georgia, serif',
      heading: '"Nunito Sans", "Open Sans", system-ui, sans-serif',
      body: '"Nunito Sans", "Open Sans", system-ui, sans-serif',
      mono: '"Roboto Mono", "Consolas", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "normal",
      lineHeight: "1.15",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "normal",
      weight: "bold"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "semibold",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    }
  },
  spacing: {
    density: "spacious",
    paddingScale: 1.25,
    gapScale: 1.2,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "elevated",
    radius: "xl",
    showBorder: !1,
    borderStyle: "subtle",
    accentEdge: "left",
    elevation: 1,
    hoverEffect: "lift"
  },
  dataViz: {
    sequential: ["#ECFEFF", "#A5F3FC", "#22D3EE", "#0891B2", "#155E75"],
    categorical: [
      "#0891B2",
      "#059669",
      "#7C3AED",
      "#E11D48",
      "#EA580C",
      "#EC4899"
    ],
    diverging: {
      negative: "#E11D48",
      neutral: "#6B7280",
      positive: "#059669"
    },
    semantic: {
      positive: "#059669",
      negative: "#E11D48",
      neutral: "#6B7280",
      warning: "#EA580C"
    }
  },
  kpiStyling: {
    metricSize: "5xl",
    metricWeight: "bold",
    metricFont: "display",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !0,
    sparklineStyle: "area",
    cardTreatment: "elevated"
  },
  accents: {
    primary: "189 94% 43%",
    // Calming Cyan
    secondary: "160 84% 39%",
    // Health Green
    application: {
      buttons: "filled",
      links: "underline",
      focus: "ring",
      selection: "subtle"
    }
  },
  motion: {
    style: "smooth",
    interactionScale: {
      hover: 1.02,
      press: 0.98
    },
    pageTransitions: !0,
    listAnimation: "fade"
  },
  dataAttributes: {
    mode: "light",
    density: "spacious",
    motion: "smooth",
    style: "editorial"
  },
  dataIdentifiers: {
    pattern: "[{TYPE}:{ID}]"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "lg",
      pressable: !0
    },
    Card: {
      variant: "elevated",
      padding: "lg",
      hoverable: !0
    },
    Badge: {
      style: "soft",
      size: "md"
    },
    DataTable: {
      density: "spacious",
      stripedRows: !0,
      showRowBorders: !0
    },
    KpiCard: {
      elevated: !0,
      displayFont: !0
    },
    Input: {
      variant: "default"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: ["https://myhealth.stanfordhealthcare.org", "https://patient.clevelandclinic.org"]
}, Ye = {
  id: "healthcare-telehealth-friendly",
  name: "Telehealth Friendly",
  description: "Modern, approachable interface for virtual healthcare and telemedicine. Warm colors and intuitive layouts create a comfortable environment for remote consultations. Features editorial serif typography for refined calm.",
  category: "healthcare",
  tags: ["telehealth", "telemedicine", "virtual", "modern", "friendly", "remote-care", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Fraunces", "Crimson Pro", Georgia, serif',
      heading: '"DM Sans", "Helvetica Neue", system-ui, sans-serif',
      body: '"DM Sans", "Helvetica Neue", system-ui, sans-serif',
      mono: '"SF Mono", "Monaco", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "medium",
      lineHeight: "1.1",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "tight",
      weight: "semibold"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    }
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.15,
    gapScale: 1.1,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "elevated",
    radius: "xl",
    showBorder: !0,
    borderStyle: "subtle",
    accentEdge: "none",
    elevation: 1,
    hoverEffect: "lift"
  },
  dataViz: {
    sequential: ["#FEF3C7", "#FDE68A", "#FBBF24", "#D97706", "#92400E"],
    categorical: [
      "#0D9488",
      "#2563EB",
      "#7C3AED",
      "#DC2626",
      "#D97706",
      "#EC4899"
    ],
    diverging: {
      negative: "#DC2626",
      neutral: "#6B7280",
      positive: "#0D9488"
    },
    semantic: {
      positive: "#0D9488",
      negative: "#DC2626",
      neutral: "#6B7280",
      warning: "#D97706"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "semibold",
    metricFont: "display",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !0,
    sparklineStyle: "area",
    cardTreatment: "elevated"
  },
  accents: {
    primary: "172 66% 31%",
    // Teal
    secondary: "37 91% 55%",
    // Warm Amber
    application: {
      buttons: "filled",
      links: "color-only",
      focus: "ring",
      selection: "subtle"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(172 66% 31%) 0%, hsl(172 50% 45%) 100%)",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "smooth",
    interactionScale: {
      hover: 1.02,
      press: 0.98
    },
    pageTransitions: !0,
    listAnimation: "stagger"
  },
  dataAttributes: {
    mode: "light",
    density: "comfortable",
    motion: "smooth",
    style: "editorial"
  },
  dataIdentifiers: {
    pattern: "[{TYPE}:{ID}]"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "md",
      pressable: !0
    },
    Card: {
      variant: "elevated",
      padding: "md",
      hoverable: !0
    },
    Badge: {
      style: "soft",
      size: "md"
    },
    DataTable: {
      density: "comfortable",
      stripedRows: !1,
      showRowBorders: !0
    },
    KpiCard: {
      elevated: !0,
      displayFont: !0
    },
    Input: {
      variant: "default"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: ["https://teladoc.com", "https://amwell.com"]
}, Ne = {
  id: "healthcare-medical-records",
  name: "Medical Records",
  description: "Data-dense, highly structured interface for electronic health records (EHR). Compact layouts with clear visual hierarchy for efficient patient data management. Features editorial serif typography for authoritative presentation.",
  category: "healthcare",
  tags: ["ehr", "emr", "records", "data-dense", "clinical", "structured", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Cormorant Garamond", "Libre Baskerville", Georgia, serif',
      heading: '"IBM Plex Sans", "Helvetica Neue", system-ui, sans-serif',
      body: '"IBM Plex Sans", "Helvetica Neue", system-ui, sans-serif',
      mono: '"IBM Plex Mono", "Consolas", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "semibold",
      lineHeight: "1.0",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "normal",
      weight: "semibold"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "semibold",
      casing: "uppercase",
      size: "xxs",
      font: "mono"
    }
  },
  spacing: {
    density: "compact",
    paddingScale: 1.1,
    gapScale: 1,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "outlined",
    radius: "sm",
    showBorder: !0,
    borderStyle: "medium",
    accentEdge: "top",
    elevation: 0,
    hoverEffect: "none"
  },
  dataViz: {
    sequential: ["#DBEAFE", "#93C5FD", "#3B82F6", "#1D4ED8", "#1E3A8A"],
    categorical: [
      "#1D4ED8",
      "#059669",
      "#7C3AED",
      "#DC2626",
      "#D97706",
      "#0891B2"
    ],
    diverging: {
      negative: "#DC2626",
      neutral: "#6B7280",
      positive: "#059669"
    },
    semantic: {
      positive: "#059669",
      negative: "#DC2626",
      neutral: "#6B7280",
      warning: "#D97706"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "semibold",
    metricFont: "display",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !0,
    sparklineStyle: "line",
    cardTreatment: "bordered"
  },
  accents: {
    primary: "221 83% 53%",
    // Deep Blue
    secondary: "160 84% 39%",
    // Medical Green
    application: {
      buttons: "filled",
      links: "color-only",
      focus: "outline",
      selection: "bold"
    }
  },
  motion: {
    style: "minimal",
    interactionScale: {
      hover: 1,
      press: 1
    },
    pageTransitions: !1,
    listAnimation: "none"
  },
  dataAttributes: {
    mode: "light",
    density: "compact",
    motion: "minimal",
    style: "editorial"
  },
  dataIdentifiers: {
    pattern: "[{TYPE}:{ID}]"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "sm",
      pressable: !1
    },
    Card: {
      variant: "outlined",
      padding: "sm",
      hoverable: !1
    },
    Badge: {
      style: "solid",
      size: "sm"
    },
    DataTable: {
      density: "compact",
      stripedRows: !0,
      showRowBorders: !0
    },
    KpiCard: {
      elevated: !1,
      displayFont: !0
    },
    Input: {
      variant: "default"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: ["https://epic.com", "https://athenahealth.com"]
}, Ue = {
  id: "healthcare-wellness-app",
  name: "Wellness App",
  description: "Fresh, energetic interface for health and wellness applications. Vibrant gradients, playful animations, and encouraging design patterns to motivate healthy habits. Features editorial serif typography for inspiring premium feel.",
  category: "healthcare",
  tags: ["wellness", "fitness", "health-tracking", "motivational", "fresh", "energetic", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Editorial New", "Bodoni Moda", Georgia, serif',
      heading: '"Plus Jakarta Sans", "Inter", system-ui, sans-serif',
      body: '"Inter var", "Inter", system-ui, sans-serif',
      mono: '"JetBrains Mono", "Fira Code", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "medium",
      lineHeight: "1.05",
      style: "serif"
    },
    scale: {
      displaySize: "6xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "tight",
      weight: "bold"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    }
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.2,
    gapScale: 1.15,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "elevated",
    radius: "2xl",
    showBorder: !1,
    borderStyle: "subtle",
    accentEdge: "top-gradient",
    elevation: 2,
    hoverEffect: "scale"
  },
  dataViz: {
    sequential: ["#ECFDF5", "#A7F3D0", "#34D399", "#10B981", "#047857"],
    categorical: [
      "#10B981",
      "#8B5CF6",
      "#F59E0B",
      "#EF4444",
      "#06B6D4",
      "#EC4899"
    ],
    diverging: {
      negative: "#EF4444",
      neutral: "#6B7280",
      positive: "#10B981"
    },
    semantic: {
      positive: "#10B981",
      negative: "#EF4444",
      neutral: "#6B7280",
      warning: "#F59E0B"
    }
  },
  kpiStyling: {
    metricSize: "5xl",
    metricWeight: "extrabold",
    metricFont: "display",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !0,
    sparklineStyle: "area",
    cardTreatment: "gradient-accent"
  },
  accents: {
    primary: "160 84% 39%",
    // Emerald Green
    secondary: "263 70% 58%",
    // Purple
    application: {
      buttons: "filled",
      links: "color-only",
      focus: "glow",
      selection: "bold"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(160 84% 39%) 0%, hsl(180 70% 45%) 100%)",
      useOnButtons: !0,
      useOnCards: !0,
      useOnText: !1
    }
  },
  motion: {
    style: "playful",
    interactionScale: {
      hover: 1.04,
      press: 0.96
    },
    pageTransitions: !0,
    listAnimation: "stagger"
  },
  dataAttributes: {
    mode: "light",
    density: "comfortable",
    motion: "playful",
    style: "editorial"
  },
  dataIdentifiers: {
    pattern: "[{TYPE}:{ID}]"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "lg",
      pill: !0,
      pressable: !0
    },
    Card: {
      variant: "elevated",
      padding: "lg",
      hoverable: !0
    },
    Badge: {
      style: "soft",
      size: "md"
    },
    DataTable: {
      density: "comfortable",
      stripedRows: !1,
      showRowBorders: !1
    },
    KpiCard: {
      elevated: !0,
      displayFont: !0
    },
    Input: {
      variant: "filled"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: ["https://noom.com", "https://headspace.com"]
}, Je = {
  id: "healthcare-pharmacy-bright",
  name: "Pharmacy Bright",
  description: "Clean, bright interface for pharmacy and medication management. High-contrast design with clear visual hierarchy ensures safe and efficient medication handling. Features editorial serif typography for trustworthy refinement.",
  category: "healthcare",
  tags: ["pharmacy", "medication", "prescription", "bright", "safe", "clear", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Lora", "Crimson Pro", Georgia, serif',
      heading: '"Source Sans 3", "Source Sans Pro", system-ui, sans-serif',
      body: '"Source Sans 3", "Source Sans Pro", system-ui, sans-serif',
      mono: '"Roboto Mono", "Consolas", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "medium",
      lineHeight: "1.1",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "normal",
      weight: "bold"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "semibold",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    }
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.15,
    gapScale: 1.1,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "elevated",
    radius: "lg",
    showBorder: !0,
    borderStyle: "subtle",
    accentEdge: "left",
    elevation: 1,
    hoverEffect: "lift"
  },
  dataViz: {
    sequential: ["#FEE2E2", "#FECACA", "#F87171", "#DC2626", "#991B1B"],
    categorical: [
      "#2563EB",
      "#DC2626",
      "#059669",
      "#7C3AED",
      "#D97706",
      "#0891B2"
    ],
    diverging: {
      negative: "#DC2626",
      neutral: "#6B7280",
      positive: "#059669"
    },
    semantic: {
      positive: "#059669",
      negative: "#DC2626",
      neutral: "#6B7280",
      warning: "#D97706"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "bold",
    metricFont: "display",
    labelCasing: "uppercase",
    labelTracking: "widest",
    showTrendArrows: !0,
    sparklineStyle: "bar",
    cardTreatment: "elevated"
  },
  accents: {
    primary: "217 91% 60%",
    // Pharmacy Blue
    secondary: "0 72% 51%",
    // Alert Red (for warnings)
    application: {
      buttons: "filled",
      links: "underline",
      focus: "ring",
      selection: "subtle"
    }
  },
  motion: {
    style: "smooth",
    interactionScale: {
      hover: 1.01,
      press: 0.99
    },
    pageTransitions: !1,
    listAnimation: "fade"
  },
  dataAttributes: {
    mode: "light",
    density: "comfortable",
    motion: "smooth",
    style: "editorial"
  },
  dataIdentifiers: {
    pattern: "[{TYPE}:{ID}]"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "md",
      pressable: !0
    },
    Card: {
      variant: "elevated",
      padding: "md",
      hoverable: !0
    },
    Badge: {
      style: "solid",
      size: "md"
    },
    DataTable: {
      density: "comfortable",
      stripedRows: !0,
      showRowBorders: !0
    },
    KpiCard: {
      elevated: !0,
      displayFont: !0
    },
    Input: {
      variant: "default"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: ["https://cvs.com", "https://walgreens.com"]
}, $e = [
  qe,
  Ke,
  Ye,
  Ne,
  Ue,
  Je
];
p($e);
const je = {
  id: "education-learning-platform",
  name: "Learning Platform",
  description: "Modern e-learning platform with editorial serif typography, excellent readability, progress tracking, and engaging course layouts. Perfect for online courses and educational content.",
  category: "education",
  tags: ["learning", "courses", "e-learning", "modern", "accessible", "blue", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Playfair Display", "Libre Baskerville", Georgia, serif',
      heading: '"Playfair Display", "Libre Baskerville", Georgia, serif',
      body: '"Source Sans 3", "Source Sans Pro", system-ui, sans-serif',
      mono: '"Source Code Pro", "Fira Code", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "medium",
      lineHeight: "1.1",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "-0.01em",
      weight: "semibold"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "semibold",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    }
  },
  dataIdentifiers: {
    pattern: "[{TYPE}:{ID}]"
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.15,
    gapScale: 1.1,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "elevated",
    radius: "lg",
    showBorder: !1,
    borderStyle: "subtle",
    accentEdge: "none",
    elevation: 1,
    hoverEffect: "lift"
  },
  dataViz: {
    sequential: ["#DBEAFE", "#93C5FD", "#3B82F6", "#1D4ED8", "#1E3A8A"],
    categorical: [
      "#3B82F6",
      "#10B981",
      "#F59E0B",
      "#8B5CF6",
      "#EC4899",
      "#06B6D4"
    ],
    diverging: {
      negative: "#EF4444",
      neutral: "#6B7280",
      positive: "#10B981"
    },
    semantic: {
      positive: "#10B981",
      negative: "#EF4444",
      neutral: "#6B7280",
      warning: "#F59E0B"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "bold",
    metricFont: "display",
    showTrendArrows: !0,
    sparklineStyle: "line",
    cardTreatment: "elevated",
    labelCasing: "uppercase",
    labelTracking: "widest"
  },
  accents: {
    primary: "217 91% 60%",
    // Blue
    secondary: "158 64% 42%",
    // Emerald
    application: {
      buttons: "filled",
      links: "color-only",
      focus: "ring",
      selection: "subtle"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(217 91% 60%) 0%, hsl(199 89% 48%) 100%)",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "smooth",
    interactionScale: {
      hover: 1.02,
      press: 0.98
    },
    pageTransitions: !0,
    listAnimation: "fade"
  },
  dataAttributes: {
    mode: "light",
    density: "comfortable",
    motion: "smooth",
    style: "editorial"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "md",
      pressable: !0
    },
    Card: {
      variant: "elevated",
      padding: "lg",
      hoverable: !0
    },
    Badge: {
      style: "soft",
      size: "md"
    },
    DataTable: {
      density: "comfortable",
      stripedRows: !1,
      showRowBorders: !0
    },
    KpiCard: {
      elevated: !0,
      displayFont: !0
    },
    Input: {
      variant: "default"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: ["https://coursera.org", "https://udemy.com", "https://khanacademy.org"]
}, Qe = {
  id: "education-university-portal",
  name: "University Portal",
  description: "Traditional academic institution design with editorial serif typography, structured layouts, and professional aesthetics. Ideal for university portals and LMS systems.",
  category: "education",
  tags: ["university", "academic", "formal", "traditional", "institutional", "navy", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Cormorant Garamond", "Merriweather", Georgia, serif',
      heading: '"Cormorant Garamond", "Merriweather", Georgia, serif',
      body: '"Open Sans", "Helvetica Neue", sans-serif',
      mono: '"Roboto Mono", "Consolas", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "semibold",
      lineHeight: "1.05",
      style: "serif"
    },
    scale: {
      displaySize: "6xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "normal",
      weight: "bold"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "semibold",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    }
  },
  dataIdentifiers: {
    pattern: "[{TYPE}:{ID}]"
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.1,
    gapScale: 1,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "outlined",
    radius: "md",
    showBorder: !0,
    borderStyle: "medium",
    accentEdge: "top",
    elevation: 0,
    hoverEffect: "none"
  },
  dataViz: {
    sequential: ["#E0E7FF", "#A5B4FC", "#6366F1", "#4338CA", "#312E81"],
    categorical: [
      "#1E3A5F",
      "#B8860B",
      "#8B0000",
      "#006400",
      "#4B0082",
      "#2F4F4F"
    ],
    diverging: {
      negative: "#DC2626",
      neutral: "#6B7280",
      positive: "#059669"
    },
    semantic: {
      positive: "#059669",
      negative: "#DC2626",
      neutral: "#6B7280",
      warning: "#D97706"
    }
  },
  kpiStyling: {
    metricSize: "5xl",
    metricWeight: "bold",
    metricFont: "display",
    showTrendArrows: !0,
    sparklineStyle: "bar",
    cardTreatment: "bordered",
    labelCasing: "uppercase",
    labelTracking: "widest"
  },
  accents: {
    primary: "213 64% 24%",
    // Navy Blue
    secondary: "43 74% 49%",
    // Gold
    application: {
      buttons: "filled",
      links: "underline",
      focus: "outline",
      selection: "bold"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(213 64% 24%) 0%, hsl(213 64% 34%) 100%)",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "minimal",
    interactionScale: {
      hover: 1,
      press: 0.99
    },
    pageTransitions: !1,
    listAnimation: "none"
  },
  dataAttributes: {
    mode: "light",
    density: "comfortable",
    motion: "minimal",
    style: "editorial"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "md",
      pressable: !1
    },
    Card: {
      variant: "outlined",
      padding: "md",
      hoverable: !1
    },
    Badge: {
      style: "solid",
      size: "md"
    },
    DataTable: {
      density: "comfortable",
      stripedRows: !0,
      showRowBorders: !0
    },
    KpiCard: {
      elevated: !1,
      displayFont: !0
    },
    Input: {
      variant: "default"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: ["https://canvas.instructure.com", "https://blackboard.com"]
}, Ze = {
  id: "education-kids-friendly",
  name: "Kids Friendly",
  description: "Playful, colorful design with editorial serif display typography, rounded shapes and engaging animations. Perfect for children's educational apps and games targeting ages 4-12.",
  category: "education",
  tags: ["kids", "playful", "colorful", "fun", "animated", "rounded", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Fraunces", "Lora", Georgia, serif',
      heading: '"Fraunces", "Lora", Georgia, serif',
      body: '"Nunito", "Quicksand", sans-serif',
      mono: '"Roboto Mono", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "semibold",
      lineHeight: "1.15",
      style: "serif"
    },
    scale: {
      displaySize: "6xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "normal",
      weight: "extrabold"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "semibold",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    }
  },
  dataIdentifiers: {
    pattern: "[{TYPE}:{ID}]"
  },
  spacing: {
    density: "spacious",
    paddingScale: 1.3,
    gapScale: 1.2,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "elevated",
    radius: "2xl",
    showBorder: !0,
    borderStyle: "thick",
    accentEdge: "none",
    elevation: 2,
    hoverEffect: "scale"
  },
  dataViz: {
    sequential: ["#FEF3C7", "#FCD34D", "#FBBF24", "#F59E0B", "#D97706"],
    categorical: [
      "#EF4444",
      "#F59E0B",
      "#10B981",
      "#3B82F6",
      "#8B5CF6",
      "#EC4899"
    ],
    diverging: {
      negative: "#EF4444",
      neutral: "#9CA3AF",
      positive: "#10B981"
    },
    semantic: {
      positive: "#10B981",
      negative: "#EF4444",
      neutral: "#9CA3AF",
      warning: "#F59E0B"
    }
  },
  kpiStyling: {
    metricSize: "5xl",
    metricWeight: "extrabold",
    metricFont: "display",
    showTrendArrows: !0,
    sparklineStyle: "bar",
    cardTreatment: "elevated",
    labelCasing: "uppercase",
    labelTracking: "widest"
  },
  accents: {
    primary: "262 83% 58%",
    // Purple
    secondary: "142 71% 45%",
    // Green
    application: {
      buttons: "filled",
      links: "bold-color",
      focus: "glow",
      selection: "bold"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(262 83% 58%) 0%, hsl(330 81% 60%) 100%)",
      useOnButtons: !0,
      useOnCards: !1,
      useOnText: !0
    }
  },
  motion: {
    style: "playful",
    interactionScale: {
      hover: 1.05,
      press: 0.95
    },
    pageTransitions: !0,
    listAnimation: "stagger"
  },
  dataAttributes: {
    mode: "light",
    density: "spacious",
    motion: "playful",
    style: "editorial"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "lg",
      pill: !0,
      pressable: !0
    },
    Card: {
      variant: "elevated",
      padding: "lg",
      hoverable: !0
    },
    Badge: {
      style: "solid",
      size: "md"
    },
    DataTable: {
      density: "spacious",
      stripedRows: !0,
      showRowBorders: !1
    },
    KpiCard: {
      elevated: !0,
      displayFont: !0
    },
    Input: {
      variant: "filled"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: ["https://abcmouse.com", "https://pbskids.org", "https://duolingo.com"]
}, _e = {
  id: "education-course-creator",
  name: "Course Creator",
  description: "Creator-focused design with editorial serif typography for course authoring platforms with intuitive content management, drag-and-drop interfaces, and clear organization. Perfect for course creators and content authors.",
  category: "education",
  tags: ["creator", "authoring", "content", "intuitive", "organized", "teal", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Crimson Pro", "Libre Baskerville", Georgia, serif',
      heading: '"Crimson Pro", "Libre Baskerville", Georgia, serif',
      body: '"DM Sans", "Inter", system-ui, sans-serif',
      mono: '"JetBrains Mono", "Fira Code", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "medium",
      lineHeight: "1.1",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "tight",
      weight: "semibold"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    }
  },
  dataIdentifiers: {
    pattern: "[{TYPE}:{ID}]"
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.1,
    gapScale: 1,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "outlined",
    radius: "lg",
    showBorder: !0,
    borderStyle: "subtle",
    accentEdge: "left",
    elevation: 0,
    hoverEffect: "lift"
  },
  dataViz: {
    sequential: ["#CCFBF1", "#5EEAD4", "#14B8A6", "#0D9488", "#115E59"],
    categorical: [
      "#14B8A6",
      "#8B5CF6",
      "#F59E0B",
      "#EC4899",
      "#3B82F6",
      "#10B981"
    ],
    diverging: {
      negative: "#EF4444",
      neutral: "#6B7280",
      positive: "#14B8A6"
    },
    semantic: {
      positive: "#14B8A6",
      negative: "#EF4444",
      neutral: "#6B7280",
      warning: "#F59E0B"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "semibold",
    metricFont: "display",
    showTrendArrows: !0,
    sparklineStyle: "area",
    cardTreatment: "bordered",
    labelCasing: "uppercase",
    labelTracking: "widest"
  },
  accents: {
    primary: "173 80% 40%",
    // Teal
    secondary: "250 91% 67%",
    // Purple
    application: {
      buttons: "filled",
      links: "color-only",
      focus: "ring",
      selection: "subtle"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(173 80% 40%) 0%, hsl(190 90% 45%) 100%)",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "smooth",
    interactionScale: {
      hover: 1.01,
      press: 0.99
    },
    pageTransitions: !0,
    listAnimation: "fade"
  },
  dataAttributes: {
    mode: "light",
    density: "comfortable",
    motion: "smooth",
    style: "editorial"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "md",
      pressable: !0
    },
    Card: {
      variant: "outlined",
      padding: "md",
      hoverable: !0
    },
    Badge: {
      style: "soft",
      size: "sm"
    },
    DataTable: {
      density: "comfortable",
      stripedRows: !1,
      showRowBorders: !0
    },
    KpiCard: {
      elevated: !1,
      displayFont: !0
    },
    Input: {
      variant: "default"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: ["https://teachable.com", "https://thinkific.com", "https://kajabi.com"]
}, Xe = {
  id: "education-assessment-tool",
  name: "Assessment Tool",
  description: "Clean, focused design with editorial serif typography optimized for quizzes, exams, and assessments. Minimizes distractions with clear question layouts and progress indicators.",
  category: "education",
  tags: ["assessment", "quiz", "exam", "focused", "minimal", "clean", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Bodoni Moda", "Playfair Display", Georgia, serif',
      heading: '"Bodoni Moda", "Playfair Display", Georgia, serif',
      body: '"Inter var", "Inter", system-ui, sans-serif',
      mono: '"Roboto Mono", "Consolas", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "normal",
      lineHeight: "1.0",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "normal",
      weight: "semibold"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    }
  },
  dataIdentifiers: {
    pattern: "[{TYPE}:{ID}]"
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.2,
    gapScale: 1.1,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "outlined",
    radius: "lg",
    showBorder: !0,
    borderStyle: "medium",
    accentEdge: "none",
    elevation: 0,
    hoverEffect: "none"
  },
  dataViz: {
    sequential: ["#E0F2FE", "#7DD3FC", "#38BDF8", "#0EA5E9", "#0369A1"],
    categorical: [
      "#0EA5E9",
      "#10B981",
      "#F59E0B",
      "#EF4444",
      "#8B5CF6",
      "#EC4899"
    ],
    diverging: {
      negative: "#EF4444",
      neutral: "#6B7280",
      positive: "#10B981"
    },
    semantic: {
      positive: "#10B981",
      negative: "#EF4444",
      neutral: "#6B7280",
      warning: "#F59E0B"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "bold",
    metricFont: "display",
    showTrendArrows: !1,
    sparklineStyle: "bar",
    cardTreatment: "bordered",
    labelCasing: "uppercase",
    labelTracking: "widest"
  },
  accents: {
    primary: "199 89% 48%",
    // Sky Blue
    secondary: "158 64% 42%",
    // Emerald
    application: {
      buttons: "filled",
      links: "color-only",
      focus: "ring",
      selection: "bold"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(199 89% 48%) 0%, hsl(217 91% 60%) 100%)",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "minimal",
    interactionScale: {
      hover: 1,
      press: 0.99
    },
    pageTransitions: !1,
    listAnimation: "none"
  },
  dataAttributes: {
    mode: "light",
    density: "comfortable",
    motion: "minimal",
    style: "editorial"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "lg",
      pressable: !1
    },
    Card: {
      variant: "outlined",
      padding: "lg",
      hoverable: !1
    },
    Badge: {
      style: "soft",
      size: "md"
    },
    DataTable: {
      density: "comfortable",
      stripedRows: !0,
      showRowBorders: !0
    },
    KpiCard: {
      elevated: !1,
      displayFont: !0
    },
    Input: {
      variant: "default"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: ["https://quizlet.com", "https://forms.google.com", "https://typeform.com"]
}, ei = {
  id: "education-tutoring-app",
  name: "Tutoring App",
  description: "Warm, approachable design with editorial serif typography for tutoring and mentoring platforms. Emphasizes human connection with friendly colors and conversational layouts.",
  category: "education",
  tags: ["tutoring", "mentoring", "warm", "friendly", "approachable", "orange", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Lora", "Merriweather", Georgia, serif',
      heading: '"Lora", "Merriweather", Georgia, serif',
      body: '"Open Sans", "Lato", sans-serif',
      mono: '"Source Code Pro", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "medium",
      lineHeight: "1.1",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "normal",
      weight: "semibold"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    }
  },
  dataIdentifiers: {
    pattern: "[{TYPE}:{ID}]"
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.15,
    gapScale: 1,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "elevated",
    radius: "xl",
    showBorder: !1,
    borderStyle: "subtle",
    accentEdge: "none",
    elevation: 1,
    hoverEffect: "lift"
  },
  dataViz: {
    sequential: ["#FFEDD5", "#FDBA74", "#FB923C", "#EA580C", "#C2410C"],
    categorical: [
      "#F97316",
      "#8B5CF6",
      "#10B981",
      "#3B82F6",
      "#EC4899",
      "#EAB308"
    ],
    diverging: {
      negative: "#EF4444",
      neutral: "#6B7280",
      positive: "#10B981"
    },
    semantic: {
      positive: "#10B981",
      negative: "#EF4444",
      neutral: "#6B7280",
      warning: "#F59E0B"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "semibold",
    metricFont: "display",
    showTrendArrows: !0,
    sparklineStyle: "line",
    cardTreatment: "elevated",
    labelCasing: "uppercase",
    labelTracking: "widest"
  },
  accents: {
    primary: "25 95% 53%",
    // Orange
    secondary: "262 83% 58%",
    // Purple
    application: {
      buttons: "filled",
      links: "color-only",
      focus: "ring",
      selection: "subtle"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(25 95% 53%) 0%, hsl(38 92% 50%) 100%)",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "smooth",
    interactionScale: {
      hover: 1.02,
      press: 0.98
    },
    pageTransitions: !0,
    listAnimation: "fade"
  },
  dataAttributes: {
    mode: "light",
    density: "comfortable",
    motion: "smooth",
    style: "editorial"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "md",
      pill: !0,
      pressable: !0
    },
    Card: {
      variant: "elevated",
      padding: "lg",
      hoverable: !0
    },
    Badge: {
      style: "soft",
      size: "md"
    },
    DataTable: {
      density: "comfortable",
      stripedRows: !1,
      showRowBorders: !0
    },
    KpiCard: {
      elevated: !0,
      displayFont: !0
    },
    Input: {
      variant: "default"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: ["https://wyzant.com", "https://preply.com", "https://tutorme.com"]
}, ii = [
  je,
  Qe,
  Ze,
  _e,
  Xe,
  ei
];
p(ii);
const ti = {
  id: "enterprise-corporate-intranet",
  name: "Corporate Intranet",
  description: "Professional, accessible editorial design for enterprise intranets and internal portals. Features serif display typography, generous spacing, and elegant content organization.",
  category: "enterprise",
  tags: ["corporate", "intranet", "professional", "accessible", "enterprise", "blue", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Playfair Display", "Libre Baskerville", Georgia, serif',
      heading: '"Segoe UI", "Open Sans", system-ui, sans-serif',
      body: '"Segoe UI", "Open Sans", system-ui, sans-serif',
      mono: '"Consolas", "Source Code Pro", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "medium",
      lineHeight: "1.1",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "normal",
      weight: "semibold"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    }
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.15,
    gapScale: 1.1,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "outlined",
    radius: "md",
    showBorder: !0,
    borderStyle: "subtle",
    accentEdge: "top",
    elevation: 0,
    hoverEffect: "lift"
  },
  dataViz: {
    sequential: ["#DBEAFE", "#93C5FD", "#3B82F6", "#1D4ED8", "#1E3A8A"],
    categorical: [
      "#2563EB",
      "#16A34A",
      "#EA580C",
      "#9333EA",
      "#0891B2",
      "#DC2626"
    ],
    diverging: {
      negative: "#DC2626",
      neutral: "#6B7280",
      positive: "#16A34A"
    },
    semantic: {
      positive: "#16A34A",
      negative: "#DC2626",
      neutral: "#6B7280",
      warning: "#CA8A04"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "semibold",
    metricFont: "display",
    showTrendArrows: !0,
    sparklineStyle: "bar",
    cardTreatment: "bordered",
    labelCasing: "uppercase",
    labelTracking: "widest"
  },
  accents: {
    primary: "217 91% 60%",
    // Blue
    secondary: "142 76% 36%",
    // Green
    application: {
      buttons: "filled",
      links: "underline",
      focus: "outline",
      selection: "subtle"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(217 91% 60%) 0%, hsl(217 91% 50%) 100%)",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "minimal",
    interactionScale: {
      hover: 1,
      press: 0.99
    },
    pageTransitions: !1,
    listAnimation: "fade"
  },
  dataAttributes: {
    mode: "light",
    density: "comfortable",
    motion: "minimal",
    style: "editorial"
  },
  dataIdentifiers: {
    pattern: "[{TYPE}:{ID}]"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "md",
      pressable: !1
    },
    Card: {
      variant: "outlined",
      padding: "md",
      hoverable: !0
    },
    Badge: {
      style: "soft",
      size: "sm"
    },
    DataTable: {
      density: "comfortable",
      stripedRows: !0,
      showRowBorders: !0
    },
    KpiCard: {
      elevated: !1,
      displayFont: !0
    },
    Input: {
      variant: "default"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: ["https://sharepoint.com", "https://confluence.atlassian.com"]
}, ai = {
  id: "enterprise-hr-portal",
  name: "HR Portal",
  description: "Friendly, approachable editorial design for human resources platforms. Features serif display typography, generous spacing, and people-centric interfaces.",
  category: "enterprise",
  tags: ["hr", "human-resources", "friendly", "approachable", "employee", "green", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Fraunces", "Merriweather", Georgia, serif',
      heading: '"Nunito Sans", "Open Sans", system-ui, sans-serif',
      body: '"Nunito Sans", "Open Sans", system-ui, sans-serif',
      mono: '"Roboto Mono", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "medium",
      lineHeight: "1.15",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "normal",
      weight: "semibold"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    }
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.2,
    gapScale: 1.15,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "elevated",
    radius: "lg",
    showBorder: !1,
    borderStyle: "subtle",
    accentEdge: "left",
    elevation: 1,
    hoverEffect: "lift"
  },
  dataViz: {
    sequential: ["#D1FAE5", "#6EE7B7", "#34D399", "#10B981", "#047857"],
    categorical: [
      "#10B981",
      "#3B82F6",
      "#F59E0B",
      "#EC4899",
      "#8B5CF6",
      "#06B6D4"
    ],
    diverging: {
      negative: "#EF4444",
      neutral: "#6B7280",
      positive: "#10B981"
    },
    semantic: {
      positive: "#10B981",
      negative: "#EF4444",
      neutral: "#6B7280",
      warning: "#F59E0B"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "semibold",
    metricFont: "display",
    showTrendArrows: !0,
    sparklineStyle: "area",
    cardTreatment: "elevated",
    labelCasing: "uppercase",
    labelTracking: "widest"
  },
  accents: {
    primary: "158 64% 42%",
    // Emerald
    secondary: "217 91% 60%",
    // Blue
    application: {
      buttons: "filled",
      links: "color-only",
      focus: "ring",
      selection: "subtle"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(158 64% 42%) 0%, hsl(172 66% 40%) 100%)",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "smooth",
    interactionScale: {
      hover: 1.01,
      press: 0.99
    },
    pageTransitions: !0,
    listAnimation: "fade"
  },
  dataAttributes: {
    mode: "light",
    density: "comfortable",
    motion: "smooth",
    style: "editorial"
  },
  dataIdentifiers: {
    pattern: "[{TYPE}:{ID}]"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "md",
      pressable: !0
    },
    Card: {
      variant: "elevated",
      padding: "lg",
      hoverable: !0
    },
    Badge: {
      style: "soft",
      size: "md"
    },
    DataTable: {
      density: "comfortable",
      stripedRows: !1,
      showRowBorders: !0
    },
    KpiCard: {
      elevated: !0,
      displayFont: !0
    },
    Input: {
      variant: "default"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: ["https://workday.com", "https://bamboohr.com", "https://gusto.com"]
}, si = {
  id: "enterprise-project-management",
  name: "Project Management",
  description: "Task-focused editorial design for project management platforms. Features serif display typography, elegant organization, and refined progress tracking.",
  category: "enterprise",
  tags: ["project", "tasks", "collaboration", "teams", "productivity", "coral", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Lora", "Crimson Pro", Georgia, serif',
      heading: '"Inter var", "Inter", system-ui, sans-serif',
      body: '"Inter var", "Inter", system-ui, sans-serif',
      mono: '"JetBrains Mono", "Fira Code", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "semibold",
      lineHeight: "1.1",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "tight",
      weight: "semibold"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    }
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.1,
    gapScale: 1.05,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "outlined",
    radius: "lg",
    showBorder: !0,
    borderStyle: "subtle",
    accentEdge: "left",
    elevation: 0,
    hoverEffect: "lift"
  },
  dataViz: {
    sequential: ["#FEE2E2", "#FECACA", "#F87171", "#EF4444", "#B91C1C"],
    categorical: [
      "#F97316",
      "#10B981",
      "#3B82F6",
      "#8B5CF6",
      "#EC4899",
      "#EAB308"
    ],
    diverging: {
      negative: "#EF4444",
      neutral: "#6B7280",
      positive: "#10B981"
    },
    semantic: {
      positive: "#10B981",
      negative: "#EF4444",
      neutral: "#6B7280",
      warning: "#F59E0B"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "semibold",
    metricFont: "display",
    showTrendArrows: !0,
    sparklineStyle: "line",
    cardTreatment: "minimal",
    labelCasing: "uppercase",
    labelTracking: "widest"
  },
  accents: {
    primary: "25 95% 53%",
    // Orange/Coral
    secondary: "262 83% 58%",
    // Purple
    application: {
      buttons: "filled",
      links: "color-only",
      focus: "ring",
      selection: "subtle"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(25 95% 53%) 0%, hsl(351 74% 55%) 100%)",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "smooth",
    interactionScale: {
      hover: 1.01,
      press: 0.99
    },
    pageTransitions: !0,
    listAnimation: "stagger"
  },
  dataAttributes: {
    mode: "light",
    density: "comfortable",
    motion: "smooth",
    style: "editorial"
  },
  dataIdentifiers: {
    pattern: "[{TYPE}:{ID}]"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "sm",
      pressable: !0
    },
    Card: {
      variant: "outlined",
      padding: "md",
      hoverable: !0
    },
    Badge: {
      style: "soft",
      size: "sm"
    },
    DataTable: {
      density: "comfortable",
      stripedRows: !1,
      showRowBorders: !0
    },
    KpiCard: {
      elevated: !1,
      displayFont: !0
    },
    Input: {
      variant: "default"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: ["https://asana.com", "https://monday.com", "https://basecamp.com"]
}, ri = {
  id: "enterprise-document-management",
  name: "Document Management",
  description: "Clean, organized editorial design for document management and file storage systems. Features serif display typography, elegant hierarchy, and refined file previews.",
  category: "enterprise",
  tags: ["documents", "files", "storage", "organized", "clean", "gray", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Cormorant Garamond", "Libre Baskerville", Georgia, serif',
      heading: '"Google Sans", "Roboto", system-ui, sans-serif',
      body: '"Roboto", "Open Sans", system-ui, sans-serif',
      mono: '"Roboto Mono", "Consolas", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "medium",
      lineHeight: "1.1",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "normal",
      weight: "medium"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    }
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.1,
    gapScale: 1.05,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "ghost",
    radius: "lg",
    showBorder: !0,
    borderStyle: "subtle",
    accentEdge: "none",
    elevation: 0,
    hoverEffect: "lift"
  },
  dataViz: {
    sequential: ["#F3F4F6", "#D1D5DB", "#9CA3AF", "#6B7280", "#374151"],
    categorical: [
      "#3B82F6",
      "#10B981",
      "#F59E0B",
      "#EF4444",
      "#8B5CF6",
      "#EC4899"
    ],
    diverging: {
      negative: "#EF4444",
      neutral: "#6B7280",
      positive: "#10B981"
    },
    semantic: {
      positive: "#10B981",
      negative: "#EF4444",
      neutral: "#6B7280",
      warning: "#F59E0B"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "medium",
    metricFont: "display",
    showTrendArrows: !1,
    sparklineStyle: "bar",
    cardTreatment: "minimal",
    labelCasing: "uppercase",
    labelTracking: "widest"
  },
  accents: {
    primary: "217 91% 60%",
    // Blue
    secondary: "158 64% 42%",
    // Green
    application: {
      buttons: "subtle",
      links: "color-only",
      focus: "ring",
      selection: "subtle"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(217 91% 60%) 0%, hsl(199 89% 48%) 100%)",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "minimal",
    interactionScale: {
      hover: 1,
      press: 0.99
    },
    pageTransitions: !1,
    listAnimation: "none"
  },
  dataAttributes: {
    mode: "light",
    density: "comfortable",
    motion: "minimal",
    style: "editorial"
  },
  dataIdentifiers: {
    pattern: "[{TYPE}:{ID}]"
  },
  componentDefaults: {
    Button: {
      variant: "ghost",
      size: "sm",
      pressable: !1
    },
    Card: {
      variant: "ghost",
      padding: "md",
      hoverable: !0
    },
    Badge: {
      style: "soft",
      size: "sm"
    },
    DataTable: {
      density: "comfortable",
      stripedRows: !1,
      showRowBorders: !1
    },
    KpiCard: {
      elevated: !1,
      displayFont: !0
    },
    Input: {
      variant: "filled"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: ["https://drive.google.com", "https://dropbox.com", "https://box.com"]
}, ni = {
  id: "enterprise-resource-planning",
  name: "Resource Planning",
  description: "Data-rich editorial design for ERP and enterprise resource planning systems. Features serif display typography, elegant data presentation, and refined multi-level navigation.",
  category: "enterprise",
  tags: ["erp", "resource-planning", "data-dense", "enterprise", "formal", "navy", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Bodoni Moda", "Playfair Display", Georgia, serif',
      heading: '"IBM Plex Sans", "Segoe UI", system-ui, sans-serif',
      body: '"IBM Plex Sans", "Segoe UI", system-ui, sans-serif',
      mono: '"IBM Plex Mono", "Consolas", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "normal",
      lineHeight: "1.0",
      style: "serif"
    },
    scale: {
      displaySize: "6xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "normal",
      weight: "semibold"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "semibold",
      casing: "uppercase",
      size: "xxs",
      font: "mono"
    }
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.1,
    gapScale: 1,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "outlined",
    radius: "sm",
    showBorder: !0,
    borderStyle: "medium",
    accentEdge: "none",
    elevation: 0,
    hoverEffect: "none"
  },
  dataViz: {
    sequential: ["#E0E7FF", "#A5B4FC", "#6366F1", "#4338CA", "#312E81"],
    categorical: [
      "#1E3A5F",
      "#10B981",
      "#F59E0B",
      "#EF4444",
      "#8B5CF6",
      "#06B6D4"
    ],
    diverging: {
      negative: "#DC2626",
      neutral: "#6B7280",
      positive: "#059669"
    },
    semantic: {
      positive: "#059669",
      negative: "#DC2626",
      neutral: "#6B7280",
      warning: "#D97706"
    }
  },
  kpiStyling: {
    metricSize: "5xl",
    metricWeight: "semibold",
    metricFont: "display",
    showTrendArrows: !0,
    sparklineStyle: "bar",
    cardTreatment: "bordered",
    labelCasing: "uppercase",
    labelTracking: "widest"
  },
  accents: {
    primary: "213 64% 24%",
    // Navy
    secondary: "142 71% 45%",
    // Green
    application: {
      buttons: "filled",
      links: "underline",
      focus: "outline",
      selection: "bold"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(213 64% 24%) 0%, hsl(213 64% 34%) 100%)",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "minimal",
    interactionScale: {
      hover: 1,
      press: 1
    },
    pageTransitions: !1,
    listAnimation: "none"
  },
  dataAttributes: {
    mode: "light",
    density: "comfortable",
    motion: "minimal",
    style: "editorial"
  },
  dataIdentifiers: {
    pattern: "[{TYPE}:{ID}]"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "sm",
      pressable: !1
    },
    Card: {
      variant: "outlined",
      padding: "md",
      hoverable: !1
    },
    Badge: {
      style: "solid",
      size: "sm"
    },
    DataTable: {
      density: "comfortable",
      stripedRows: !0,
      showRowBorders: !0
    },
    KpiCard: {
      elevated: !1,
      displayFont: !0
    },
    Input: {
      variant: "default"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: ["https://sap.com", "https://oracle.com/erp", "https://netsuite.com"]
}, oi = {
  id: "enterprise-compliance-dashboard",
  name: "Compliance Dashboard",
  description: "Serious, trustworthy editorial design for compliance monitoring and regulatory systems. Features serif display typography, elegant status indicators, and refined audit trail visualization.",
  category: "enterprise",
  tags: ["compliance", "regulatory", "audit", "trustworthy", "serious", "slate", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Editorial New", "Merriweather", Georgia, serif',
      heading: '"Inter var", "Inter", system-ui, sans-serif',
      body: '"Inter var", "Inter", system-ui, sans-serif',
      mono: '"JetBrains Mono", "Fira Code", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "medium",
      lineHeight: "1.1",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "tight",
      weight: "semibold"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "semibold",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    }
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.15,
    gapScale: 1.1,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "outlined",
    radius: "md",
    showBorder: !0,
    borderStyle: "medium",
    accentEdge: "left",
    elevation: 0,
    hoverEffect: "none"
  },
  dataViz: {
    sequential: ["#F1F5F9", "#CBD5E1", "#94A3B8", "#64748B", "#334155"],
    categorical: [
      "#475569",
      "#10B981",
      "#F59E0B",
      "#EF4444",
      "#8B5CF6",
      "#3B82F6"
    ],
    diverging: {
      negative: "#DC2626",
      neutral: "#64748B",
      positive: "#059669"
    },
    semantic: {
      positive: "#059669",
      negative: "#DC2626",
      neutral: "#64748B",
      warning: "#D97706"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "bold",
    metricFont: "display",
    showTrendArrows: !0,
    sparklineStyle: "line",
    cardTreatment: "bordered",
    labelCasing: "uppercase",
    labelTracking: "widest"
  },
  accents: {
    primary: "215 25% 27%",
    // Slate
    secondary: "158 64% 42%",
    // Emerald
    application: {
      buttons: "filled",
      links: "color-only",
      focus: "outline",
      selection: "subtle"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(215 25% 27%) 0%, hsl(215 25% 37%) 100%)",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "minimal",
    interactionScale: {
      hover: 1,
      press: 0.99
    },
    pageTransitions: !1,
    listAnimation: "fade"
  },
  dataAttributes: {
    mode: "light",
    density: "comfortable",
    motion: "minimal",
    style: "editorial"
  },
  dataIdentifiers: {
    pattern: "[{TYPE}:{ID}]"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "md",
      pressable: !1
    },
    Card: {
      variant: "outlined",
      padding: "md",
      hoverable: !1
    },
    Badge: {
      style: "solid",
      size: "sm"
    },
    DataTable: {
      density: "comfortable",
      stripedRows: !0,
      showRowBorders: !0
    },
    KpiCard: {
      elevated: !1,
      displayFont: !0
    },
    Input: {
      variant: "default"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: ["https://onetrust.com", "https://vanta.com", "https://drata.com"]
}, li = [
  ti,
  ai,
  si,
  ri,
  ni,
  oi
];
p(li);
const di = {
  id: "productivity-task-manager",
  name: "Task Manager",
  description: "Editorial, focused design for personal task management. Emphasizes task lists, due dates, priorities, and quick capture with refined serif typography and minimal visual noise.",
  category: "productivity",
  tags: ["tasks", "todo", "focused", "minimal", "personal", "red", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Playfair Display", "Libre Baskerville", Georgia, serif',
      heading: '"Inter var", "Inter", system-ui, sans-serif',
      body: '"Inter var", "Inter", system-ui, sans-serif',
      mono: '"JetBrains Mono", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "medium",
      lineHeight: "1.1",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "tight",
      weight: "semibold"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    }
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.1,
    gapScale: 1,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "ghost",
    radius: "lg",
    showBorder: !1,
    borderStyle: "subtle",
    accentEdge: "none",
    elevation: 0,
    hoverEffect: "lift"
  },
  dataViz: {
    sequential: ["#FEE2E2", "#FECACA", "#F87171", "#EF4444", "#B91C1C"],
    categorical: [
      "#EF4444",
      "#F59E0B",
      "#10B981",
      "#3B82F6",
      "#8B5CF6",
      "#6B7280"
    ],
    diverging: {
      negative: "#EF4444",
      neutral: "#6B7280",
      positive: "#10B981"
    },
    semantic: {
      positive: "#10B981",
      negative: "#EF4444",
      neutral: "#6B7280",
      warning: "#F59E0B"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "semibold",
    metricFont: "display",
    showTrendArrows: !1,
    sparklineStyle: "bar",
    cardTreatment: "minimal",
    labelCasing: "uppercase",
    labelTracking: "widest"
  },
  accents: {
    primary: "0 84% 60%",
    // Red (Todoist-style)
    secondary: "217 91% 60%",
    // Blue
    application: {
      buttons: "filled",
      links: "color-only",
      focus: "ring",
      selection: "subtle"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(0 84% 60%) 0%, hsl(15 90% 55%) 100%)",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "smooth",
    interactionScale: {
      hover: 1.01,
      press: 0.99
    },
    pageTransitions: !0,
    listAnimation: "fade"
  },
  dataAttributes: {
    mode: "light",
    density: "comfortable",
    motion: "smooth",
    style: "editorial"
  },
  dataIdentifiers: {
    pattern: "[{TYPE}:{ID}]"
  },
  componentDefaults: {
    Button: {
      variant: "ghost",
      size: "sm",
      pressable: !0
    },
    Card: {
      variant: "ghost",
      padding: "sm",
      hoverable: !0
    },
    Badge: {
      style: "soft",
      size: "sm"
    },
    DataTable: {
      density: "comfortable",
      stripedRows: !1,
      showRowBorders: !1
    },
    KpiCard: {
      elevated: !1,
      displayFont: !0
    },
    Input: {
      variant: "flushed"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: ["https://todoist.com", "https://culturedcode.com/things", "https://ticktick.com"]
}, ci = {
  id: "productivity-note-taking",
  name: "Note Taking",
  description: "Editorial, writing-focused design for note-taking and knowledge management. Emphasizes typography, markdown support, and distraction-free writing with refined serif display fonts.",
  category: "productivity",
  tags: ["notes", "writing", "knowledge", "markdown", "minimal", "warm", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Merriweather", "Libre Baskerville", Georgia, serif',
      heading: '"Inter var", "Inter", system-ui, sans-serif',
      body: '"Inter var", "Inter", system-ui, sans-serif',
      mono: '"JetBrains Mono", "Fira Code", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "normal",
      lineHeight: "1.15",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "normal",
      weight: "semibold"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    }
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.2,
    gapScale: 1.1,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "ghost",
    radius: "md",
    showBorder: !1,
    borderStyle: "subtle",
    accentEdge: "none",
    elevation: 0,
    hoverEffect: "none"
  },
  dataViz: {
    sequential: ["#FEF3C7", "#FDE68A", "#FCD34D", "#FBBF24", "#D97706"],
    categorical: [
      "#92400E",
      "#10B981",
      "#3B82F6",
      "#8B5CF6",
      "#EC4899",
      "#6B7280"
    ],
    diverging: {
      negative: "#DC2626",
      neutral: "#6B7280",
      positive: "#059669"
    },
    semantic: {
      positive: "#059669",
      negative: "#DC2626",
      neutral: "#6B7280",
      warning: "#D97706"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "medium",
    metricFont: "display",
    showTrendArrows: !1,
    sparklineStyle: "line",
    cardTreatment: "minimal",
    labelCasing: "uppercase",
    labelTracking: "widest"
  },
  accents: {
    primary: "32 95% 44%",
    // Amber/Brown
    secondary: "217 91% 60%",
    // Blue
    application: {
      buttons: "subtle",
      links: "underline",
      focus: "ring",
      selection: "subtle"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(32 95% 44%) 0%, hsl(25 95% 53%) 100%)",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "minimal",
    interactionScale: {
      hover: 1,
      press: 0.99
    },
    pageTransitions: !1,
    listAnimation: "none"
  },
  dataAttributes: {
    mode: "light",
    density: "comfortable",
    motion: "minimal",
    style: "editorial"
  },
  dataIdentifiers: {
    pattern: "[{TYPE}:{ID}]"
  },
  componentDefaults: {
    Button: {
      variant: "ghost",
      size: "sm",
      pressable: !1
    },
    Card: {
      variant: "ghost",
      padding: "lg",
      hoverable: !1
    },
    Badge: {
      style: "soft",
      size: "sm"
    },
    DataTable: {
      density: "comfortable",
      stripedRows: !1,
      showRowBorders: !1
    },
    KpiCard: {
      elevated: !1,
      displayFont: !0
    },
    Input: {
      variant: "flushed"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: ["https://notion.so", "https://obsidian.md", "https://bear.app"]
}, pi = {
  id: "productivity-calendar-app",
  name: "Calendar App",
  description: "Editorial, time-focused design for calendar and scheduling applications. Emphasizes date grids, event colors, and time block visualization with refined serif display fonts.",
  category: "productivity",
  tags: ["calendar", "scheduling", "events", "time", "organized", "blue", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Cormorant Garamond", "Libre Baskerville", Georgia, serif',
      heading: '"Google Sans", "Roboto", system-ui, sans-serif',
      body: '"Roboto", "Open Sans", system-ui, sans-serif',
      mono: '"Roboto Mono", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "medium",
      lineHeight: "1.1",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "normal",
      weight: "medium"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    }
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.1,
    gapScale: 1,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "outlined",
    radius: "md",
    showBorder: !0,
    borderStyle: "subtle",
    accentEdge: "left",
    elevation: 0,
    hoverEffect: "lift"
  },
  dataViz: {
    sequential: ["#DBEAFE", "#93C5FD", "#3B82F6", "#1D4ED8", "#1E3A8A"],
    categorical: [
      "#3B82F6",
      "#10B981",
      "#F59E0B",
      "#EF4444",
      "#8B5CF6",
      "#EC4899",
      "#06B6D4",
      "#84CC16"
    ],
    diverging: {
      negative: "#EF4444",
      neutral: "#6B7280",
      positive: "#10B981"
    },
    semantic: {
      positive: "#10B981",
      negative: "#EF4444",
      neutral: "#6B7280",
      warning: "#F59E0B"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "medium",
    metricFont: "display",
    showTrendArrows: !1,
    sparklineStyle: "bar",
    cardTreatment: "minimal",
    labelCasing: "uppercase",
    labelTracking: "widest"
  },
  accents: {
    primary: "217 91% 60%",
    // Blue
    secondary: "142 71% 45%",
    // Green
    application: {
      buttons: "filled",
      links: "color-only",
      focus: "ring",
      selection: "subtle"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(217 91% 60%) 0%, hsl(199 89% 48%) 100%)",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "smooth",
    interactionScale: {
      hover: 1,
      press: 0.99
    },
    pageTransitions: !0,
    listAnimation: "fade"
  },
  dataAttributes: {
    mode: "light",
    density: "comfortable",
    motion: "smooth",
    style: "editorial"
  },
  dataIdentifiers: {
    pattern: "[{TYPE}:{ID}]"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "sm",
      pressable: !0
    },
    Card: {
      variant: "outlined",
      padding: "sm",
      hoverable: !0
    },
    Badge: {
      style: "soft",
      size: "sm"
    },
    DataTable: {
      density: "comfortable",
      stripedRows: !1,
      showRowBorders: !0
    },
    KpiCard: {
      elevated: !1,
      displayFont: !0
    },
    Input: {
      variant: "default"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: ["https://calendar.google.com", "https://flexibits.com/fantastical", "https://calendly.com"]
}, gi = {
  id: "productivity-team-collaboration",
  name: "Team Collaboration",
  description: "Editorial, communication-focused design for team collaboration tools. Emphasizes channels, threads, real-time messaging, and status indicators with refined serif display fonts.",
  category: "productivity",
  tags: ["collaboration", "messaging", "teams", "real-time", "chat", "purple", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Fraunces", "Playfair Display", Georgia, serif',
      heading: '"Lato", "Open Sans", system-ui, sans-serif',
      body: '"Lato", "Open Sans", system-ui, sans-serif',
      mono: '"Source Code Pro", "Consolas", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "medium",
      lineHeight: "1.1",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "normal",
      weight: "bold"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    }
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.1,
    gapScale: 1,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "ghost",
    radius: "lg",
    showBorder: !1,
    borderStyle: "subtle",
    accentEdge: "none",
    elevation: 0,
    hoverEffect: "lift"
  },
  dataViz: {
    sequential: ["#EDE9FE", "#C4B5FD", "#8B5CF6", "#6D28D9", "#4C1D95"],
    categorical: [
      "#8B5CF6",
      "#10B981",
      "#F59E0B",
      "#EF4444",
      "#3B82F6",
      "#EC4899"
    ],
    diverging: {
      negative: "#EF4444",
      neutral: "#6B7280",
      positive: "#10B981"
    },
    semantic: {
      positive: "#10B981",
      negative: "#EF4444",
      neutral: "#6B7280",
      warning: "#F59E0B"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "semibold",
    metricFont: "display",
    showTrendArrows: !0,
    sparklineStyle: "line",
    cardTreatment: "minimal",
    labelCasing: "uppercase",
    labelTracking: "widest"
  },
  accents: {
    primary: "262 83% 58%",
    // Purple (Slack-inspired)
    secondary: "142 71% 45%",
    // Green
    application: {
      buttons: "filled",
      links: "color-only",
      focus: "ring",
      selection: "subtle"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(262 83% 58%) 0%, hsl(280 85% 60%) 100%)",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "smooth",
    interactionScale: {
      hover: 1.01,
      press: 0.99
    },
    pageTransitions: !1,
    listAnimation: "fade"
  },
  dataAttributes: {
    mode: "light",
    density: "comfortable",
    motion: "smooth",
    style: "editorial"
  },
  dataIdentifiers: {
    pattern: "[{TYPE}:{ID}]"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "sm",
      pressable: !0
    },
    Card: {
      variant: "ghost",
      padding: "sm",
      hoverable: !0
    },
    Badge: {
      style: "solid",
      size: "sm"
    },
    DataTable: {
      density: "comfortable",
      stripedRows: !1,
      showRowBorders: !1
    },
    KpiCard: {
      elevated: !1,
      displayFont: !0
    },
    Input: {
      variant: "filled"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: ["https://slack.com", "https://teams.microsoft.com", "https://discord.com"]
}, mi = {
  id: "productivity-time-tracker",
  name: "Time Tracker",
  description: "Editorial, data-driven design for time tracking applications. Emphasizes timers, time entries, reports, and productivity analytics with refined serif display fonts.",
  category: "productivity",
  tags: ["time-tracking", "productivity", "reports", "analytics", "precise", "pink", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Bodoni Moda", "Playfair Display", Georgia, serif',
      heading: '"Inter var", "Inter", system-ui, sans-serif',
      body: '"Inter var", "Inter", system-ui, sans-serif',
      mono: '"JetBrains Mono", "Fira Code", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "medium",
      lineHeight: "1.0",
      style: "serif"
    },
    scale: {
      displaySize: "6xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "tight",
      weight: "semibold"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    }
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.15,
    gapScale: 1.1,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "elevated",
    radius: "lg",
    showBorder: !1,
    borderStyle: "subtle",
    accentEdge: "none",
    elevation: 1,
    hoverEffect: "lift"
  },
  dataViz: {
    sequential: ["#FCE7F3", "#FBCFE8", "#F472B6", "#EC4899", "#BE185D"],
    categorical: [
      "#EC4899",
      "#3B82F6",
      "#10B981",
      "#F59E0B",
      "#8B5CF6",
      "#06B6D4"
    ],
    diverging: {
      negative: "#EF4444",
      neutral: "#6B7280",
      positive: "#10B981"
    },
    semantic: {
      positive: "#10B981",
      negative: "#EF4444",
      neutral: "#6B7280",
      warning: "#F59E0B"
    }
  },
  kpiStyling: {
    metricSize: "5xl",
    metricWeight: "bold",
    metricFont: "display",
    showTrendArrows: !0,
    sparklineStyle: "area",
    cardTreatment: "elevated",
    labelCasing: "uppercase",
    labelTracking: "widest"
  },
  accents: {
    primary: "330 81% 60%",
    // Pink (Toggl-inspired)
    secondary: "217 91% 60%",
    // Blue
    application: {
      buttons: "filled",
      links: "color-only",
      focus: "ring",
      selection: "subtle"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(330 81% 60%) 0%, hsl(280 85% 60%) 100%)",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "smooth",
    interactionScale: {
      hover: 1.02,
      press: 0.98
    },
    pageTransitions: !0,
    listAnimation: "fade"
  },
  dataAttributes: {
    mode: "light",
    density: "comfortable",
    motion: "smooth",
    style: "editorial"
  },
  dataIdentifiers: {
    pattern: "[{TYPE}:{ID}]"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "md",
      pill: !0,
      pressable: !0
    },
    Card: {
      variant: "elevated",
      padding: "md",
      hoverable: !0
    },
    Badge: {
      style: "soft",
      size: "sm"
    },
    DataTable: {
      density: "comfortable",
      stripedRows: !1,
      showRowBorders: !0
    },
    KpiCard: {
      elevated: !0,
      displayFont: !0
    },
    Input: {
      variant: "default"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: ["https://toggl.com", "https://getharvest.com", "https://clockify.me"]
}, ui = {
  id: "productivity-kanban-board",
  name: "Kanban Board",
  description: "Editorial, visual, drag-and-drop focused design for kanban boards. Emphasizes card stacks, swimlanes, labels, and workflow visualization with refined serif display fonts.",
  category: "productivity",
  tags: ["kanban", "boards", "visual", "drag-drop", "workflow", "blue", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Lora", "Crimson Pro", Georgia, serif',
      heading: '"Inter var", "Inter", system-ui, sans-serif',
      body: '"Inter var", "Inter", system-ui, sans-serif',
      mono: '"JetBrains Mono", "Fira Code", monospace'
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "semibold",
      lineHeight: "1.1",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    headings: {
      letterSpacing: "tight",
      weight: "semibold"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "semibold",
      casing: "uppercase",
      size: "xxs",
      font: "mono"
    }
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.1,
    gapScale: 1,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "elevated",
    radius: "lg",
    showBorder: !1,
    borderStyle: "subtle",
    accentEdge: "none",
    elevation: 1,
    hoverEffect: "lift"
  },
  dataViz: {
    sequential: ["#DBEAFE", "#93C5FD", "#3B82F6", "#1D4ED8", "#1E3A8A"],
    categorical: [
      "#3B82F6",
      "#10B981",
      "#F59E0B",
      "#EF4444",
      "#8B5CF6",
      "#EC4899",
      "#06B6D4",
      "#84CC16"
    ],
    diverging: {
      negative: "#EF4444",
      neutral: "#6B7280",
      positive: "#10B981"
    },
    semantic: {
      positive: "#10B981",
      negative: "#EF4444",
      neutral: "#6B7280",
      warning: "#F59E0B"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "semibold",
    metricFont: "display",
    showTrendArrows: !1,
    sparklineStyle: "bar",
    cardTreatment: "minimal",
    labelCasing: "uppercase",
    labelTracking: "widest"
  },
  accents: {
    primary: "217 91% 60%",
    // Blue (Trello-inspired)
    secondary: "142 71% 45%",
    // Green
    application: {
      buttons: "filled",
      links: "color-only",
      focus: "ring",
      selection: "subtle"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(217 91% 60%) 0%, hsl(245 82% 60%) 100%)",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "smooth",
    interactionScale: {
      hover: 1.02,
      press: 0.98
    },
    pageTransitions: !1,
    listAnimation: "stagger"
  },
  dataAttributes: {
    mode: "light",
    density: "comfortable",
    motion: "smooth",
    style: "editorial"
  },
  dataIdentifiers: {
    pattern: "[{TYPE}:{ID}]"
  },
  componentDefaults: {
    Button: {
      variant: "ghost",
      size: "sm",
      pressable: !0
    },
    Card: {
      variant: "elevated",
      padding: "sm",
      hoverable: !0
    },
    Badge: {
      style: "solid",
      size: "sm"
    },
    DataTable: {
      density: "comfortable",
      stripedRows: !1,
      showRowBorders: !1
    },
    KpiCard: {
      elevated: !1,
      displayFont: !0
    },
    Input: {
      variant: "default"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: ["https://trello.com", "https://linear.app", "https://jira.atlassian.com"]
}, yi = [
  di,
  ci,
  pi,
  gi,
  mi,
  ui
];
p(yi);
const fi = {
  id: "social-community-forum",
  name: "Community Forum",
  description: "Editorial discussion-focused design for community forums and Q&A platforms. Emphasizes threads, upvotes, user reputation, and topic organization with refined serif typography.",
  category: "social-platform",
  tags: ["forum", "community", "discussions", "q&a", "threads", "blue", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Playfair Display", "Libre Baskerville", Georgia, serif',
      heading: '"Playfair Display", "Libre Baskerville", Georgia, serif',
      body: '"Inter var", "Inter", system-ui, sans-serif',
      mono: '"JetBrains Mono", "Fira Code", monospace'
    },
    headings: {
      letterSpacing: "tight",
      weight: "semibold"
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "medium",
      lineHeight: "1.1",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    }
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.15,
    gapScale: 1.1,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "outlined",
    radius: "md",
    showBorder: !0,
    borderStyle: "subtle",
    accentEdge: "none",
    elevation: 0,
    hoverEffect: "lift"
  },
  dataViz: {
    sequential: ["#DBEAFE", "#93C5FD", "#3B82F6", "#1D4ED8", "#1E3A8A"],
    categorical: [
      "#3B82F6",
      "#10B981",
      "#F59E0B",
      "#EF4444",
      "#8B5CF6",
      "#EC4899"
    ],
    diverging: {
      negative: "#EF4444",
      neutral: "#6B7280",
      positive: "#10B981"
    },
    semantic: {
      positive: "#10B981",
      negative: "#EF4444",
      neutral: "#6B7280",
      warning: "#F59E0B"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "semibold",
    metricFont: "display",
    showTrendArrows: !0,
    sparklineStyle: "line",
    cardTreatment: "bordered",
    labelCasing: "uppercase",
    labelTracking: "widest"
  },
  accents: {
    primary: "217 91% 60%",
    // Blue
    secondary: "25 95% 53%",
    // Orange
    application: {
      buttons: "filled",
      links: "color-only",
      focus: "ring",
      selection: "subtle"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(217 91% 60%) 0%, hsl(199 89% 48%) 100%)",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "smooth",
    interactionScale: {
      hover: 1.01,
      press: 0.99
    },
    pageTransitions: !0,
    listAnimation: "fade"
  },
  dataAttributes: {
    mode: "light",
    density: "comfortable",
    motion: "smooth",
    style: "editorial"
  },
  dataIdentifiers: {
    pattern: "[{TYPE}:{ID}]"
  },
  componentDefaults: {
    Button: {
      variant: "secondary",
      size: "sm",
      pressable: !0
    },
    Card: {
      variant: "outlined",
      padding: "md",
      hoverable: !0
    },
    Badge: {
      style: "soft",
      size: "sm"
    },
    DataTable: {
      density: "comfortable",
      stripedRows: !1,
      showRowBorders: !0
    },
    KpiCard: {
      elevated: !1,
      displayFont: !0
    },
    Input: {
      variant: "default"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: ["https://discourse.org", "https://reddit.com", "https://stackoverflow.com"]
}, hi = {
  id: "social-feed",
  name: "Social Feed",
  description: "Engaging, media-rich editorial design for social feeds and timelines. Emphasizes posts, media, reactions, comments, and infinite scroll patterns with refined serif typography.",
  category: "social-platform",
  tags: ["social", "feed", "timeline", "media", "engaging", "sky", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Crimson Pro", "Cormorant Garamond", Georgia, serif',
      heading: '"Crimson Pro", "Cormorant Garamond", Georgia, serif',
      body: '"Chirp", "Inter var", system-ui, sans-serif',
      mono: '"Source Code Pro", monospace'
    },
    headings: {
      letterSpacing: "tight",
      weight: "semibold"
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "medium",
      lineHeight: "1.1",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    }
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.15,
    gapScale: 1,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "ghost",
    radius: "xl",
    showBorder: !0,
    borderStyle: "subtle",
    accentEdge: "none",
    elevation: 0,
    hoverEffect: "none"
  },
  dataViz: {
    sequential: ["#E0F2FE", "#BAE6FD", "#7DD3FC", "#38BDF8", "#0284C7"],
    categorical: [
      "#0EA5E9",
      "#EF4444",
      "#10B981",
      "#8B5CF6",
      "#F59E0B",
      "#EC4899"
    ],
    diverging: {
      negative: "#EF4444",
      neutral: "#6B7280",
      positive: "#10B981"
    },
    semantic: {
      positive: "#10B981",
      negative: "#EF4444",
      neutral: "#6B7280",
      warning: "#F59E0B"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "bold",
    metricFont: "display",
    showTrendArrows: !1,
    sparklineStyle: "line",
    cardTreatment: "minimal",
    labelCasing: "uppercase",
    labelTracking: "widest"
  },
  accents: {
    primary: "199 89% 48%",
    // Sky Blue (Twitter-inspired)
    secondary: "0 84% 60%",
    // Red
    application: {
      buttons: "filled",
      links: "color-only",
      focus: "ring",
      selection: "subtle"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(199 89% 48%) 0%, hsl(217 91% 60%) 100%)",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "smooth",
    interactionScale: {
      hover: 1.02,
      press: 0.98
    },
    pageTransitions: !1,
    listAnimation: "fade"
  },
  dataAttributes: {
    mode: "light",
    density: "comfortable",
    motion: "smooth",
    style: "editorial"
  },
  dataIdentifiers: {
    pattern: "[{TYPE}:{ID}]"
  },
  componentDefaults: {
    Button: {
      variant: "ghost",
      size: "sm",
      pill: !0,
      pressable: !0
    },
    Card: {
      variant: "ghost",
      padding: "md",
      hoverable: !1
    },
    Badge: {
      style: "soft",
      size: "sm"
    },
    DataTable: {
      density: "comfortable",
      stripedRows: !1,
      showRowBorders: !1
    },
    KpiCard: {
      elevated: !1,
      displayFont: !0
    },
    Input: {
      variant: "filled"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: ["https://twitter.com", "https://instagram.com", "https://facebook.com"]
}, bi = {
  id: "social-messaging-app",
  name: "Messaging App",
  description: "Chat-focused editorial design for messaging applications. Emphasizes conversation bubbles, contact lists, read receipts, and real-time indicators with refined serif typography.",
  category: "social-platform",
  tags: ["messaging", "chat", "conversations", "real-time", "bubbles", "green", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Editorial New", "Libre Baskerville", Georgia, serif',
      heading: '"Editorial New", "Libre Baskerville", Georgia, serif',
      body: '"SF Pro Text", "Inter var", system-ui, sans-serif',
      mono: '"SF Mono", "Menlo", monospace'
    },
    headings: {
      letterSpacing: "tight",
      weight: "semibold"
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "normal",
      lineHeight: "1.15",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    }
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.1,
    gapScale: 1,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "ghost",
    radius: "2xl",
    showBorder: !1,
    borderStyle: "subtle",
    accentEdge: "none",
    elevation: 0,
    hoverEffect: "lift"
  },
  dataViz: {
    sequential: ["#DCFCE7", "#86EFAC", "#4ADE80", "#22C55E", "#16A34A"],
    categorical: [
      "#22C55E",
      "#3B82F6",
      "#F59E0B",
      "#EF4444",
      "#8B5CF6",
      "#EC4899"
    ],
    diverging: {
      negative: "#EF4444",
      neutral: "#6B7280",
      positive: "#22C55E"
    },
    semantic: {
      positive: "#22C55E",
      negative: "#EF4444",
      neutral: "#6B7280",
      warning: "#F59E0B"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "semibold",
    metricFont: "display",
    showTrendArrows: !1,
    sparklineStyle: "line",
    cardTreatment: "minimal",
    labelCasing: "uppercase",
    labelTracking: "widest"
  },
  accents: {
    primary: "142 71% 45%",
    // Green (WhatsApp-inspired)
    secondary: "217 91% 60%",
    // Blue
    application: {
      buttons: "filled",
      links: "color-only",
      focus: "ring",
      selection: "subtle"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(142 71% 45%) 0%, hsl(158 64% 42%) 100%)",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "smooth",
    interactionScale: {
      hover: 1.01,
      press: 0.98
    },
    pageTransitions: !0,
    listAnimation: "slide"
  },
  dataAttributes: {
    mode: "light",
    density: "comfortable",
    motion: "smooth",
    style: "editorial"
  },
  dataIdentifiers: {
    pattern: "[{TYPE}:{ID}]"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "md",
      pill: !0,
      pressable: !0
    },
    Card: {
      variant: "ghost",
      padding: "md",
      hoverable: !0
    },
    Badge: {
      style: "solid",
      size: "sm"
    },
    DataTable: {
      density: "comfortable",
      stripedRows: !1,
      showRowBorders: !1
    },
    KpiCard: {
      elevated: !1,
      displayFont: !0
    },
    Input: {
      variant: "filled"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: ["https://whatsapp.com", "https://telegram.org", "https://apple.com/ios/messages"]
}, Si = {
  id: "social-dating-app",
  name: "Dating App",
  description: "Bold, engaging editorial design for dating applications. Emphasizes profile cards, photo galleries, swipe gestures, and match notifications with refined serif typography.",
  category: "social-platform",
  tags: ["dating", "profiles", "cards", "swipe", "bold", "gradient", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Fraunces", "Bodoni Moda", Georgia, serif',
      heading: '"Fraunces", "Bodoni Moda", Georgia, serif',
      body: '"Open Sans", "Lato", system-ui, sans-serif',
      mono: '"Roboto Mono", monospace'
    },
    headings: {
      letterSpacing: "tight",
      weight: "semibold"
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "semibold",
      lineHeight: "1.05",
      style: "serif"
    },
    scale: {
      displaySize: "6xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "semibold",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    }
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.2,
    gapScale: 1.1,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "elevated",
    radius: "2xl",
    showBorder: !1,
    borderStyle: "subtle",
    accentEdge: "none",
    elevation: 2,
    hoverEffect: "scale"
  },
  dataViz: {
    sequential: ["#FEE2E2", "#FECACA", "#F87171", "#EF4444", "#DC2626"],
    categorical: [
      "#F43F5E",
      "#F59E0B",
      "#10B981",
      "#3B82F6",
      "#8B5CF6",
      "#EC4899"
    ],
    diverging: {
      negative: "#EF4444",
      neutral: "#6B7280",
      positive: "#10B981"
    },
    semantic: {
      positive: "#10B981",
      negative: "#EF4444",
      neutral: "#6B7280",
      warning: "#F59E0B"
    }
  },
  kpiStyling: {
    metricSize: "5xl",
    metricWeight: "bold",
    metricFont: "display",
    showTrendArrows: !1,
    sparklineStyle: "area",
    cardTreatment: "gradient-accent",
    labelCasing: "uppercase",
    labelTracking: "widest"
  },
  accents: {
    primary: "346 77% 60%",
    // Rose/Pink (Tinder-inspired)
    secondary: "38 92% 50%",
    // Yellow (Bumble)
    application: {
      buttons: "filled",
      links: "bold-color",
      focus: "glow",
      selection: "bold"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(346 77% 60%) 0%, hsl(25 95% 53%) 100%)",
      useOnButtons: !0,
      useOnCards: !1,
      useOnText: !0
    }
  },
  motion: {
    style: "playful",
    interactionScale: {
      hover: 1.03,
      press: 0.97
    },
    pageTransitions: !0,
    listAnimation: "stagger"
  },
  dataAttributes: {
    mode: "light",
    density: "comfortable",
    motion: "playful",
    style: "editorial"
  },
  dataIdentifiers: {
    pattern: "[{TYPE}:{ID}]"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "lg",
      pill: !0,
      pressable: !0
    },
    Card: {
      variant: "elevated",
      padding: "lg",
      hoverable: !0
    },
    Badge: {
      style: "solid",
      size: "md"
    },
    DataTable: {
      density: "comfortable",
      stripedRows: !1,
      showRowBorders: !1
    },
    KpiCard: {
      elevated: !0,
      displayFont: !0
    },
    Input: {
      variant: "filled"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: ["https://tinder.com", "https://bumble.com", "https://hinge.co"]
}, vi = {
  id: "social-professional-network",
  name: "Professional Network",
  description: "Business-focused editorial design for professional networking. Emphasizes profiles, connections, job listings, and professional content sharing with refined serif typography.",
  category: "social-platform",
  tags: ["professional", "networking", "business", "careers", "linkedin", "navy", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Merriweather", "Crimson Pro", Georgia, serif',
      heading: '"Merriweather", "Crimson Pro", Georgia, serif',
      body: '"Source Sans 3", "Inter var", system-ui, sans-serif',
      mono: '"Source Code Pro", monospace'
    },
    headings: {
      letterSpacing: "tight",
      weight: "semibold"
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "normal",
      lineHeight: "1.1",
      style: "serif"
    },
    scale: {
      displaySize: "5xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    }
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.15,
    gapScale: 1.1,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "elevated",
    radius: "lg",
    showBorder: !0,
    borderStyle: "subtle",
    accentEdge: "none",
    elevation: 1,
    hoverEffect: "lift"
  },
  dataViz: {
    sequential: ["#E0E7FF", "#A5B4FC", "#6366F1", "#4338CA", "#1E3A8A"],
    categorical: [
      "#0A66C2",
      "#10B981",
      "#F59E0B",
      "#EF4444",
      "#8B5CF6",
      "#EC4899"
    ],
    diverging: {
      negative: "#DC2626",
      neutral: "#6B7280",
      positive: "#059669"
    },
    semantic: {
      positive: "#059669",
      negative: "#DC2626",
      neutral: "#6B7280",
      warning: "#D97706"
    }
  },
  kpiStyling: {
    metricSize: "4xl",
    metricWeight: "semibold",
    metricFont: "display",
    showTrendArrows: !0,
    sparklineStyle: "line",
    cardTreatment: "elevated",
    labelCasing: "uppercase",
    labelTracking: "widest"
  },
  accents: {
    primary: "210 100% 40%",
    // LinkedIn Blue
    secondary: "142 71% 45%",
    // Green
    application: {
      buttons: "filled",
      links: "color-only",
      focus: "ring",
      selection: "subtle"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(210 100% 40%) 0%, hsl(210 100% 30%) 100%)",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "smooth",
    interactionScale: {
      hover: 1.01,
      press: 0.99
    },
    pageTransitions: !0,
    listAnimation: "fade"
  },
  dataAttributes: {
    mode: "light",
    density: "comfortable",
    motion: "smooth",
    style: "editorial"
  },
  dataIdentifiers: {
    pattern: "[{TYPE}:{ID}]"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "md",
      pill: !0,
      pressable: !0
    },
    Card: {
      variant: "elevated",
      padding: "md",
      hoverable: !0
    },
    Badge: {
      style: "soft",
      size: "sm"
    },
    DataTable: {
      density: "comfortable",
      stripedRows: !1,
      showRowBorders: !0
    },
    KpiCard: {
      elevated: !0,
      displayFont: !0
    },
    Input: {
      variant: "default"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: ["https://linkedin.com", "https://angel.co"]
}, wi = {
  id: "social-content-creator",
  name: "Content Creator",
  description: "Creative, expressive editorial design for content creation platforms. Emphasizes video/media uploads, analytics, monetization, and audience engagement with refined serif typography.",
  category: "social-platform",
  tags: ["creator", "content", "video", "analytics", "creative", "red", "editorial", "serif"],
  version: "2.0.0",
  typography: {
    fonts: {
      display: '"Lora", "Cormorant Garamond", Georgia, serif',
      heading: '"Lora", "Cormorant Garamond", Georgia, serif',
      body: '"Roboto", "Inter var", system-ui, sans-serif',
      mono: '"Roboto Mono", monospace'
    },
    headings: {
      letterSpacing: "tight",
      weight: "semibold"
    },
    display: {
      letterSpacing: "-0.02em",
      weight: "medium",
      lineHeight: "1.0",
      style: "serif"
    },
    scale: {
      displaySize: "6xl",
      h1Size: "3xl",
      h2Size: "2xl",
      h3Size: "xl",
      bodySize: "base",
      smallSize: "sm"
    },
    microLabels: {
      letterSpacing: "widest",
      weight: "medium",
      casing: "uppercase",
      size: "xs",
      font: "mono"
    }
  },
  spacing: {
    density: "comfortable",
    paddingScale: 1.15,
    gapScale: 1.1,
    sectionSpacing: "generous"
  },
  cards: {
    defaultVariant: "elevated",
    radius: "lg",
    showBorder: !1,
    borderStyle: "subtle",
    accentEdge: "none",
    elevation: 1,
    hoverEffect: "lift"
  },
  dataViz: {
    sequential: ["#FEE2E2", "#FECACA", "#F87171", "#EF4444", "#DC2626"],
    categorical: [
      "#FF0000",
      "#3B82F6",
      "#10B981",
      "#F59E0B",
      "#8B5CF6",
      "#EC4899"
    ],
    diverging: {
      negative: "#EF4444",
      neutral: "#6B7280",
      positive: "#10B981"
    },
    semantic: {
      positive: "#10B981",
      negative: "#EF4444",
      neutral: "#6B7280",
      warning: "#F59E0B"
    }
  },
  kpiStyling: {
    metricSize: "5xl",
    metricWeight: "bold",
    metricFont: "display",
    showTrendArrows: !0,
    sparklineStyle: "area",
    cardTreatment: "elevated",
    labelCasing: "uppercase",
    labelTracking: "widest"
  },
  accents: {
    primary: "0 100% 50%",
    // YouTube Red
    secondary: "217 91% 60%",
    // Blue
    application: {
      buttons: "filled",
      links: "color-only",
      focus: "ring",
      selection: "subtle"
    },
    gradients: {
      primaryGradient: "linear-gradient(135deg, hsl(0 100% 50%) 0%, hsl(350 90% 45%) 100%)",
      useOnButtons: !1,
      useOnCards: !1,
      useOnText: !1
    }
  },
  motion: {
    style: "smooth",
    interactionScale: {
      hover: 1.02,
      press: 0.98
    },
    pageTransitions: !0,
    listAnimation: "stagger"
  },
  dataAttributes: {
    mode: "light",
    density: "comfortable",
    motion: "smooth",
    style: "editorial"
  },
  dataIdentifiers: {
    pattern: "[{TYPE}:{ID}]"
  },
  componentDefaults: {
    Button: {
      variant: "primary",
      size: "md",
      pill: !0,
      pressable: !0
    },
    Card: {
      variant: "elevated",
      padding: "md",
      hoverable: !0
    },
    Badge: {
      style: "solid",
      size: "sm"
    },
    DataTable: {
      density: "comfortable",
      stripedRows: !1,
      showRowBorders: !0
    },
    KpiCard: {
      elevated: !0,
      displayFont: !0
    },
    Input: {
      variant: "filled"
    },
    Typography: {
      display: !0,
      serifHeadings: !0
    }
  },
  references: ["https://studio.youtube.com", "https://tiktok.com/creators", "https://patreon.com"]
}, Bi = [
  fi,
  hi,
  bi,
  Si,
  vi,
  wi
];
p(Bi);
export {
  ve as agencyCreativePreset,
  Z as amplitudeModernPreset,
  ee as analyticsPlatformPresets,
  Te as apiConsolePreset,
  Di as applyPreset,
  Xe as assessmentToolPreset,
  Oe as bankingProfessionalPreset,
  Ai as baseDefaults,
  U as bloombergInspiredPreset,
  Fe as brandStorytellingPreset,
  B as buttonVariantRule,
  pi as calendarAppPreset,
  v as cardElevationRule,
  qe as clinicalCleanPreset,
  fi as communityForumPreset,
  oi as complianceDashboardPreset,
  wi as contentCreatorPreset,
  Be as conversionFocusedPreset,
  ti as corporateIntranetPreset,
  we as corporateTrustPreset,
  _e as courseCreatorPreset,
  ki as createPresetResolver,
  Ii as createScopedApplier,
  I as createValidationContext,
  fe as crmSystemPresets,
  Ge as cryptoModernPreset,
  L as darkModeProPreset,
  R as dataDensePreset,
  $ as dataStudioPreset,
  Si as datingAppPreset,
  Pi as deepMerge,
  Mi as defaultAccents,
  Oi as defaultCards,
  Ri as defaultComponentDefaults,
  Hi as defaultDataAttributes,
  Gi as defaultDataViz,
  Vi as defaultKpiStyling,
  Li as defaultMotion,
  Wi as defaultSpacing,
  qi as defaultTypography,
  k as defaultValidationRules,
  Me as developerToolsPresets,
  ri as documentManagementPreset,
  de as eCommercePresets,
  D as editorialDataIdentifiersRule,
  C as editorialDisplayTypographyRule,
  be as editorialElegantPreset,
  x as editorialKpiSizeRule,
  E as editorialMicroLabelsRule,
  T as editorialSpacingDensityRule,
  ii as educationPresets,
  re as electronicsTechPreset,
  H as enterpriseCleanPreset,
  ye as enterpriseCrmPreset,
  li as enterprisePresets,
  V as executivePremiumPreset,
  se as fashionForwardPreset,
  We as fintechPresets,
  A as flatUiDetectionRule,
  ue as freshworksFriendlyPreset,
  Ki as getAppliedPresetId,
  Yi as getComponentDefaults,
  Ee as githubInspiredPreset,
  Ie as gitlabOrangePreset,
  j as grafanaDarkPreset,
  ne as groceryFreshPreset,
  Ci as groupResultsByRule,
  Ei as groupResultsBySeverity,
  oe as handmadeArtisanPreset,
  $e as healthcarePresets,
  ai as hrPortalPreset,
  pe as hubspotModernPreset,
  De as ideDarkPreset,
  Ve as insuranceTrustPreset,
  Ni as isPresetApplied,
  ui as kanbanBoardPreset,
  Ze as kidsFriendlyPreset,
  he as landingPageBoldPreset,
  je as learningPlatformPreset,
  X as lookerEnterprisePreset,
  ie as luxuryBoutiquePreset,
  Ce as marketingSitePresets,
  Ne as medicalRecordsPreset,
  bi as messagingAppPreset,
  _ as metabaseFriendlyPreset,
  Y as minimalMonoPreset,
  J as mixpanelStylePreset,
  te as modernMarketplacePreset,
  O as modernMinimalPreset,
  F as motionConsistencyRule,
  q as neonCyberpunkPreset,
  ci as noteTakingPreset,
  W as pastelSoftPreset,
  Ke as patientPortalPreset,
  Le as paymentGatewayPreset,
  Je as pharmacyBrightPreset,
  ge as pipelineFocusedPreset,
  Pe as postmanOrangePreset,
  Ui as presetRegistry,
  Se as productShowcasePreset,
  yi as productivityPresets,
  vi as professionalNetworkPreset,
  si as projectManagementPreset,
  Ji as registerPreset,
  p as registerPresets,
  $i as removePreset,
  ji as resolvePreset,
  ni as resourcePlanningPreset,
  N as saasDashboardPresets,
  ze as saasLandingPreset,
  ce as salesforceStylePreset,
  b as semanticTokenRule,
  ae as shopifyAdminPreset,
  hi as socialFeedPreset,
  Bi as socialPlatformPresets,
  w as spacingConsistencyRule,
  G as startupFreshPreset,
  le as streetwearBoldPreset,
  Ae as stripeDocsPreset,
  Qi as switchPreset,
  Q as tableauClassicPreset,
  di as taskManagerPreset,
  gi as teamCollaborationPreset,
  Ye as telehealthFriendlyPreset,
  ke as terminalGreenPreset,
  mi as timeTrackerPreset,
  Re as tradingPlatformPreset,
  Zi as tryResolvePreset,
  ei as tutoringAppPreset,
  S as typographyHierarchyRule,
  Qe as universityPortalPreset,
  _i as updateCssVariables,
  M as validateElement,
  zi as validateTree,
  xe as vercelStylePreset,
  K as warmEarthyPreset,
  He as wealthManagementPreset,
  Ue as wellnessAppPreset,
  me as zohoPracticalPreset
};
